import { ACCOUNT_ORGANIZATION_CONTEXT_PATH, ACCOUNT_SESSION_PATH, AGENT_REPLY_PLACEMENT_HEADER, CENTER_AGENT_ROUTINE_MANAGEMENT_CONTRACT, CENTER_AGENT_ROUTINE_PRACTICAL_CONTRACT, CLI_RELEASE_PATH, ORGANIZATION_LOGO_MAX_SIZE_BYTES, SPACE_ACCESS_VERSION, SPACE_ACCESS_VERSION_HEADER, SPACE_FILE_MAX_SIZE_BYTES, SPACE_FILE_RAW_UPLOAD_MAX_BYTES, SPACE_FILE_UPLOAD_PART_BYTES, accountOrganizationContextSchema, accountSessionSchema, accountSpaceIndexResponseSchema, addCenterAgentToSpaceBodySchema, addOrganizationDirectoryProfilesToSpaceBodySchema, agentActivityEventSchema, agentActivitySessionInventoryQuerySchema, agentActivitySessionInventoryResponseSchema, agentActivitySnapshotQuerySchema, agentActivitySnapshotResponseSchema, agentActivityStatsQuerySchema, agentActivityStatsResponseSchema, agentExecutionReadinessRouteParamsSchema, agentProfileBindingRouteParamsSchema, agentProfileCreationIntentSchema, agentProfileCreationRequestMutationResponseSchema, agentProfileExecutionModeResponseSchema, agentProfileWorkRecoveryRouteParamsSchema, approveOrganizationDocumentDraftResponseSchema, archiveProjectBodySchema, archiveProjectResponseSchema, betterAuthDeviceAuthorizationClaimResponseSchema, betterAuthDeviceAuthorizationCodeRequestSchema, betterAuthDeviceAuthorizationCodeResponseSchema, betterAuthDeviceAuthorizationDecisionRequestSchema, betterAuthDeviceAuthorizationDecisionResponseSchema, catchupResponseSchema, centerAgentInboxSummaryResponseSchema, centerAgentModelConfigurationResponseSchema, centerAgentOrganizationMemoryPolicyResponseSchema, centerAgentRoutineRouteParamsSchema, centerAgentSessionSelectorSchema, centerAgentSlackWorkspaceConnectBodySchema, centerAgentSlackWorkspaceConnectionResponseSchema, centerAgentSlackWorkspaceDisconnectResponseSchema, centerAgentUpdateProfileBodySchema, centerAgentUpdateProfileResponseSchema, centerAgentWipeMemberMemoryResponseSchema, cliReleaseSchema, computerFileAccessPolicyResponseSchema, computerFileAccessReadRequestSchema, computerFileAccessUpdateRequestSchema, convertDirectMessageToSpaceBodySchema, convertDirectMessageToSpaceResponseSchema, createAgentProfileCreationRequestBodySchema, createAgentProfileCreationRequestResponseSchema, createCenterAgentContextLoadReceiptBodySchema, createCenterAgentContextLoadReceiptResponseSchema, createCenterAgentContextManifestBodySchema, createCenterAgentContextManifestResponseSchema, createCenterAgentRoutineBodySchema, createCenterAgentRoutineResponseSchema, createCenterAgentSessionBodySchema, createOrganizationDocumentBodySchema, createOrganizationDocumentFolderBodySchema, createOrganizationDocumentFolderResponseSchema, createOrganizationDocumentResponseSchema, createOrganizationSkillBodySchema, createOrganizationSkillResponseSchema, createProjectBodySchema, createProjectResponseSchema, createSpaceBodySchema, createSpaceDiagnosticReportBodySchema, createSpaceDiagnosticReportResponseSchema, createSpaceFolderResponseSchema, createSpaceResponseSchema, createSpaceTaskBodySchema, createSpaceThreadBodySchema, createSpaceThreadResponseSchema, currentAgentProfileSessionLookupQuerySchema, currentAgentProfileSessionLookupResponseSchema, currentDeviceTargetResponseSchema, currentLocalAgentInstallationsResponseSchema, currentLocalRuntimeReplyReadinessResponseSchema, decideAgentProfileCreationRequestBodySchema, deleteCenterAgentRoutineBodySchema, deleteCenterAgentRoutineResponseSchema, deleteOrganizationDocumentFolderResponseSchema, deleteOrganizationDocumentResponseSchema, deleteOrganizationSkillBodySchema, deleteOrganizationSkillResponseSchema, deleteSpaceResponseSchema, designateCenterAgentBodySchema, designateCenterAgentResponseSchema, disableAgentProfilePrimaryBindingResponseSchema, discardOrganizationDocumentDraftResponseSchema, discardSpaceComposerUploadResponseSchema, dismissInboxItemResponseSchema, ensureAgentProfilePrimaryBindingBodySchema, ensureAgentProfilePrimaryBindingResponseSchema, executeAgentProfileWorkRecoveryBodySchema, executeAgentProfileWorkRecoveryResponseSchema, executeExecutionRecoveryBodySchema, executeExecutionRecoveryResponseSchema, feedbackReportingPolicyResponseSchema, forgetComputerResponseSchema, forgetCurrentComputerResponseSchema, gatewayErrorCodeSchema, gatewayErrorEnvelopeSchema, getActiveSpaceWakeProgressResponseSchema, getAgentExecutionReadinessBatchBodySchema, getAgentExecutionReadinessBatchResponseSchema, getAgentExecutionReadinessResponseSchema, getAgentProfileControllerChangeEligibilityResponseSchema, getAgentProfileCreationApprovalPreferenceResponseSchema, getAgentProfileCreationDefaultsResponseSchema, getAgentProfilePrimaryBindingResponseSchema, getCenterAgentDesignationResponseSchema, getCenterAgentDirectMessageSpaceProjectionResponseSchema, getCenterAgentMemberResearchStatusResponseSchema, getCenterAgentOperatingStateResponseSchema, getInboxItemResponseSchema, getLocalRuntimeExpectedRoutesQuerySchema, getLocalRuntimeExpectedRoutesResponseSchema, getModelCatalogResponseSchema, getOrganizationDocumentResponseSchema, getOrganizationSkillResponseSchema, getPrepareReadinessQuerySchema, getPrepareReadinessResponseSchema, getSpaceEntryResolutionResponseSchema, getSpaceFileResponseSchema, getSpaceLinkPreviewsResponseSchema, getSpaceMessageDetailsResponseSchema, getSpaceMessageReactionsResponseSchema, getSpaceStatusResponseSchema, getSpaceThreadResponseSchema, getSpaceUpdatesResponseSchema, getSpaceWakeProgressResponseSchema, getSpaceWakeTraceWaterfallResponseSchema, importOrganizationSkillFromGitHubBodySchema, importOrganizationSkillFromGitHubResponseSchema, inboxFeedQuerySchema, inboxFeedResponseSchema, inboxItemRouteParamsSchema, inboxMessageNotificationPreferencesQuerySchema, inboxMessageNotificationPreferencesResponseSchema, inboxNotificationPreferencesResponseSchema, inboxSummaryQuerySchema, inboxSummaryResponseSchema, inspectExecutionRecoveryResponseSchema, larkPlatformActiveRegistrationListResponseSchema, larkPlatformProviderSchema, larkPlatformRegistrationAttemptIdSchema, larkPlatformRegistrationBeginModeSchema, larkPlatformRegistrationResponseSchema, leaveSpaceResponseSchema, listAgentProfileCreationRequestsResponseSchema, listCenterAgentAuditJournalQuerySchema, listCenterAgentAuditJournalResponseSchema, listCenterAgentRoutineRunsQuerySchema, listCenterAgentRoutineRunsResponseSchema, listCenterAgentRoutineTargetSpacesResponseSchema, listCenterAgentRoutinesManagementResponseSchema, listCenterAgentRoutinesResponseSchema, listCenterAgentSessionsQuerySchema, listCenterAgentSessionsResponseSchema, listInboxItemsQuerySchema, listInboxItemsResponseSchema, listOrganizationDocumentsResponseSchema, listOrganizationSkillsResponseSchema, listProfileSpaceHistoryResponseSchema, listProjectsResponseSchema, listSpaceFileRevisionsResponseSchema, listSpaceFilesResponseSchema, listSpaceTasksResponseSchema, listSpaceThreadEventsResponseSchema, listSpaceThreadSignalsQuerySchema, listSpaceThreadSignalsResponseSchema, listSpaceThreadsResponseSchema, localAgentReasoningPreferencesSchema, localFolderPickerRequestSchema, localFolderPickerResultSchema, localProjectControlConnectCandidateRequestSchema, localProjectControlConnectDeclaredPathRequestSchema, localProjectControlConnectOutcomeSchema, localProjectControlDiscoverProjectsRequestSchema, localProjectControlDiscoverProjectsResponseSchema, localProjectControlRemoveConnectionRequestSchema, localProjectControlRemoveConnectionResponseSchema, localProjectControlRemoveMissingConnectionsRequestSchema, localProjectControlRemoveMissingConnectionsResponseSchema, localProjectControlSetDefaultConnectionRequestSchema, localProjectControlSetDefaultConnectionResponseSchema, localRuntimeEnrollmentBodySchema, localRuntimeEnrollmentResponseSchema, localRuntimesQuerySchema, localRuntimesResponseSchema, markAllInboxItemsReadQuerySchema, markAllInboxItemsReadResponseSchema, markCenterAgentInboxReadThroughBodySchema, markCenterAgentInboxReadThroughResponseSchema, markInboxItemReadBodySchema, markInboxItemReadResponseSchema, markSpaceInboxReadThroughBodySchema, markSpaceInboxReadThroughResponseSchema, messageChannelConnectionListResponseSchema, messageChannelIdentityLinkConsumeBodySchema, messageChannelIdentityLinkConsumeResponseSchema, messageChannelIdentityLinkPreviewBodySchema, messageChannelIdentityLinkPreviewResponseSchema, messageChannelSetupRequestBodySchema, messageChannelSetupRequestResponseSchema, mutateInboxFeedBodySchema, mutateInboxFeedResponseSchema, mutateSpaceTaskBodySchema, normalizeListSignalsReadQuerySemantics, normalizeSpacePasswordText, notifyAgentProfileRouteCatalogChangedBodySchema, notifyAgentProfileRouteCatalogChangedResponseSchema, notifyAgentProfilesRouteCatalogChangedBodySchema, openCenterAgentDirectMessageSpaceResponseSchema, openDirectMessageSpaceBodySchema, openDirectMessageSpaceResponseSchema, openMeldRequestContextSchema, organizationComputersResponseSchema, organizationDirectoryResponseSchema, organizationDocumentFolderRouteParamsSchema, organizationDocumentRouteParamsSchema, organizationInformationProtectionPolicyResponseSchema, organizationLogoMimeTypeSchema, organizationLogoResponseSchema, organizationMemberOpenMeldServiceStatusesResponseSchema, organizationSkillRouteParamsSchema, organizationSpaceDirectoryResponseSchema, organizationSpaceDirectoryWithMemberCountsResponseSchema, organizationUsageOverviewResponseSchema, patchProfileSpaceHistoryStatusResponseSchema, patchSpaceMetaBodySchema, patchSpaceMetaResponseSchema, pauseCenterAgentRoutineBodySchema, pauseCenterAgentRoutineResponseSchema, peopleComputerFileAccessUpdateBodySchema, peopleComputerFolderPickerBodySchema, peopleComputerTargetSchema, peopleComputersResponseSchema, pluginActionRequestSchema, pluginActionResponseSchema, postNormalMessageBodySchema, postNormalMessageResponseSchema, postSpaceMembersBodySchema, postSpaceMembersResponseSchema, postSpaceThreadSignalBodySchema, postSpaceThreadSignalResponseSchema, postSpaceWakeStopBodySchema, postSpaceWakeStopResponseSchema, previewOrganizationSkillFromGitHubBodySchema, previewOrganizationSkillFromGitHubResponseSchema, projectRouteParamsSchema, publishSpaceComposerUploadResponseSchema, refreshCurrentLocalAgentCatalogResponseSchema, removeSpaceMembersBodySchema, removeSpaceMembersResponseSchema, requestCurrentOpenMeldToolsUpdateResponseSchema, respondToSpaceAgentInteractionBodySchema, respondToSpaceAgentInteractionResponseSchema, restoreSpaceFileEntryResponseSchema, restoreSpaceFileRevisionResponseSchema, resumeCenterAgentRoutineBodySchema, resumeCenterAgentRoutineResponseSchema, selectCurrentLocalAgentInstallationBodySchema, selectCurrentLocalAgentInstallationResponseSchema, serviceConnectionIncidentReceiptSchema, serviceConnectionIncidentReportSchema, serviceConnectionIncidentsResponseSchema, setAgentProfileCreationApprovalPreferenceBodySchema, setAgentProfileCreationApprovalPreferenceResponseSchema, setAgentProfileCreationDefaultsBodySchema, setAgentProfileCreationDefaultsResponseSchema, setCurrentAgentProfileWorkspaceBodySchema, setCurrentAgentProfileWorkspaceResponseSchema, setCurrentLocalAgentEnabledBodySchema, setCurrentLocalAgentEnabledResponseSchema, setCurrentOpenMeldToolsMaintenanceBodySchema, setCurrentOpenMeldToolsMaintenanceResponseSchema, setLocalRuntimeDisplayNameBodySchema, setOrganizationSkillEnabledBodySchema, setOrganizationSkillEnabledResponseSchema, setOrganizationSkillMaintainersBodySchema, setOrganizationSkillMaintainersResponseSchema, setSpaceAccessModeBodySchema, slackIdentityLinkConsumeBodySchema, slackIdentityLinkConsumeResponseSchema, slackIdentityLinkPreviewBodySchema, slackIdentityLinkPreviewResponseSchema, spaceAccessModeStateSchema, spaceAttachmentMimeTypeSchema, spaceAttachmentSizeBytesSchema, spaceAttachmentUploadQuerySchema, spaceBootstrapResponseSchema, spaceFileMimeTypeSchema, spaceFilePinMutationSchema, spaceFilePinsResponseSchema, spaceFileUpdateSettingsSchema, spaceFileUploadResponseSchema, spaceHistoryNavigationSchema, spaceIdentityDirectorySchema, spaceInboxSummaryResponseSchema, spaceInboxUnreadTargetsResponseSchema, spaceInboxUnreadTargetsRouteParamsSchema, spaceMemberDirectorySchema, spaceMembersSnapshotSchema, spaceMessageMutationBodySchema, spaceMessageMutationResponseSchema, spaceMessagePinMutationSchema, spaceMessagePinsResponseSchema, spaceTaskMutationReceiptSchema, spaceTaskResponseSchema, spaceViewerMembershipResponseSchema, spaceWorkHandoffSchema, stageSpaceComposerUploadResponseSchema, startCenterAgentMemberResearchBodySchema, startCenterAgentMemberResearchResponseSchema, submitAgentActivityEventsBodySchema, submitAgentActivityEventsResponseSchema, submitAgentActivitySessionReconciliationBodySchema, submitAgentActivitySessionReconciliationResponseSchema, submitAgentControllerTaskLifecycleEventsBodySchema, submitAgentControllerTaskLifecycleEventsResponseSchema, submitFeedbackIssueRequestSchema, submitFeedbackIssueResponseSchema, submitRuntimeAgentControllerReportsBodySchema, submitRuntimeAgentControllerReportsResponseSchema, submitRuntimeProviderConversationProofsBodySchema, submitRuntimeProviderConversationProofsResponseSchema, submitRuntimeRegistrationBodySchema, submitRuntimeRegistrationResponseSchema, toCompatibleSpaceAddressingRequestWireValue, toLegacySpaceImageGeometryWireValue, trashSpaceFileEntryResponseSchema, updateAgentProfileDefaultProjectBodySchema, updateAgentProfileDefaultProjectResponseSchema, updateAgentProfileExecutionModeBodySchema, updateAgentProfilePrimaryBindingAgentControllerCollaborationModeBodySchema, updateAgentProfilePrimaryBindingAgentControllerPermissionModeBodySchema, updateAgentProfilePrimaryBindingModelSelectionBodySchema, updateAgentProfilePrimaryBindingOpenCodePermissionBodySchema, updateCenterAgentModelBodySchema, updateCenterAgentModelResponseSchema, updateCenterAgentOperatingStateBodySchema, updateCenterAgentOperatingStateResponseSchema, updateCenterAgentOrganizationMemoryPolicyBodySchema, updateCenterAgentRoutineBodySchema, updateCenterAgentRoutineResponseSchema, updateFeedbackReportingPolicyBodySchema, updateInboxMessageNotificationPreferencesBodySchema, updateInboxNotificationPreferencesBodySchema, updateOrganizationDocumentBodySchema, updateOrganizationDocumentFolderBodySchema, updateOrganizationDocumentFolderResponseSchema, updateOrganizationDocumentResponseSchema, updateOrganizationInformationProtectionPolicyBodySchema, updateOrganizationSkillBodySchema, updateOrganizationSkillResponseSchema, updateProfileResponseSchema, updateProjectBodySchema, updateProjectResponseSchema, updateSpaceFileEntryResponseSchema, uploadSpaceAttachmentResponseSchema, uploadSpaceFileResponseSchema, upsertProfileSpaceHistoryResponseSchema, writeCurrentDeviceObservedMetadataBodySchema, writeCurrentDeviceObservedMetadataResponseSchema } from "@openmeld/schemas";
import { OPENMELD_HEADER_AGENT_CONTROLLER_CONVERSATION_ID, OPENMELD_HEADER_AGENT_CONTROLLER_REF, OPENMELD_HEADER_AUTO_RELAY_DEPTH, OPENMELD_HEADER_CALLER_PRINCIPAL_ID, OPENMELD_HEADER_DISPATCH_CHAIN_ID, OPENMELD_HEADER_FORWARDED_BY, OPENMELD_HEADER_INBOX_ITEM_KIND_VERSION, OPENMELD_HEADER_INBOX_SOURCE_TARGET_VERSION, OPENMELD_HEADER_INBOX_SUMMARY_VERSION, OPENMELD_HEADER_OWNER_NAME, OPENMELD_HEADER_OWNER_USER_ID, OPENMELD_HEADER_PROFILE_HANDLE, OPENMELD_HEADER_PROFILE_ID, OPENMELD_HEADER_PROFILE_KIND, OPENMELD_HEADER_PROFILE_NAME, OPENMELD_HEADER_REQUESTED_ORGANIZATION_ID, OPENMELD_HEADER_REQUESTED_ORGANIZATION_SLUG, OPENMELD_HEADER_REQUEST_ID, OPENMELD_HEADER_SPACE_ADDRESSING_VERSION, OPENMELD_HEADER_SPACE_FILES_ORIGIN_VERSION, OPENMELD_HEADER_SPACE_IMAGE_GEOMETRY_VERSION, OPENMELD_HEADER_SPACE_PASSWORD, OPENMELD_HEADER_VISITED_PROFILE_IDS, OPENMELD_HEADER_VISITED_PROFILE_IDS_HASH, OPENMELD_INBOX_ITEM_KIND_VERSION, OPENMELD_INBOX_SOURCE_TARGET_VERSION, OPENMELD_INBOX_SUMMARY_VERSION, OPENMELD_SPACE_ADDRESSING_VERSION, OPENMELD_SPACE_FILES_ORIGIN_VERSION, OPENMELD_SPACE_IMAGE_GEOMETRY_VERSION, ORGANIZATION_DIRECTORY_AGENT_PROFILE_WORK_RECOVERY_VERSION_QUERY_PARAMETER, ORGANIZATION_DIRECTORY_INCLUDE_MEMBER_LAST_ACTIVE_AT_QUERY_PARAMETER } from "@openmeld/gateway-contract";
import { parseEnvelope } from "@openmeld/protocol";
//#region src/errors.ts
const FALLBACK_GATEWAY_HTTP_ERROR_CODE = "gateway.http_error";
const INVALID_RESPONSE_ERROR_CODE = "gateway.invalid_response";
const GENERIC_NETWORK_ERROR_CODES = ["network.timeout", "network.request_failed"];
const KNOWN_API_CLIENT_ERROR_CODES = /* @__PURE__ */ new Set([
	...gatewayErrorCodeSchema.options,
	FALLBACK_GATEWAY_HTTP_ERROR_CODE,
	INVALID_RESPONSE_ERROR_CODE,
	...GENERIC_NETWORK_ERROR_CODES
]);
var OpenMeldApiClientHttpError = class extends Error {
	code;
	requestId;
	status;
	rawBody;
	upstreamCode;
	constructor(input) {
		super(input.message);
		this.name = "OpenMeldApiClientHttpError";
		this.code = input.code;
		this.requestId = normalizeOptionalText(input.requestId);
		this.status = input.status;
		this.rawBody = input.rawBody;
		this.upstreamCode = normalizeOptionalText(input.upstreamCode);
	}
};
var OpenMeldApiClientInvalidResponseError = class extends Error {
	code = INVALID_RESPONSE_ERROR_CODE;
	operation;
	requestId;
	status;
	rawBody;
	schemaIssueMessage;
	schemaIssuePath;
	upstreamCode = null;
	constructor(input) {
		super(input.message);
		this.name = "OpenMeldApiClientInvalidResponseError";
		this.operation = input.operation;
		this.requestId = normalizeOptionalText(input.requestId);
		this.status = input.status;
		this.rawBody = input.rawBody;
		this.schemaIssueMessage = normalizeOptionalText(input.schemaIssue?.message);
		this.schemaIssuePath = formatSchemaIssuePath(input.schemaIssue);
	}
};
function toStructuredApiClientFailure(error) {
	if (error instanceof OpenMeldApiClientHttpError) return {
		code: error.code,
		message: normalizeFailureMessage(error.message),
		requestId: error.requestId,
		status: error.status,
		upstreamCode: error.upstreamCode
	};
	if (error instanceof OpenMeldApiClientInvalidResponseError) return withInvalidResponseDiagnostics({
		code: error.code,
		message: normalizeFailureMessage(error.message),
		requestId: error.requestId,
		status: error.status,
		upstreamCode: null
	}, {
		schemaIssueMessage: error.schemaIssueMessage,
		schemaIssuePath: error.schemaIssuePath
	});
	return withInvalidResponseDiagnostics({
		code: readGenericErrorCode(error),
		message: normalizeFailureMessage(readFailureMessage(error)),
		requestId: readOptionalObjectTextField(error, "requestId"),
		status: readOptionalObjectStatus(error),
		upstreamCode: readOptionalObjectTextField(error, "upstreamCode")
	}, {
		schemaIssueMessage: readOptionalObjectTextField(error, "schemaIssueMessage"),
		schemaIssuePath: readOptionalObjectTextField(error, "schemaIssuePath")
	});
}
function readApiClientTextResponse(input) {
	return input.response.text().then((raw) => {
		assertApiClientResponseOk({
			response: input.response,
			raw
		});
		return raw;
	});
}
async function readApiClientJsonResponse(input) {
	let raw;
	try {
		raw = await input.response.text();
	} catch (error) {
		const bodyReadError = new Error(toErrorMessage$1(error), { cause: error });
		bodyReadError.code = "network.request_failed";
		bodyReadError.status = input.response.status;
		throw bodyReadError;
	}
	assertApiClientResponseOk({
		response: input.response,
		raw
	});
	const parsed = input.schema.safeParse(parseJsonResponse(raw));
	if (!parsed.success) throw new OpenMeldApiClientInvalidResponseError({
		message: input.invalidMessage,
		operation: input.operation,
		requestId: input.response.headers.get(OPENMELD_HEADER_REQUEST_ID),
		status: input.response.status,
		rawBody: raw,
		schemaIssue: parsed.error?.issues?.[0] ?? null
	});
	return parsed.data;
}
function assertApiClientResponseOk(input) {
	if (input.response.ok) return;
	throw parseApiClientErrorResponse(input);
}
function parseApiClientErrorResponse(input) {
	const parsed = gatewayErrorEnvelopeSchema.safeParse(parseJsonResponse(input.raw));
	const headerRequestId = normalizeOptionalText(input.response.headers.get(OPENMELD_HEADER_REQUEST_ID));
	if (parsed.success) return new OpenMeldApiClientHttpError({
		code: parsed.data.error.code,
		message: parsed.data.error.message,
		requestId: parsed.data.error.requestId || headerRequestId,
		status: input.response.status,
		rawBody: input.raw,
		upstreamCode: parsed.data.error.upstreamCode ?? null
	});
	return new OpenMeldApiClientHttpError({
		code: FALLBACK_GATEWAY_HTTP_ERROR_CODE,
		message: normalizeOptionalText(input.raw) ?? `Gateway request failed with HTTP ${input.response.status}.`,
		requestId: headerRequestId,
		status: input.response.status,
		rawBody: input.raw,
		upstreamCode: null
	});
}
function parseJsonResponse(raw) {
	if (!raw.trim()) return null;
	try {
		return JSON.parse(raw);
	} catch {
		return null;
	}
}
function normalizeOptionalText(value) {
	const normalized = String(value ?? "").trim();
	return normalized.length > 0 ? normalized : null;
}
function toErrorMessage$1(error) {
	if (error instanceof Error) return normalizeOptionalText(error.message) ?? error.name;
	return normalizeOptionalText(error) ?? "request failed";
}
function formatSchemaIssuePath(issue) {
	const path = issue?.path;
	if (!path || path.length === 0) return null;
	return path.map((part) => String(part)).join(".");
}
function withInvalidResponseDiagnostics(failure, diagnostics) {
	if (!(diagnostics.schemaIssueMessage || diagnostics.schemaIssuePath)) return failure;
	return {
		...failure,
		schemaIssueMessage: diagnostics.schemaIssueMessage,
		schemaIssuePath: diagnostics.schemaIssuePath
	};
}
function normalizeFailureMessage(value) {
	return normalizeOptionalText(value) ?? "Unknown error.";
}
function readFailureMessage(value) {
	if (value instanceof Error) return normalizeOptionalText(value.message);
	if (typeof value === "string") return normalizeOptionalText(value);
	if (value && typeof value === "object" && "message" in value) {
		const message = value.message;
		return typeof message === "string" ? normalizeOptionalText(message) : null;
	}
	if (value === null || value === void 0 || typeof value === "object") return null;
	return normalizeOptionalText(value);
}
function readOptionalObjectTextField(value, fieldName) {
	if (!value || typeof value !== "object" || !(fieldName in value)) return null;
	const fieldValue = value[fieldName];
	return typeof fieldValue === "string" ? normalizeOptionalText(fieldValue) : null;
}
function readOptionalObjectStatus(value) {
	if (!value || typeof value !== "object" || !("status" in value)) return null;
	const status = value.status;
	return typeof status === "number" && Number.isInteger(status) ? status : null;
}
function readGenericErrorCode(value) {
	if (!value || typeof value !== "object" || !("code" in value)) return null;
	const normalized = normalizeOptionalText(value.code ?? null);
	if (!(normalized && KNOWN_API_CLIENT_ERROR_CODES.has(normalized))) return null;
	return normalized;
}
//#endregion
//#region src/account-organization-context.ts
async function readAccountOrganizationContext(client) {
	const response = await client.requestResponse({
		url: ACCOUNT_ORGANIZATION_CONTEXT_PATH,
		method: "GET",
		operation: "account.organizationContext.read"
	});
	if (response.status === 401) return null;
	return readApiClientJsonResponse({
		operation: "account.organizationContext.read",
		response,
		schema: accountOrganizationContextSchema,
		invalidMessage: "Invalid account Organization context response."
	});
}
//#endregion
//#region src/account-session.ts
async function readAccountSession(client) {
	const response = await client.requestResponse({
		url: ACCOUNT_SESSION_PATH,
		method: "GET",
		operation: "account.session.read"
	});
	if (response.status === 401) return null;
	return readApiClientJsonResponse({
		operation: "account.session.read",
		response,
		schema: accountSessionSchema,
		invalidMessage: "Invalid account session response."
	});
}
//#endregion
//#region src/base-url.ts
const TRAILING_SLASHES_REGEX = /\/+$/;
const ROOT_PATH_REGEX = /^\/+$/;
function normalizeApiBaseUrl(baseUrl) {
	const url = new URL(baseUrl);
	if (!ROOT_PATH_REGEX.test(url.pathname)) throw new Error("baseUrl must be origin-only (no path prefix)");
	if (url.search || url.hash) throw new Error("baseUrl must be origin-only (no query or hash)");
	url.pathname = "";
	url.search = "";
	url.hash = "";
	return url.toString().replace(TRAILING_SLASHES_REGEX, "");
}
//#endregion
//#region src/profile-space-history/routes.ts
const PROFILE_SPACE_HISTORY_DEFAULT_LIMIT = 20;
function resolveProfileSpaceHistoryGatewayHost(baseUrl) {
	return new URL(normalizeApiBaseUrl(baseUrl)).host.toLowerCase();
}
function buildProfileSpaceHistoryListPath(input) {
	const url = new URL(buildProfileSpaceHistoryBasePath(input.profileId), "https://openmeld.local");
	url.searchParams.set("gatewayHost", input.gatewayHost);
	for (const status of input.statuses ?? ["active"]) url.searchParams.append("status", status);
	if (input.pinned !== void 0) url.searchParams.set("pinned", String(input.pinned));
	url.searchParams.set("limit", String(Math.max(1, input.limit ?? PROFILE_SPACE_HISTORY_DEFAULT_LIMIT)));
	return `${url.pathname}${url.search}`;
}
function buildProfileSpaceHistoryUpsertPath(input) {
	return `${buildProfileSpaceHistoryBasePath(input.profileId)}/${encodeURIComponent(input.spaceId)}`;
}
function buildProfileSpaceHistoryStatusPath(input) {
	return `${buildProfileSpaceHistoryUpsertPath(input)}/status`;
}
function buildProfileSpaceHistoryBasePath(profileId) {
	return `/v1/profiles/${encodeURIComponent(profileId)}/spaces`;
}
//#endregion
//#region src/account-space-index/routes.ts
const ACCOUNT_SPACE_INDEX_DEFAULT_LIMIT = 500;
function resolveAccountSpaceIndexGatewayHost(baseUrl) {
	return resolveProfileSpaceHistoryGatewayHost(baseUrl);
}
function buildAccountSpaceActiveWakeSummaryPath(input) {
	const url = new URL("/v1/account/spaces/active-wake-summary", "https://openmeld.local");
	url.searchParams.set("gatewayHost", input.gatewayHost);
	url.searchParams.set("selectedProfileId", input.selectedProfileId);
	return `${url.pathname}${url.search}`;
}
function buildAccountSpaceIndexPath(input) {
	const url = new URL("/v1/account/spaces", "https://openmeld.local");
	url.searchParams.set("gatewayHost", input.gatewayHost);
	url.searchParams.set("scope", input.scope);
	url.searchParams.set("selectedProfileId", input.selectedProfileId);
	url.searchParams.set("limit", String(Math.max(1, input.limit ?? ACCOUNT_SPACE_INDEX_DEFAULT_LIMIT)));
	if (input.includeRecentlyDeletedItems === true) url.searchParams.set("includeRecentlyDeletedItems", "true");
	if (input.includeDirectMessageProfileIds === true) url.searchParams.set("includeDirectMessageProfileIds", "true");
	if (input.includePurposes === true) url.searchParams.set("includePurposes", "true");
	if (input.includeMemberPreviews === true) url.searchParams.set("includeMemberPreviews", "true");
	if (input.includeMessagePreviews === true) url.searchParams.set("includeMessagePreviews", "true");
	return `${url.pathname}${url.search}`;
}
//#endregion
//#region src/account-space-index/api.ts
const createAccountSpaceIndexApi = (client) => {
	return { listAccountSpaces: async (input) => await client.requestJson({
		url: buildAccountSpaceIndexPath(input),
		operation: "account_space_index.list",
		method: "GET",
		requestContext: input.requestContext,
		timeoutMs: input.timeoutMs,
		schema: accountSpaceIndexResponseSchema,
		invalidMessage: "invalid account space index response"
	}) };
};
//#endregion
//#region src/agent-activity/routes.ts
const AGENT_ACTIVITY_SNAPSHOT_PATH = "/v1/organizations/current/agent-activity";
const AGENT_ACTIVITY_SESSIONS_PATH = "/v1/organizations/current/agent-activity/sessions";
const AGENT_ACTIVITY_STATS_PATH = "/v1/organizations/current/agent-activity/stats";
function buildAgentActivitySnapshotPath(query = {}) {
	const search = new URLSearchParams();
	for (const [key, value] of Object.entries(query)) if (value !== void 0) search.set(key, String(value));
	const suffix = search.toString();
	return suffix ? `${AGENT_ACTIVITY_SNAPSHOT_PATH}?${suffix}` : AGENT_ACTIVITY_SNAPSHOT_PATH;
}
function buildAgentActivitySessionsPath(query = {}) {
	const search = new URLSearchParams();
	for (const [key, value] of Object.entries(query)) if (value !== void 0) search.set(key, String(value));
	const suffix = search.toString();
	return suffix ? `${AGENT_ACTIVITY_SESSIONS_PATH}?${suffix}` : AGENT_ACTIVITY_SESSIONS_PATH;
}
function buildAgentActivityStatsPath(query = {}) {
	const search = new URLSearchParams();
	if (query.projectId !== void 0) search.set("projectId", query.projectId);
	const suffix = search.toString();
	return suffix ? `${AGENT_ACTIVITY_STATS_PATH}?${suffix}` : AGENT_ACTIVITY_STATS_PATH;
}
//#endregion
//#region src/agent-activity/api.ts
const createAgentActivityApi = (client) => ({
	readSessions: async (input = {}) => {
		const query = requireValidInput$7(agentActivitySessionInventoryQuerySchema, {
			...input.cursor === void 0 ? {} : { cursor: input.cursor },
			...input.limit === void 0 ? {} : { limit: input.limit },
			...input.memberUserId === void 0 ? {} : { memberUserId: input.memberUserId },
			...input.nativeSessionId === void 0 ? {} : { nativeSessionId: input.nativeSessionId },
			...input.origin === void 0 ? {} : { origin: input.origin },
			...input.projectId === void 0 ? {} : { projectId: input.projectId },
			...input.provider === void 0 ? {} : { provider: input.provider },
			...input.query === void 0 ? {} : { query: input.query },
			...input.status === void 0 ? {} : { status: input.status }
		}, "Agent Activity Session Inventory request is invalid.");
		return await client.requestJson({
			...requestOptions$9(input),
			invalidMessage: "invalid Agent Activity Session Inventory response",
			method: "GET",
			operation: "agent_activity.sessions.read",
			schema: agentActivitySessionInventoryResponseSchema,
			url: buildAgentActivitySessionsPath(query)
		});
	},
	readSnapshot: async (input = {}) => {
		const query = requireValidInput$7(agentActivitySnapshotQuerySchema, {
			...input.includeProviderMetadata === true ? { includeProviderMetadata: true } : {},
			...input.memberUserId === void 0 ? {} : { memberUserId: input.memberUserId },
			...input.projectId === void 0 ? {} : { projectId: input.projectId },
			...input.provider === void 0 ? {} : { provider: input.provider },
			...input.status === void 0 ? {} : { status: input.status }
		}, "Agent Activity snapshot request is invalid.");
		return await client.requestJson({
			...requestOptions$9(input),
			invalidMessage: "invalid Agent Activity snapshot response",
			method: "GET",
			operation: "agent_activity.snapshot.read",
			schema: agentActivitySnapshotResponseSchema,
			url: buildAgentActivitySnapshotPath(query)
		});
	},
	readStats: async (input = {}) => {
		const query = requireValidInput$7(agentActivityStatsQuerySchema, { ...input.projectId === void 0 ? {} : { projectId: input.projectId } }, "Agent Activity stats request is invalid.");
		return await client.requestJson({
			...requestOptions$9(input),
			invalidMessage: "invalid Agent Activity stats response",
			method: "GET",
			operation: "agent_activity.stats.read",
			schema: agentActivityStatsResponseSchema,
			url: buildAgentActivityStatsPath(query)
		});
	}
});
function requestOptions$9(input) {
	return {
		...input.requestContext === void 0 ? {} : { requestContext: input.requestContext },
		...input.signal === void 0 ? {} : { signal: input.signal },
		...input.timeoutMs === void 0 ? {} : { timeoutMs: input.timeoutMs }
	};
}
function requireValidInput$7(schema, value, message) {
	const parsed = schema.safeParse(value);
	if (!parsed.success) throw new Error(`${message} ${parsed.error.issues[0]?.message ?? "Invalid input."}`);
	return parsed.data;
}
//#endregion
//#region src/agent-profile-binding/routes.ts
function buildAgentProfilePrimaryBindingRoute(agentProfileId) {
	return `/v1/agent-profiles/${encodeURIComponent(agentProfileId)}/primary-binding`;
}
function buildCurrentAgentProfileSessionRoute(input) {
	return `/v1/agent-profiles/current-session?${new URLSearchParams({
		agentControllerConversationId: input.agentControllerConversationId,
		agentControllerRef: input.agentControllerRef
	}).toString()}`;
}
function buildAgentProfileControllerChangeEligibilityRoute(agentProfileId) {
	return `/v1/agent-profiles/${encodeURIComponent(agentProfileId)}/controller-change-eligibility`;
}
function buildAgentProfilePrimaryBindingModelSelectionRoute(agentProfileId) {
	return `${buildAgentProfilePrimaryBindingRoute(agentProfileId)}/model-selection`;
}
function buildAgentProfilePrimaryBindingAgentControllerPermissionModeRoute(agentProfileId) {
	return `${buildAgentProfilePrimaryBindingRoute(agentProfileId)}/agent-controller-permission-mode`;
}
function buildAgentProfilePrimaryBindingAgentControllerCollaborationModeRoute(agentProfileId) {
	return `${buildAgentProfilePrimaryBindingRoute(agentProfileId)}/agent-controller-collaboration-mode`;
}
function buildAgentProfilePrimaryBindingOpenCodePermissionRoute(agentProfileId) {
	return `${buildAgentProfilePrimaryBindingRoute(agentProfileId)}/opencode-permission`;
}
function buildAgentProfileRouteCatalogSyncRoute(agentProfileId) {
	return `/v1/agent-profiles/${encodeURIComponent(agentProfileId)}/route-catalog-sync`;
}
function buildAgentProfilesRouteCatalogSyncRoute() {
	return "/v1/agent-profiles/route-catalog-sync";
}
function buildAgentExecutionReadinessRoute(agentProfileId) {
	return `/v1/agent-profiles/${encodeURIComponent(agentProfileId)}/execution-readiness`;
}
function buildAgentExecutionReadinessBatchRoute() {
	return "/v1/agent-profiles/execution-readiness/batch";
}
//#endregion
//#region src/agent-profile-binding/api.ts
const getAgentExecutionReadinessInputSchema = agentExecutionReadinessRouteParamsSchema.extend({ requestContext: openMeldRequestContextSchema.optional() });
const getCurrentAgentProfileSessionInputSchema = currentAgentProfileSessionLookupQuerySchema.extend({ requestContext: openMeldRequestContextSchema.optional() });
function requireValidCurrentAgentProfileSessionInput(input) {
	const parsed = getCurrentAgentProfileSessionInputSchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid current Agent Profile Session lookup.");
	return parsed.data;
}
const getAgentExecutionReadinessBatchInputSchema = getAgentExecutionReadinessBatchBodySchema.extend({ requestContext: openMeldRequestContextSchema.optional() });
const ensureAgentProfilePrimaryBindingInputSchema = agentProfileBindingRouteParamsSchema.merge(ensureAgentProfilePrimaryBindingBodySchema).extend({ requestContext: openMeldRequestContextSchema.optional() });
const notifyAgentProfileRouteCatalogChangedInputSchema = agentProfileBindingRouteParamsSchema.merge(notifyAgentProfileRouteCatalogChangedBodySchema).extend({ requestContext: openMeldRequestContextSchema.optional() });
const notifyAgentProfilesRouteCatalogChangedInputSchema = notifyAgentProfilesRouteCatalogChangedBodySchema.extend({ requestContext: openMeldRequestContextSchema.optional() });
const updateAgentProfilePrimaryBindingModelSelectionInputSchema = agentProfileBindingRouteParamsSchema.merge(updateAgentProfilePrimaryBindingModelSelectionBodySchema).extend({ requestContext: openMeldRequestContextSchema.optional() });
const updateAgentProfilePrimaryBindingAgentControllerPermissionModeInputSchema = agentProfileBindingRouteParamsSchema.merge(updateAgentProfilePrimaryBindingAgentControllerPermissionModeBodySchema).extend({ requestContext: openMeldRequestContextSchema.optional() });
const updateAgentProfilePrimaryBindingAgentControllerCollaborationModeInputSchema = agentProfileBindingRouteParamsSchema.merge(updateAgentProfilePrimaryBindingAgentControllerCollaborationModeBodySchema).extend({ requestContext: openMeldRequestContextSchema.optional() });
const updateAgentProfilePrimaryBindingOpenCodePermissionInputSchema = agentProfileBindingRouteParamsSchema.merge(updateAgentProfilePrimaryBindingOpenCodePermissionBodySchema).extend({ requestContext: openMeldRequestContextSchema.optional() });
function requireValidBindingCommandBody(input) {
	const parsed = ensureAgentProfilePrimaryBindingInputSchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Profile Binding payload.");
	const { agentProfileId: _agentProfileId, requestContext: _requestContext, ...body } = parsed.data;
	return body;
}
function requireValidBindingRouteInput(input) {
	const parsed = agentProfileBindingRouteParamsSchema.extend({ requestContext: openMeldRequestContextSchema.optional() }).safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Profile Binding route.");
	return parsed.data;
}
function requireValidRouteCatalogChangedBody(input) {
	const parsed = notifyAgentProfileRouteCatalogChangedInputSchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Profile route catalog notification payload.");
	const { agentProfileId: _agentProfileId, requestContext: _requestContext, ...body } = parsed.data;
	return body;
}
function requireValidRouteCatalogChangedBatchBody(input) {
	const parsed = notifyAgentProfilesRouteCatalogChangedInputSchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Profile route catalog notification payload.");
	const { requestContext: _requestContext, ...body } = parsed.data;
	return body;
}
function requireValidModelSelectionPatchBody(input) {
	const parsed = updateAgentProfilePrimaryBindingModelSelectionInputSchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Profile Binding model selection payload.");
	const { agentProfileId: _agentProfileId, requestContext: _requestContext, ...body } = parsed.data;
	return body;
}
function requireValidAgentControllerPermissionModePatchBody(input) {
	const parsed = updateAgentProfilePrimaryBindingAgentControllerPermissionModeInputSchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Profile Binding Agent Controller Permission Mode payload.");
	const { agentProfileId: _agentProfileId, requestContext: _requestContext, ...body } = parsed.data;
	return body;
}
function requireValidAgentControllerCollaborationModePatchBody(input) {
	const parsed = updateAgentProfilePrimaryBindingAgentControllerCollaborationModeInputSchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Profile Binding Agent Controller Collaboration Mode payload.");
	const { agentProfileId: _agentProfileId, requestContext: _requestContext, ...body } = parsed.data;
	return body;
}
function requireValidOpenCodePermissionPatchBody(input) {
	const parsed = updateAgentProfilePrimaryBindingOpenCodePermissionInputSchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Profile Binding OpenCode permissions payload.");
	const { agentProfileId: _agentProfileId, requestContext: _requestContext, ...body } = parsed.data;
	return body;
}
function requireValidExecutionReadinessInput(input) {
	const parsed = getAgentExecutionReadinessInputSchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Execution Readiness request.");
	return parsed.data;
}
function requireValidExecutionReadinessBatchInput(input) {
	const parsed = getAgentExecutionReadinessBatchInputSchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Execution Readiness batch request.");
	return parsed.data;
}
const createAgentProfileBindingApi = (client) => {
	return {
		getControllerChangeEligibility: async (input) => await client.requestJson({
			invalidMessage: "Invalid Agent Profile Controller change eligibility response.",
			method: "GET",
			operation: "agent_profile_binding.controller_change_eligibility.read",
			requestContext: input.requestContext,
			schema: getAgentProfileControllerChangeEligibilityResponseSchema,
			url: buildAgentProfileControllerChangeEligibilityRoute(input.agentProfileId)
		}),
		getExecutionReadiness: async (input) => {
			const request = requireValidExecutionReadinessInput(input);
			return await client.requestJson({
				invalidMessage: "Invalid Agent Execution Readiness response.",
				method: "GET",
				operation: "agent_execution_readiness.read",
				requestContext: request.requestContext,
				schema: getAgentExecutionReadinessResponseSchema,
				url: buildAgentExecutionReadinessRoute(request.agentProfileId)
			});
		},
		getExecutionReadinessBatch: async (input) => {
			const { signal, ...body } = input;
			const request = requireValidExecutionReadinessBatchInput(body);
			return await client.requestJson({
				body: JSON.stringify({
					agentProfileIds: request.agentProfileIds,
					...request.targetRuntime === void 0 ? {} : { targetRuntime: request.targetRuntime }
				}),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Agent Execution Readiness batch response.",
				method: "POST",
				operation: "agent_execution_readiness.batch_read",
				signal,
				requestContext: request.requestContext,
				schema: getAgentExecutionReadinessBatchResponseSchema,
				url: buildAgentExecutionReadinessBatchRoute()
			});
		},
		getPrimaryBinding: async (input) => await client.requestJson({
			invalidMessage: "Invalid Agent Profile Binding response.",
			method: "GET",
			operation: "agent_profile_binding.primary.read",
			requestContext: input.requestContext,
			schema: getAgentProfilePrimaryBindingResponseSchema,
			url: buildAgentProfilePrimaryBindingRoute(input.agentProfileId)
		}),
		getCurrentSession: async (input) => {
			const request = requireValidCurrentAgentProfileSessionInput(input);
			return await client.requestJson({
				invalidMessage: "Invalid current Agent Profile Session response.",
				method: "GET",
				operation: "agent_profile_binding.current_session.read",
				requestContext: request.requestContext,
				schema: currentAgentProfileSessionLookupResponseSchema,
				url: buildCurrentAgentProfileSessionRoute(request)
			});
		},
		ensurePrimaryBinding: async (input) => {
			const body = requireValidBindingCommandBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Agent Profile Binding command response.",
				method: "PUT",
				operation: "agent_profile_binding.primary.ensure",
				requestContext: input.requestContext,
				schema: ensureAgentProfilePrimaryBindingResponseSchema,
				url: buildAgentProfilePrimaryBindingRoute(input.agentProfileId)
			});
		},
		disablePrimaryBinding: async (input) => {
			const request = requireValidBindingRouteInput(input);
			return await client.requestJson({
				invalidMessage: "Invalid Agent Profile Binding disable response.",
				method: "DELETE",
				operation: "agent_profile_binding.primary.disable",
				requestContext: request.requestContext,
				schema: disableAgentProfilePrimaryBindingResponseSchema,
				url: buildAgentProfilePrimaryBindingRoute(request.agentProfileId)
			});
		},
		notifyRouteCatalogChanged: async (input) => {
			const body = requireValidRouteCatalogChangedBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Agent Profile route catalog notification response.",
				method: "POST",
				operation: "agent_profile_binding.route_catalog_sync",
				requestContext: input.requestContext,
				schema: notifyAgentProfileRouteCatalogChangedResponseSchema,
				url: buildAgentProfileRouteCatalogSyncRoute(input.agentProfileId)
			});
		},
		notifyRouteCatalogChangedBatch: async (input) => {
			const body = requireValidRouteCatalogChangedBatchBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Agent Profile route catalog notification response.",
				method: "POST",
				operation: "agent_profile_binding.route_catalog_sync.batch",
				requestContext: input.requestContext,
				schema: notifyAgentProfileRouteCatalogChangedResponseSchema,
				url: buildAgentProfilesRouteCatalogSyncRoute()
			});
		},
		updatePrimaryBindingModelSelection: async (input) => {
			const body = requireValidModelSelectionPatchBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Agent Profile Binding model selection response.",
				method: "PATCH",
				operation: "agent_profile_binding.primary.model_selection.update",
				requestContext: input.requestContext,
				schema: ensureAgentProfilePrimaryBindingResponseSchema,
				url: buildAgentProfilePrimaryBindingModelSelectionRoute(input.agentProfileId)
			});
		},
		updatePrimaryBindingAgentControllerPermissionMode: async (input) => {
			const body = requireValidAgentControllerPermissionModePatchBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Agent Profile Binding Agent Controller Permission Mode response.",
				method: "PATCH",
				operation: "agent_profile_binding.primary.agent_controller_permission_mode.update",
				requestContext: input.requestContext,
				schema: ensureAgentProfilePrimaryBindingResponseSchema,
				url: buildAgentProfilePrimaryBindingAgentControllerPermissionModeRoute(input.agentProfileId)
			});
		},
		updatePrimaryBindingAgentControllerCollaborationMode: async (input) => {
			const body = requireValidAgentControllerCollaborationModePatchBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Agent Profile Binding Agent Controller Collaboration Mode response.",
				method: "PATCH",
				operation: "agent_profile_binding.primary.agent_controller_collaboration_mode.update",
				requestContext: input.requestContext,
				schema: ensureAgentProfilePrimaryBindingResponseSchema,
				url: buildAgentProfilePrimaryBindingAgentControllerCollaborationModeRoute(input.agentProfileId)
			});
		},
		updatePrimaryBindingOpenCodePermission: async (input) => {
			const body = requireValidOpenCodePermissionPatchBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Agent Profile Binding OpenCode permissions response.",
				method: "PATCH",
				operation: "agent_profile_binding.primary.opencode_permission.update",
				requestContext: input.requestContext,
				schema: ensureAgentProfilePrimaryBindingResponseSchema,
				url: buildAgentProfilePrimaryBindingOpenCodePermissionRoute(input.agentProfileId)
			});
		}
	};
};
//#endregion
//#region src/agent-profile-execution-mode.ts
function createAgentProfileExecutionModeApi(client) {
	return { readOrUpdate(input) {
		const body = input.mode === void 0 ? void 0 : updateAgentProfileExecutionModeBodySchema.parse({ mode: input.mode });
		return client.requestJson({
			url: `/v1/agent-profiles/${encodeURIComponent(input.agentProfileId)}/execution-mode`,
			method: body ? "PATCH" : "GET",
			...body ? {
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" }
			} : {},
			schema: agentProfileExecutionModeResponseSchema,
			requestContext: input.requestContext,
			operation: "agent_profile.execution_mode",
			invalidMessage: "Invalid Agent Profile execution mode response."
		});
	} };
}
//#endregion
//#region src/agent-profile-work-recovery/routes.ts
function buildAgentProfileWorkRecoveryRoute(agentProfileId) {
	return `/v1/agent-profiles/${encodeURIComponent(agentProfileId)}/work-recovery`;
}
//#endregion
//#region src/agent-profile-work-recovery/api.ts
const executeAgentProfileWorkRecoveryInputSchema = agentProfileWorkRecoveryRouteParamsSchema.extend({ requestContext: openMeldRequestContextSchema.optional() }).and(executeAgentProfileWorkRecoveryBodySchema);
const createAgentProfileWorkRecoveryApi = (client) => ({ execute: async (input) => {
	const parsed = executeAgentProfileWorkRecoveryInputSchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Profile work recovery request.");
	return await client.requestJson({
		body: JSON.stringify(parsed.data.action === "skip_interrupted_work" ? {
			action: parsed.data.action,
			expectedInterruptedTargetWakeLifecycleId: parsed.data.expectedInterruptedTargetWakeLifecycleId
		} : { action: parsed.data.action }),
		headers: { "content-type": "application/json" },
		invalidMessage: "Invalid Agent Profile work recovery response.",
		method: "POST",
		operation: "agent_profile_work_recovery.execute",
		requestContext: parsed.data.requestContext,
		schema: executeAgentProfileWorkRecoveryResponseSchema,
		url: buildAgentProfileWorkRecoveryRoute(parsed.data.agentProfileId)
	});
} });
//#endregion
//#region src/center-agent/routes.ts
function buildCenterAgentDesignationPath() {
	return "/v1/organizations/current/center-agent/designation";
}
function buildCenterAgentModelPath() {
	return "/v1/organizations/current/center-agent/model";
}
function buildCenterAgentOperatingStatePath() {
	return "/v1/organizations/current/center-agent/operating-state";
}
function buildCenterAgentProfilePath() {
	return "/v1/organizations/current/center-agent/profile";
}
function buildCenterAgentAuditJournalPath() {
	return "/v1/organizations/current/center-agent/audit-journal";
}
function buildCenterAgentDirectMessageSpacePath() {
	return "/v1/organizations/current/center-agent/dm-space";
}
function buildCenterAgentSessionsPath() {
	return "/v1/organizations/current/center-agent/sessions";
}
function buildCenterAgentSessionPath(spaceId) {
	return `${buildCenterAgentSessionsPath()}/${encodeURIComponent(spaceId)}`;
}
function buildCenterAgentContextManifestPath() {
	return "/v1/organizations/current/center-agent/context-manifests";
}
function buildCenterAgentContextLoadReceiptPath(manifestId) {
	return `${buildCenterAgentContextManifestPath()}/${encodeURIComponent(manifestId)}/load-receipt`;
}
function buildCenterAgentSlackWorkspaceConnectionPath() {
	return "/v1/organizations/current/center-agent/slack-connection";
}
function buildSlackIdentityLinkPreviewPath() {
	return "/v1/slack/identity-link/preview";
}
function buildSlackIdentityLinkConsumePath() {
	return "/v1/slack/identity-link/consume";
}
//#endregion
//#region src/center-agent/api.ts
const createCenterAgentApi = (client) => ({
	getDesignation: async (input = {}) => await client.requestJson({
		url: buildCenterAgentDesignationPath(),
		operation: "center_agent.designation.read",
		method: "GET",
		requestContext: validateRequestInput$1(input).requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: getCenterAgentDesignationResponseSchema,
		invalidMessage: "Invalid Center Agent designation response."
	}),
	designate: async (input) => {
		const request = validateDesignationInput(input);
		return await client.requestJson({
			url: buildCenterAgentDesignationPath(),
			operation: "center_agent.designation.write",
			method: "PUT",
			requestContext: request.requestContext,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify({
				...request.agentProfileId === void 0 ? {} : { agentProfileId: request.agentProfileId },
				...request.runtime === void 0 ? {} : { runtime: request.runtime }
			}),
			schema: designateCenterAgentResponseSchema,
			invalidMessage: "Invalid Center Agent designation write response."
		});
	},
	getModel: async (input = {}) => await client.requestJson({
		url: buildCenterAgentModelPath(),
		operation: "center_agent.model.read",
		method: "GET",
		requestContext: validateRequestInput$1(input).requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: centerAgentModelConfigurationResponseSchema,
		invalidMessage: "Invalid Center Agent model response."
	}),
	updateModel: async (input) => {
		const request = validateModelInput(input);
		return await client.requestJson({
			url: buildCenterAgentModelPath(),
			operation: "center_agent.model.update",
			method: "PUT",
			requestContext: request.requestContext,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify({
				expectedConfigurationRevision: request.expectedConfigurationRevision,
				preference: request.preference
			}),
			schema: updateCenterAgentModelResponseSchema,
			invalidMessage: "Invalid Center Agent model update response."
		});
	},
	getOperatingState: async (input = {}) => await client.requestJson({
		url: buildCenterAgentOperatingStatePath(),
		operation: "center_agent.operating_state.read",
		method: "GET",
		requestContext: validateRequestInput$1(input).requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: getCenterAgentOperatingStateResponseSchema,
		invalidMessage: "Invalid Center Agent operating state response."
	}),
	updateOperatingState: async (input) => {
		const request = validateOperatingStateInput(input);
		return await client.requestJson({
			url: buildCenterAgentOperatingStatePath(),
			operation: "center_agent.operating_state.update",
			method: "PUT",
			requestContext: request.requestContext,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify({ operatingState: request.operatingState }),
			schema: updateCenterAgentOperatingStateResponseSchema,
			invalidMessage: "Invalid Center Agent operating state update response."
		});
	},
	connectSlackWorkspace: async (input) => {
		const request = validateSlackWorkspaceConnectInput(input);
		return await client.requestJson({
			url: buildCenterAgentSlackWorkspaceConnectionPath(),
			operation: "center_agent.slack_workspace.connect",
			method: "POST",
			requestContext: request.requestContext,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify({ slackTeamId: request.slackTeamId }),
			schema: centerAgentSlackWorkspaceConnectionResponseSchema,
			invalidMessage: "Invalid Center Agent Slack connection response."
		});
	},
	disconnectSlackWorkspace: async (input = {}) => await client.requestJson({
		url: buildCenterAgentSlackWorkspaceConnectionPath(),
		operation: "center_agent.slack_workspace.disconnect",
		method: "DELETE",
		requestContext: validateRequestInput$1(input).requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: centerAgentSlackWorkspaceDisconnectResponseSchema,
		invalidMessage: "Invalid Center Agent Slack disconnect response."
	}),
	previewSlackIdentityLink: async (input) => {
		const request = validateSlackIdentityLinkPreviewInput(input);
		return await client.requestJson({
			url: buildSlackIdentityLinkPreviewPath(),
			operation: "center_agent.slack_identity_link.preview",
			method: "POST",
			requestContext: request.requestContext,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify({ token: request.token }),
			schema: slackIdentityLinkPreviewResponseSchema,
			invalidMessage: "Invalid Slack identity link preview response."
		});
	},
	consumeSlackIdentityLink: async (input) => {
		const request = validateSlackIdentityLinkConsumeInput(input);
		return await client.requestJson({
			url: buildSlackIdentityLinkConsumePath(),
			operation: "center_agent.slack_identity_link.consume",
			method: "POST",
			requestContext: request.requestContext,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify({
				includeReturnTarget: request.includeReturnTarget,
				token: request.token
			}),
			schema: slackIdentityLinkConsumeResponseSchema,
			invalidMessage: "Invalid Slack identity link consume response."
		});
	},
	updateProfile: async (input) => {
		const request = validateUpdateProfileInput(input);
		return await client.requestJson({
			url: buildCenterAgentProfilePath(),
			operation: "center_agent.profile.update",
			method: "PATCH",
			requestContext: request.requestContext,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify({ profileName: request.profileName }),
			schema: centerAgentUpdateProfileResponseSchema,
			invalidMessage: "Invalid Center Agent profile update response."
		});
	},
	listAuditJournal: async (input = {}) => {
		const request = validateAuditJournalInput(input);
		return await client.requestJson({
			url: buildAuditJournalUrl(request),
			operation: "center_agent.audit_journal.list",
			method: "GET",
			requestContext: request.requestContext,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			schema: listCenterAgentAuditJournalResponseSchema,
			invalidMessage: "Invalid Center Agent audit journal response."
		});
	},
	createContextManifest: async (input) => {
		const request = validateContextManifestInput(input);
		return await client.requestJson({
			body: JSON.stringify({
				...request.spaceId === void 0 ? {} : { spaceId: request.spaceId },
				...request.cursor === void 0 ? {} : { cursor: request.cursor },
				limit: request.limit,
				maxContextTokens: request.maxContextTokens,
				source: request.source,
				view: request.view
			}),
			headers: { "content-type": "application/json" },
			invalidMessage: "Invalid Center Agent context manifest response.",
			method: "POST",
			operation: "center_agent.context_manifest.create",
			requestContext: request.requestContext,
			schema: createCenterAgentContextManifestResponseSchema,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			url: buildCenterAgentContextManifestPath()
		});
	},
	createContextLoadReceipt: async (input) => {
		const request = validateContextLoadReceiptInput(input);
		return await client.requestJson({
			body: JSON.stringify({
				selection: request.selection,
				source: request.source
			}),
			headers: { "content-type": "application/json" },
			invalidMessage: "Invalid Center Agent Context Load Receipt response.",
			method: "POST",
			operation: "center_agent.context_load_receipt.create",
			requestContext: request.requestContext,
			schema: createCenterAgentContextLoadReceiptResponseSchema,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			url: buildCenterAgentContextLoadReceiptPath(request.manifestId)
		});
	},
	createSession: async (input) => {
		const body = createCenterAgentSessionBodySchema.safeParse({ creationId: input.creationId });
		if (!body.success) throw new Error("Provide a valid session creation ID.");
		return await client.requestJson({
			url: buildCenterAgentSessionsPath(),
			operation: "center_agent.session.create",
			method: "POST",
			headers: { "content-type": "application/json" },
			body: JSON.stringify(body.data),
			requestContext: validateRequestInput$1(input).requestContext,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			schema: openCenterAgentDirectMessageSpaceResponseSchema,
			invalidMessage: "Invalid Center Agent session response."
		});
	},
	listSessions: async (input = {}) => {
		const parsed = listCenterAgentSessionsQuerySchema.safeParse({
			...input.cursor === void 0 ? {} : { cursor: input.cursor },
			...input.limit === void 0 ? {} : { limit: input.limit }
		});
		if (!parsed.success) throw new Error("Provide a valid chat-list cursor and limit.");
		const query = new URLSearchParams({ limit: String(parsed.data.limit) });
		if (parsed.data.cursor !== void 0) query.set("cursor", parsed.data.cursor);
		return await client.requestJson({
			url: `${buildCenterAgentSessionsPath()}?${query.toString()}`,
			operation: "center_agent.session.list",
			method: "GET",
			requestContext: validateRequestInput$1(input).requestContext,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			schema: listCenterAgentSessionsResponseSchema,
			invalidMessage: "Invalid Center Agent chat list."
		});
	},
	getSession: async (input) => {
		const selector = centerAgentSessionSelectorSchema.safeParse({ spaceId: input.spaceId });
		if (!selector.success) throw new Error("Provide a valid session ID.");
		return await client.requestJson({
			url: buildCenterAgentSessionPath(selector.data.spaceId),
			operation: "center_agent.session.read",
			method: "GET",
			requestContext: validateRequestInput$1(input).requestContext,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			schema: getCenterAgentDirectMessageSpaceProjectionResponseSchema,
			invalidMessage: "Invalid Center Agent session response."
		});
	},
	openDirectMessageSpace: async (input = {}) => await client.requestJson({
		url: buildCenterAgentDirectMessageSpacePath(),
		operation: "center_agent.dm_space.open",
		method: "POST",
		requestContext: validateRequestInput$1(input).requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: openCenterAgentDirectMessageSpaceResponseSchema,
		invalidMessage: "Invalid Center Agent DM Space response."
	}),
	getDirectMessageSpaceProjection: async (input = {}) => await client.requestJson({
		url: buildCenterAgentDirectMessageSpacePath(),
		operation: "center_agent.dm_space.projection.read",
		method: "GET",
		requestContext: validateRequestInput$1(input).requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: getCenterAgentDirectMessageSpaceProjectionResponseSchema,
		invalidMessage: "Invalid Center Agent DM Space projection response."
	})
});
function validateRequestInput$1(input) {
	if (!openMeldRequestContextSchema.optional().safeParse(input.requestContext).success) throw new Error("Invalid Center Agent request context.");
	return input;
}
function validateContextManifestInput(input) {
	const parsed = createCenterAgentContextManifestBodySchema.safeParse({
		...input.spaceId === void 0 ? {} : { spaceId: input.spaceId },
		...input.cursor === void 0 ? {} : { cursor: input.cursor },
		...input.limit === void 0 ? {} : { limit: input.limit },
		...input.maxContextTokens === void 0 ? {} : { maxContextTokens: input.maxContextTokens },
		source: input.source,
		...input.view === void 0 ? {} : { view: input.view }
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Center Agent context manifest request.");
	validateRequestInput$1(input);
	return {
		...input,
		...parsed.data
	};
}
function validateContextLoadReceiptInput(input) {
	const parsed = createCenterAgentContextLoadReceiptBodySchema.safeParse({
		selection: input.selection,
		source: input.source
	});
	const manifestId = input.manifestId.trim();
	if (!(parsed.success && manifestId)) throw new Error("Invalid Center Agent Context Load Receipt request.");
	validateRequestInput$1(input);
	return {
		...input,
		...parsed.data,
		manifestId
	};
}
function validateDesignationInput(input) {
	const parsed = designateCenterAgentBodySchema.safeParse({
		agentProfileId: input.agentProfileId,
		...input.runtime === void 0 ? {} : { runtime: input.runtime }
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Center Agent designation.");
	validateRequestInput$1(input);
	return input;
}
function validateOperatingStateInput(input) {
	const parsed = updateCenterAgentOperatingStateBodySchema.safeParse({ operatingState: input.operatingState });
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Center Agent operating state.");
	validateRequestInput$1(input);
	return input;
}
function validateModelInput(input) {
	const parsed = updateCenterAgentModelBodySchema.safeParse({
		expectedConfigurationRevision: input.expectedConfigurationRevision,
		preference: input.preference
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Center Agent model.");
	validateRequestInput$1(input);
	return input;
}
function validateAuditJournalInput(input) {
	const parsed = listCenterAgentAuditJournalQuerySchema.safeParse({
		actionSet: input.actionSet ?? "v16",
		...input.limit === void 0 ? {} : { limit: input.limit }
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Center Agent audit journal query.");
	validateRequestInput$1(input);
	return {
		...input,
		actionSet: parsed.data.actionSet
	};
}
function validateUpdateProfileInput(input) {
	const parsed = centerAgentUpdateProfileBodySchema.safeParse({ profileName: input.profileName });
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Center Agent profile update.");
	validateRequestInput$1(input);
	return input;
}
function validateSlackWorkspaceConnectInput(input) {
	const parsed = centerAgentSlackWorkspaceConnectBodySchema.safeParse({ slackTeamId: input.slackTeamId });
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Center Agent Slack workspace payload.");
	validateRequestInput$1(input);
	return input;
}
function validateSlackIdentityLinkPreviewInput(input) {
	const parsed = slackIdentityLinkPreviewBodySchema.safeParse({ token: input.token });
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Slack identity link token.");
	validateRequestInput$1(input);
	return input;
}
function validateSlackIdentityLinkConsumeInput(input) {
	const parsed = slackIdentityLinkConsumeBodySchema.safeParse({
		includeReturnTarget: input.includeReturnTarget,
		token: input.token
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Slack identity link token.");
	validateRequestInput$1(input);
	return input;
}
function buildAuditJournalUrl(input) {
	const url = new URL(buildCenterAgentAuditJournalPath(), "https://openmeld.local");
	if (input.limit !== void 0) url.searchParams.set("limit", String(input.limit));
	if (input.actionSet !== void 0) url.searchParams.set("actionSet", input.actionSet);
	return `${url.pathname}${url.search}`;
}
//#endregion
//#region src/cli-release.ts
async function readCliRelease(client) {
	return readApiClientJsonResponse({
		response: await client.requestResponse({
			url: CLI_RELEASE_PATH,
			method: "GET",
			operation: "cli.release.read"
		}),
		operation: "cli.release.read",
		schema: cliReleaseSchema,
		invalidMessage: "Invalid CLI release response."
	});
}
//#endregion
//#region src/client.ts
const RESERVED_HEADERS = new Set([
	"authorization",
	OPENMELD_HEADER_AGENT_CONTROLLER_CONVERSATION_ID,
	OPENMELD_HEADER_AUTO_RELAY_DEPTH,
	OPENMELD_HEADER_CALLER_PRINCIPAL_ID,
	OPENMELD_HEADER_AGENT_CONTROLLER_REF,
	OPENMELD_HEADER_DISPATCH_CHAIN_ID,
	OPENMELD_HEADER_FORWARDED_BY,
	OPENMELD_HEADER_OWNER_NAME,
	OPENMELD_HEADER_OWNER_USER_ID,
	OPENMELD_HEADER_PROFILE_HANDLE,
	OPENMELD_HEADER_PROFILE_ID,
	OPENMELD_HEADER_PROFILE_KIND,
	OPENMELD_HEADER_PROFILE_NAME,
	OPENMELD_HEADER_REQUEST_ID,
	OPENMELD_HEADER_REQUESTED_ORGANIZATION_ID,
	OPENMELD_HEADER_REQUESTED_ORGANIZATION_SLUG,
	OPENMELD_HEADER_SPACE_PASSWORD,
	OPENMELD_HEADER_VISITED_PROFILE_IDS,
	OPENMELD_HEADER_VISITED_PROFILE_IDS_HASH
].map((value) => value.toLowerCase()));
function createOpenMeldApiClient(config) {
	const normalizedBaseUrl = normalizeApiBaseUrl(config.baseUrl);
	return {
		requestResponse: async (input) => await performRequest({
			config,
			baseUrl: normalizedBaseUrl,
			input
		}),
		requestJson: async (input) => {
			return await readApiClientJsonResponse({
				response: await performRequest({
					config,
					baseUrl: normalizedBaseUrl,
					input
				}),
				schema: input.schema,
				invalidMessage: input.invalidMessage,
				operation: input.operation
			});
		},
		requestText: async (input) => {
			return await readApiClientTextResponse({ response: await performRequest({
				config,
				baseUrl: normalizedBaseUrl,
				input
			}) });
		}
	};
}
async function performRequest(input) {
	const requestUrl = resolveRequestUrl(input.baseUrl, input.input.url);
	const headers = await resolveRequestHeaders({
		config: input.config,
		requestUrl,
		requestContext: input.input.requestContext,
		spacePassword: input.input.spacePassword,
		requestHeaders: input.input.headers
	});
	return await input.config.transport({
		url: requestUrl,
		operation: input.input.operation,
		timeoutMs: input.input.timeoutMs,
		init: {
			method: input.input.method,
			headers,
			body: input.input.body ?? void 0,
			signal: input.input.signal
		}
	});
}
async function resolveRequestHeaders(input) {
	assertNoReservedHeaderOverrides(input.requestHeaders);
	const authHeaders = normalizeHeaderRecord(input.config.getAuthHeaders ? await input.config.getAuthHeaders({ requestUrl: input.requestUrl }) : {});
	const requestContextHeaders = normalizeHeaderRecord(input.requestContext && input.config.getRequestContextHeaders ? await input.config.getRequestContextHeaders({
		requestUrl: input.requestUrl,
		requestContext: input.requestContext,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword }
	}) : {});
	const requestHeaders = normalizeHeaderRecord(input.requestHeaders ?? {});
	const spacePassword = input.spacePassword === void 0 ? void 0 : normalizeSpacePasswordText(input.spacePassword);
	return {
		...authHeaders,
		...requestContextHeaders,
		...spacePassword ? { [OPENMELD_HEADER_SPACE_PASSWORD]: spacePassword } : {},
		...requestHeaders
	};
}
function resolveRequestUrl(baseUrl, candidate) {
	return new URL(candidate, `${baseUrl}/`).toString();
}
function assertNoReservedHeaderOverrides(headers) {
	if (!headers) return;
	for (const headerName of Object.keys(headers)) {
		if (!RESERVED_HEADERS.has(headerName.toLowerCase())) continue;
		throw new Error(`request headers must not override reserved header: ${headerName}`);
	}
}
function normalizeHeaderRecord(headers) {
	const normalized = {};
	for (const [key, value] of Object.entries(headers)) {
		const normalizedKey = String(key).trim();
		if (normalizedKey.length === 0) continue;
		normalized[normalizedKey] = String(value);
	}
	return normalized;
}
//#endregion
//#region src/computer-authorization.ts
/** The authenticated client's explicit connection action approves an independent Computer session. */
async function createComputerAuthorizationGrant(request) {
	const codeResult = betterAuthDeviceAuthorizationCodeResponseSchema.safeParse(await request("/device/code", "POST", betterAuthDeviceAuthorizationCodeRequestSchema.parse({ client_id: "openmeld-cli" })));
	if (!codeResult.success) throw new Error("Auth returned an invalid computer authorization response.");
	const code = codeResult.data;
	if (!betterAuthDeviceAuthorizationClaimResponseSchema.safeParse(await request(`/device?user_code=${encodeURIComponent(code.user_code)}`, "GET")).success) throw new Error("Auth returned an invalid computer authorization claim.");
	const approval = betterAuthDeviceAuthorizationDecisionResponseSchema.safeParse(await request("/device/approve", "POST", betterAuthDeviceAuthorizationDecisionRequestSchema.parse({ userCode: code.user_code })));
	if (!(approval.success && approval.data.success)) throw new Error("Auth did not approve this computer authorization.");
	return {
		deviceCode: code.device_code,
		expiresIn: code.expires_in
	};
}
//#endregion
//#region src/computer-file-access/routes.ts
const CURRENT_COMPUTER_FILE_ACCESS_PATH = "/v1/local-runtimes/current/file-access";
function buildComputerFileAccessReadPath(expectedDeviceId) {
	const searchParams = new URLSearchParams({ expectedDeviceId });
	return `${CURRENT_COMPUTER_FILE_ACCESS_PATH}?${searchParams.toString()}`;
}
function buildComputerFileAccessUpdatePath() {
	return CURRENT_COMPUTER_FILE_ACCESS_PATH;
}
//#endregion
//#region src/computer-file-access/api.ts
const createComputerFileAccessApi = (client) => ({
	readPeopleComputerPolicy: async (input) => {
		const target = requireValidInput$6(peopleComputerTargetSchema, {
			deviceId: input.deviceId,
			runtimeLane: input.runtimeLane
		});
		return await client.requestJson({
			...requestOptions$8(input),
			method: "GET",
			operation: "people-computer.file-access.read",
			schema: computerFileAccessPolicyResponseSchema,
			invalidMessage: "Invalid Computer file access response.",
			url: `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/file-access`
		});
	},
	updatePeopleComputerPolicy: async (input) => {
		const target = requireValidInput$6(peopleComputerTargetSchema, {
			deviceId: input.deviceId,
			runtimeLane: input.runtimeLane
		});
		const body = requireValidInput$6(peopleComputerFileAccessUpdateBodySchema, {
			expectedRevision: input.expectedRevision,
			idempotencyKey: input.idempotencyKey,
			policy: input.policy
		});
		return await client.requestJson({
			...requestOptions$8(input),
			method: "PUT",
			operation: "people-computer.file-access.update",
			schema: computerFileAccessPolicyResponseSchema,
			invalidMessage: "Invalid Computer file access response.",
			headers: { "content-type": "application/json" },
			body: JSON.stringify(body),
			url: `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/file-access`
		});
	},
	readPolicy: async (input) => {
		const parsed = requireValidInput$6(computerFileAccessReadRequestSchema, { expectedDeviceId: input.expectedDeviceId });
		return await client.requestJson({
			...requestOptions$8(input),
			invalidMessage: "Invalid Computer file access response.",
			method: "GET",
			operation: "computer-file-access.read",
			schema: computerFileAccessPolicyResponseSchema,
			url: buildComputerFileAccessReadPath(parsed.expectedDeviceId)
		});
	},
	updatePolicy: async (input) => {
		const parsed = requireValidInput$6(computerFileAccessUpdateRequestSchema, {
			expectedDeviceId: input.expectedDeviceId,
			expectedRevision: input.expectedRevision,
			idempotencyKey: input.idempotencyKey,
			policy: input.policy
		});
		return await client.requestJson({
			...requestOptions$8(input),
			body: JSON.stringify(parsed),
			headers: { "content-type": "application/json" },
			invalidMessage: "Invalid Computer file access response.",
			method: "PUT",
			operation: "computer-file-access.update",
			schema: computerFileAccessPolicyResponseSchema,
			url: buildComputerFileAccessUpdatePath()
		});
	}
});
function requestOptions$8(input) {
	return {
		...input.requestContext === void 0 ? {} : { requestContext: input.requestContext },
		...input.signal === void 0 ? {} : { signal: input.signal },
		...input.timeoutMs === void 0 ? {} : { timeoutMs: input.timeoutMs }
	};
}
function requireValidInput$6(schema, value) {
	const parsed = schema.safeParse(value);
	if (!parsed.success) throw new Error(`Computer file access request is invalid. ${parsed.error.issues[0]?.message ?? "Invalid input."}`);
	return parsed.data;
}
//#endregion
//#region src/config/routes.ts
function buildModelCatalogPath() {
	return "/v1/config/model-catalog";
}
//#endregion
//#region src/config/api.ts
const createConfigApi = (client) => {
	return { getModelCatalog: () => getModelCatalog(client) };
};
async function getModelCatalog(client) {
	return await client.requestJson({
		url: buildModelCatalogPath(),
		operation: "config.model_catalog.read",
		method: "GET",
		schema: getModelCatalogResponseSchema,
		invalidMessage: "invalid model catalog response"
	});
}
//#endregion
//#region src/current-device/routes.ts
const CURRENT_DEVICE_ROUTE = "/v1/devices/current";
function buildLocalRuntimeEnrollmentRoute(deviceId) {
	return `/v1/local-runtimes/${encodeURIComponent(deviceId)}/enrollment`;
}
const FORGET_CURRENT_COMPUTER_ROUTE = "/v1/devices/current/forget";
const CURRENT_LOCAL_RUNTIME_REPLY_READINESS_ROUTE = "/v1/local-runtimes/current/reply-readiness";
const CURRENT_LOCAL_AGENT_CATALOG_REFRESH_ROUTE = "/v1/local-runtimes/current/local-agents/refresh-catalog";
const CURRENT_OPENMELD_TOOLS_UPDATE_ROUTE = "/v1/local-runtimes/current/openmeld-tools/update";
const CURRENT_OPENMELD_TOOLS_MAINTENANCE_ROUTE = "/v1/local-runtimes/current/openmeld-tools/maintenance";
function buildCurrentAgentProfileWorkspaceRoute(agentProfileId) {
	return `/v1/local-runtimes/current/agent-profiles/${encodeURIComponent(agentProfileId)}/workspace`;
}
function buildCurrentLocalAgentEnabledRoute(agentId) {
	return `/v1/local-runtimes/current/local-agents/${encodeURIComponent(agentId)}/enabled`;
}
function buildCurrentLocalAgentInstallationsRoute(agentId) {
	return `/v1/local-runtimes/current/local-agents/${encodeURIComponent(agentId)}/installations`;
}
const LOCAL_RUNTIMES_ROUTE = "/v1/local-runtimes";
function buildLocalRuntimesRoute(input) {
	if (!(input?.connectionIdentityAdoption || input?.includeUsageLimits)) return LOCAL_RUNTIMES_ROUTE;
	const params = new URLSearchParams();
	if (input.connectionIdentityAdoption) params.set("connectionIdentityAdoption", input.connectionIdentityAdoption);
	if (input.includeUsageLimits) params.set("includeUsageLimits", input.includeUsageLimits);
	return `${LOCAL_RUNTIMES_ROUTE}?${params.toString()}`;
}
function buildForgetComputerRoute(deviceId) {
	return `/v1/devices/${encodeURIComponent(deviceId)}/forget`;
}
function buildCurrentDeviceObservedMetadataRoute(deviceId) {
	return `/v1/devices/${encodeURIComponent(deviceId)}/observed-metadata`;
}
function buildLocalRuntimeDisplayNameRoute(deviceId) {
	return `/v1/local-runtimes/${encodeURIComponent(deviceId)}/display-name`;
}
//#endregion
//#region src/current-device/api.ts
function requireValidLocalRuntimeEnrollmentBody(input) {
	const parsed = localRuntimeEnrollmentBodySchema.safeParse({
		...input.connectedComputerId === void 0 ? {} : { connectedComputerId: input.connectedComputerId },
		runtimeLane: input.runtimeLane
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid local runtime enrollment body.");
	return parsed.data;
}
function requireValidCurrentDeviceObservedMetadataBody(input) {
	const parsed = writeCurrentDeviceObservedMetadataBodySchema.safeParse({ metadata: input.metadata });
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid current device observed metadata body.");
	return parsed.data;
}
function requireValidLocalRuntimesQuery(input = {}) {
	const parsed = localRuntimesQuerySchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid local runtimes query.");
	return parsed.data;
}
function requireValidLocalRuntimeDisplayNameBody(input) {
	const parsed = setLocalRuntimeDisplayNameBodySchema.safeParse({ displayName: input.displayName });
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid local runtime display name body.");
	return parsed.data;
}
function requireValidCurrentLocalAgentEnabledBody(input) {
	const parsed = setCurrentLocalAgentEnabledBodySchema.safeParse({ enabled: input.enabled });
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid local agent enabled payload.");
	return parsed.data;
}
function requireValidCurrentLocalAgentInstallationBody(input) {
	const parsed = selectCurrentLocalAgentInstallationBodySchema.safeParse({ installationId: input.installationId });
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid local agent installation payload.");
	return parsed.data;
}
function requireValidCurrentOpenMeldToolsMaintenanceBody(input) {
	const parsed = setCurrentOpenMeldToolsMaintenanceBodySchema.safeParse(input);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid update setting.");
	return parsed.data;
}
function requireValidCurrentAgentProfileWorkspaceBody(input) {
	const parsed = setCurrentAgentProfileWorkspaceBodySchema.safeParse({
		workspaceMode: input.workspaceMode,
		...input.workspacePath === void 0 ? {} : { workspacePath: input.workspacePath }
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid profile workspace payload.");
	return parsed.data;
}
const createCurrentDeviceApi = (client) => {
	return {
		listPeopleComputers: async (input) => client.requestJson({
			url: `/v1/people-computers${input?.includeUsageLimits === "true" ? "?includeUsageLimits=true" : ""}`,
			operation: "people_computers.list",
			method: "GET",
			schema: peopleComputersResponseSchema,
			invalidMessage: "Invalid computers response."
		}),
		getPeopleComputerReplyReadiness: (input) => {
			const target = peopleComputerTargetSchema.parse(input);
			return client.requestJson({
				url: `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/reply-readiness`,
				operation: "people_computers.reply_readiness.read",
				method: "GET",
				schema: currentLocalRuntimeReplyReadinessResponseSchema,
				invalidMessage: "Invalid computer readiness response."
			});
		},
		setPeopleComputerLocalAgentEnabled: async (input) => {
			const target = peopleComputerTargetSchema.parse({
				deviceId: input.deviceId,
				runtimeLane: input.runtimeLane
			});
			const body = setCurrentLocalAgentEnabledBodySchema.parse({ enabled: input.enabled });
			return await client.requestJson({
				url: `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/local-agents/${encodeURIComponent(input.agentId)}/enabled`,
				operation: "people_computer.setPeopleComputerLocalAgentEnabled",
				method: "PUT",
				headers: { "content-type": "application/json" },
				body: JSON.stringify(body),
				schema: setCurrentLocalAgentEnabledResponseSchema,
				invalidMessage: "Invalid computer action response."
			});
		},
		getPeopleComputerLocalAgentInstallations: async (input) => {
			const target = peopleComputerTargetSchema.parse({
				deviceId: input.deviceId,
				runtimeLane: input.runtimeLane
			});
			return await client.requestJson({
				url: `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/local-agents/${encodeURIComponent(input.agentId)}/installations`,
				operation: "people_computer.getPeopleComputerLocalAgentInstallations",
				method: "GET",
				schema: currentLocalAgentInstallationsResponseSchema,
				invalidMessage: "Invalid computer action response."
			});
		},
		selectPeopleComputerLocalAgentInstallation: async (input) => {
			const target = peopleComputerTargetSchema.parse({
				deviceId: input.deviceId,
				runtimeLane: input.runtimeLane
			});
			const body = selectCurrentLocalAgentInstallationBodySchema.parse({ installationId: input.installationId });
			return await client.requestJson({
				url: `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/local-agents/${encodeURIComponent(input.agentId)}/installations`,
				operation: "people_computer.selectPeopleComputerLocalAgentInstallation",
				method: "PUT",
				headers: { "content-type": "application/json" },
				body: JSON.stringify(body),
				schema: selectCurrentLocalAgentInstallationResponseSchema,
				invalidMessage: "Invalid computer action response."
			});
		},
		refreshPeopleComputerLocalAgentCatalog: async (input) => {
			const target = peopleComputerTargetSchema.parse({
				deviceId: input.deviceId,
				runtimeLane: input.runtimeLane
			});
			return await client.requestJson({
				url: `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/local-agents/refresh-catalog`,
				operation: "people_computer.refreshPeopleComputerLocalAgentCatalog",
				method: "POST",
				schema: refreshCurrentLocalAgentCatalogResponseSchema,
				invalidMessage: "Invalid computer action response."
			});
		},
		requestPeopleComputerOpenMeldToolsUpdate: async (input) => {
			const target = peopleComputerTargetSchema.parse({
				deviceId: input.deviceId,
				runtimeLane: input.runtimeLane
			});
			return await client.requestJson({
				url: `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/openmeld-tools/update`,
				operation: "people_computer.requestPeopleComputerOpenMeldToolsUpdate",
				method: "POST",
				schema: requestCurrentOpenMeldToolsUpdateResponseSchema,
				invalidMessage: "Invalid computer action response."
			});
		},
		setPeopleComputerOpenMeldToolsMaintenance: async (input) => {
			const target = peopleComputerTargetSchema.parse({
				deviceId: input.deviceId,
				runtimeLane: input.runtimeLane
			});
			const body = setCurrentOpenMeldToolsMaintenanceBodySchema.parse({ automaticUpdatesEnabled: input.automaticUpdatesEnabled });
			return await client.requestJson({
				url: `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/openmeld-tools/maintenance`,
				operation: "people_computer.setPeopleComputerOpenMeldToolsMaintenance",
				method: "PUT",
				headers: { "content-type": "application/json" },
				body: JSON.stringify(body),
				schema: setCurrentOpenMeldToolsMaintenanceResponseSchema,
				invalidMessage: "Invalid computer action response."
			});
		},
		getCurrentLocalRuntimeReplyReadiness: async () => await client.requestJson({
			url: CURRENT_LOCAL_RUNTIME_REPLY_READINESS_ROUTE,
			operation: "local_runtime.current.reply_readiness.read",
			method: "GET",
			schema: currentLocalRuntimeReplyReadinessResponseSchema,
			invalidMessage: "Invalid current local runtime reply readiness response."
		}),
		getCurrentTarget: async () => await client.requestJson({
			url: CURRENT_DEVICE_ROUTE,
			operation: "current_device.read",
			method: "GET",
			schema: currentDeviceTargetResponseSchema,
			invalidMessage: "Invalid current device target response."
		}),
		forgetComputer: async (input) => await client.requestJson({
			url: buildForgetComputerRoute(input.deviceId),
			operation: "local_runtime.forget",
			method: "POST",
			schema: forgetComputerResponseSchema,
			invalidMessage: "Invalid forgotten computer response."
		}),
		forgetCurrentComputer: async () => await client.requestJson({
			url: FORGET_CURRENT_COMPUTER_ROUTE,
			operation: "current_device.forget",
			method: "POST",
			schema: forgetCurrentComputerResponseSchema,
			invalidMessage: "Invalid forgotten computer response."
		}),
		listLocalRuntimes: async (input) => {
			const query = requireValidLocalRuntimesQuery(input);
			return await client.requestJson({
				url: buildLocalRuntimesRoute(query),
				operation: "local_runtime.list",
				method: "GET",
				schema: localRuntimesResponseSchema,
				invalidMessage: "Invalid local runtimes response."
			});
		},
		enrollLocalRuntime: async (input) => {
			const body = requireValidLocalRuntimeEnrollmentBody(input);
			return await client.requestJson({
				url: buildLocalRuntimeEnrollmentRoute(input.deviceId),
				operation: "local_runtime.enroll",
				method: "POST",
				headers: { "content-type": "application/json" },
				body: JSON.stringify(body),
				schema: localRuntimeEnrollmentResponseSchema,
				invalidMessage: "Invalid local runtime enrollment response."
			});
		},
		setDisplayName: async (input) => {
			const body = requireValidLocalRuntimeDisplayNameBody(input);
			return await client.requestJson({
				url: buildLocalRuntimeDisplayNameRoute(input.deviceId),
				operation: "local_runtime.display_name.write",
				method: "PUT",
				headers: { "content-type": "application/json" },
				body: JSON.stringify(body),
				schema: localRuntimesResponseSchema,
				invalidMessage: "Invalid local runtimes response."
			});
		},
		setCurrentLocalAgentEnabled: async (input) => {
			const body = requireValidCurrentLocalAgentEnabledBody(input);
			return await client.requestJson({
				url: buildCurrentLocalAgentEnabledRoute(input.agentId),
				operation: "local_runtime.current.local_agent_enabled.write",
				method: "PUT",
				headers: { "content-type": "application/json" },
				body: JSON.stringify(body),
				schema: setCurrentLocalAgentEnabledResponseSchema,
				invalidMessage: "Invalid local agent enabled response."
			});
		},
		getCurrentLocalAgentInstallations: async (input) => await client.requestJson({
			url: buildCurrentLocalAgentInstallationsRoute(input.agentId),
			operation: "local_runtime.current.local_agent_installations.read",
			method: "GET",
			schema: currentLocalAgentInstallationsResponseSchema,
			invalidMessage: "Invalid local agent installations response."
		}),
		selectCurrentLocalAgentInstallation: async (input) => {
			const body = requireValidCurrentLocalAgentInstallationBody(input);
			return await client.requestJson({
				url: buildCurrentLocalAgentInstallationsRoute(input.agentId),
				operation: "local_runtime.current.local_agent_installation.write",
				method: "PUT",
				headers: { "content-type": "application/json" },
				body: JSON.stringify(body),
				schema: selectCurrentLocalAgentInstallationResponseSchema,
				invalidMessage: "Invalid selected local agent installation response."
			});
		},
		requestCurrentOpenMeldToolsUpdate: async () => await client.requestJson({
			url: CURRENT_OPENMELD_TOOLS_UPDATE_ROUTE,
			operation: "local_runtime.current.openmeld_tools.update",
			method: "POST",
			schema: requestCurrentOpenMeldToolsUpdateResponseSchema,
			invalidMessage: "Invalid OpenMeld Tools update response."
		}),
		setCurrentOpenMeldToolsMaintenance: async (input) => {
			const body = requireValidCurrentOpenMeldToolsMaintenanceBody(input);
			return await client.requestJson({
				url: CURRENT_OPENMELD_TOOLS_MAINTENANCE_ROUTE,
				operation: "local_runtime.current.openmeld_tools.maintenance.write",
				method: "PUT",
				headers: { "content-type": "application/json" },
				body: JSON.stringify(body),
				schema: setCurrentOpenMeldToolsMaintenanceResponseSchema,
				invalidMessage: "Invalid OpenMeld Tools update setting response."
			});
		},
		setCurrentAgentProfileWorkspace: async (input) => {
			const body = requireValidCurrentAgentProfileWorkspaceBody(input);
			const target = input.target ? peopleComputerTargetSchema.parse(input.target) : null;
			return await client.requestJson({
				url: target ? `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/agent-profiles/${encodeURIComponent(input.agentProfileId)}/workspace` : buildCurrentAgentProfileWorkspaceRoute(input.agentProfileId),
				operation: "local_runtime.current.agent_profile_workspace.write",
				method: "PUT",
				headers: { "content-type": "application/json" },
				body: JSON.stringify(body),
				schema: setCurrentAgentProfileWorkspaceResponseSchema,
				invalidMessage: "Invalid profile workspace response."
			});
		},
		refreshCurrentLocalAgentCatalog: async () => await client.requestJson({
			url: CURRENT_LOCAL_AGENT_CATALOG_REFRESH_ROUTE,
			operation: "local_runtime.current.local_agent_catalog.refresh",
			method: "POST",
			schema: refreshCurrentLocalAgentCatalogResponseSchema,
			invalidMessage: "Invalid local agent catalog refresh response."
		}),
		writeObservedMetadata: async (input) => {
			const body = requireValidCurrentDeviceObservedMetadataBody(input);
			return await client.requestJson({
				url: buildCurrentDeviceObservedMetadataRoute(input.deviceId),
				operation: "current_device.observed_metadata.write",
				method: "PUT",
				headers: { "content-type": "application/json" },
				body: JSON.stringify(body),
				schema: writeCurrentDeviceObservedMetadataResponseSchema,
				invalidMessage: "Invalid current device observed metadata response."
			});
		}
	};
};
//#endregion
//#region src/direct-message/routes.ts
function buildDirectMessageSpacePath() {
	return "/v1/organizations/current/dm-space";
}
function buildDirectMessageConversionPath(spaceId) {
	return `/v1/spaces/${encodeURIComponent(spaceId)}/direct-message-conversion`;
}
//#endregion
//#region src/direct-message/api.ts
const createDirectMessageApi = (client) => ({
	convertToSpace: async (input) => {
		const request = validateConvertDirectMessageToSpaceInput(input);
		return await client.requestJson({
			body: JSON.stringify({
				includeMemberSnapshots: request.includeMemberSnapshots,
				name: request.name,
				profileIds: request.profileIds
			}),
			headers: { "content-type": "application/json" },
			invalidMessage: "Invalid Direct Message conversion response.",
			method: "POST",
			operation: "direct_message.space.convert",
			requestContext: request.requestContext,
			schema: convertDirectMessageToSpaceResponseSchema,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			url: buildDirectMessageConversionPath(request.spaceId)
		});
	},
	openSpace: async (input) => {
		const request = validateOpenDirectMessageSpaceInput(input);
		return await client.requestJson({
			url: buildDirectMessageSpacePath(),
			operation: "direct_message.space.open",
			method: "POST",
			requestContext: request.requestContext,
			signal: request.signal,
			timeoutMs: request.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify({ targetProfileId: request.targetProfileId }),
			schema: openDirectMessageSpaceResponseSchema,
			invalidMessage: "Invalid Direct Message Space response."
		});
	}
});
function validateConvertDirectMessageToSpaceInput(input) {
	const parsed = convertDirectMessageToSpaceBodySchema.safeParse({
		includeMemberSnapshots: input.includeMemberSnapshots,
		name: input.name,
		profileIds: input.profileIds
	});
	if (!parsed.success || input.spaceId.trim().length === 0) throw new Error(parsed.error?.issues[0]?.message ?? "Invalid Direct Message conversion request.");
	validateRequestInput(input);
	return input;
}
function validateRequestInput(input) {
	if (!openMeldRequestContextSchema.optional().safeParse(input.requestContext).success) throw new Error("Invalid Direct Message request context.");
	return input;
}
function validateOpenDirectMessageSpaceInput(input) {
	const parsed = openDirectMessageSpaceBodySchema.safeParse({ targetProfileId: input.targetProfileId });
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Direct Message target.");
	validateRequestInput(input);
	return input;
}
//#endregion
//#region src/feedback/routes.ts
function buildFeedbackIssueSubmissionPath(inboxKey) {
	return `/v1/feedback/inboxes/${encodeURIComponent(inboxKey)}/issues`;
}
function buildCurrentOrganizationFeedbackReportingPolicyPath() {
	return "/v1/organizations/current/feedback-reporting-policy";
}
//#endregion
//#region src/feedback/api.ts
const createFeedbackApi = (client) => ({
	submitFeedbackIssue: async (input) => {
		const request = submitFeedbackIssueRequestSchema.parse(input.request);
		return await client.requestJson({
			url: buildFeedbackIssueSubmissionPath(input.inboxKey),
			operation: "feedback.issue.submit",
			method: "POST",
			headers: { "content-type": "application/json" },
			body: JSON.stringify(request),
			schema: submitFeedbackIssueResponseSchema,
			invalidMessage: "invalid Feedback Issue submission response"
		});
	},
	readCurrentOrganizationFeedbackReportingPolicy: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationFeedbackReportingPolicyPath(),
		operation: "feedback.reporting_policy.read",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: feedbackReportingPolicyResponseSchema,
		invalidMessage: "invalid feedback reporting policy response"
	}),
	setCurrentOrganizationFeedbackReportingPolicy: async (input) => {
		const body = updateFeedbackReportingPolicyBodySchema.parse({ reportingEnabled: input.reportingEnabled });
		return await client.requestJson({
			url: buildCurrentOrganizationFeedbackReportingPolicyPath(),
			operation: "feedback.reporting_policy.write",
			method: "PUT",
			requestContext: input.requestContext,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify(body),
			schema: feedbackReportingPolicyResponseSchema,
			invalidMessage: "invalid feedback reporting policy response"
		});
	}
});
//#endregion
//#region src/inbox/routes.ts
const INBOX_PATH = "/v1/inbox";
function buildInboxFeedPath(query = {}) {
	const search = new URLSearchParams();
	for (const key of [
		"category",
		"unreadOnly",
		"agentsOnly",
		"peopleOnly",
		"conversationType",
		"includeSelectionUnreadCount",
		"cursor",
		"limit",
		"snapshotId",
		"groupKey"
	]) if (query[key] !== void 0) search.set(key, String(query[key]));
	return `${INBOX_PATH}/feed${search.size ? `?${search}` : ""}`;
}
function buildInboxFeedStatePath() {
	return `${INBOX_PATH}/feed/state`;
}
function buildInboxMessageNotificationPreferencesPath(spaceId) {
	const base = `${INBOX_PATH}/message-notification-preferences`;
	return spaceId === void 0 ? base : `${base}?${new URLSearchParams({ spaceId })}`;
}
function buildInboxPath(query = {}) {
	const search = new URLSearchParams();
	if (query.cursor !== void 0) search.set("cursor", query.cursor);
	if (query.limit !== void 0) search.set("limit", String(query.limit));
	if (query.presentation !== void 0) search.set("presentation", query.presentation);
	if (query.notificationPreview !== void 0) search.set("notificationPreview", query.notificationPreview);
	if (query.view !== void 0) search.set("view", query.view);
	const suffix = search.toString();
	return suffix ? `${INBOX_PATH}?${suffix}` : INBOX_PATH;
}
function buildInboxSummaryPath(presentation) {
	const base = `${INBOX_PATH}/summary`;
	return presentation === void 0 ? base : `${base}?${new URLSearchParams({ presentation })}`;
}
function buildCenterAgentInboxSummaryPath() {
	return `${INBOX_PATH}/center-agent/summary`;
}
function buildCenterAgentInboxReadThroughPath() {
	return `${INBOX_PATH}/center-agent/read-through`;
}
function buildSpaceInboxSummaryPath() {
	return `${INBOX_PATH}/spaces/summary`;
}
function buildSpaceInboxUnreadTargetsPath(spaceId) {
	return `${INBOX_PATH}/spaces/${encodeURIComponent(spaceId)}/unread-targets`;
}
function buildSpaceInboxReadThroughPath() {
	return `${INBOX_PATH}/spaces/read-through`;
}
function buildInboxItemReadPath(itemId) {
	return `${INBOX_PATH}/items/${encodeURIComponent(itemId)}/read`;
}
function buildInboxItemDismissPath(itemId) {
	return `${INBOX_PATH}/items/${encodeURIComponent(itemId)}/dismiss`;
}
function buildInboxItemPath(itemId) {
	return `${INBOX_PATH}/items/${encodeURIComponent(itemId)}`;
}
function buildInboxMarkAllReadPath(presentation) {
	const base = `${INBOX_PATH}/mark-all-read`;
	return presentation === void 0 ? base : `${base}?${new URLSearchParams({ presentation })}`;
}
function buildInboxPreferencesPath() {
	return `${INBOX_PATH}/preferences`;
}
//#endregion
//#region src/inbox/api.ts
const createInboxApi = (client) => ({
	feed: async (input = {}) => {
		const { requestContext: _context, signal: _signal, timeoutMs: _timeout, ...rawQuery } = input;
		const query = requireValidInput$5(inboxFeedQuerySchema, rawQuery, "Inbox filters are invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			method: "GET",
			operation: "inbox.feed",
			headers: inboxSourceTargetVersionHeaders(),
			schema: inboxFeedResponseSchema,
			invalidMessage: "Invalid Inbox attention feed response",
			url: buildInboxFeedPath(query)
		});
	},
	mutateFeed: async (input) => {
		const body = requireValidInput$5(mutateInboxFeedBodySchema, {
			snapshotId: input.snapshotId,
			groupKey: input.groupKey,
			operation: input.operation
		}, "Inbox selection is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			method: "POST",
			operation: "inbox.feed.state",
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			schema: mutateInboxFeedResponseSchema,
			invalidMessage: "Invalid Inbox selection response",
			url: buildInboxFeedStatePath()
		});
	},
	getMessageNotificationPreferences: async (input = {}) => {
		const query = requireValidInput$5(inboxMessageNotificationPreferencesQuerySchema, { spaceId: input.spaceId }, "Message notification preferences query is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			method: "GET",
			operation: "inbox.message_preferences.read",
			invalidMessage: "Invalid message notification preferences response",
			schema: inboxMessageNotificationPreferencesResponseSchema,
			url: buildInboxMessageNotificationPreferencesPath(query.spaceId)
		});
	},
	updateMessageNotificationPreferences: async (input) => {
		const body = requireValidInput$5(updateInboxMessageNotificationPreferencesBodySchema, input.preference, "Message notification preferences request is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			method: "PATCH",
			operation: "inbox.message_preferences.update",
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "Invalid message notification preferences response",
			schema: inboxMessageNotificationPreferencesResponseSchema,
			url: buildInboxMessageNotificationPreferencesPath()
		});
	},
	centerAgentSummary: async (input = {}) => await client.requestJson({
		...requestOptions$7(input),
		invalidMessage: "invalid Center Agent Inbox summary response",
		method: "GET",
		operation: "inbox.center_agent.summary",
		schema: centerAgentInboxSummaryResponseSchema,
		url: buildCenterAgentInboxSummaryPath()
	}),
	dismiss: async (input) => {
		const params = requireValidInput$5(inboxItemRouteParamsSchema, { itemId: input.itemId }, "Inbox item request is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			invalidMessage: "invalid Inbox dismiss response",
			headers: inboxSourceTargetVersionHeaders(),
			method: "PUT",
			operation: "inbox.item.dismiss",
			schema: dismissInboxItemResponseSchema,
			url: buildInboxItemDismissPath(params.itemId)
		});
	},
	get: async (input) => {
		const params = requireValidInput$5(inboxItemRouteParamsSchema, { itemId: input.itemId }, "Inbox item request is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			headers: inboxSourceTargetVersionHeaders(),
			invalidMessage: "invalid Inbox item response",
			method: "GET",
			operation: "inbox.item.get",
			schema: getInboxItemResponseSchema,
			url: buildInboxItemPath(params.itemId)
		});
	},
	list: async (input = {}) => {
		const query = requireValidInput$5(listInboxItemsQuerySchema, {
			...input.cursor === void 0 ? {} : { cursor: input.cursor },
			...input.limit === void 0 ? {} : { limit: input.limit },
			...input.presentation === void 0 ? {} : { presentation: input.presentation },
			...input.notificationPreview === void 0 ? {} : { notificationPreview: input.notificationPreview },
			...input.view === void 0 ? {} : { view: input.view }
		}, "Inbox list request is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			headers: inboxSourceTargetVersionHeaders(),
			invalidMessage: "invalid Inbox list response",
			method: "GET",
			operation: "inbox.list",
			schema: listInboxItemsResponseSchema,
			url: buildInboxPath(query)
		});
	},
	summary: async (input = {}) => {
		const query = requireValidInput$5(inboxSummaryQuerySchema, input.presentation === void 0 ? {} : { presentation: input.presentation }, "Inbox summary request is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			invalidMessage: "invalid Inbox summary response",
			headers: {
				...inboxSourceTargetVersionHeaders(),
				[OPENMELD_HEADER_INBOX_SUMMARY_VERSION]: OPENMELD_INBOX_SUMMARY_VERSION
			},
			method: "GET",
			operation: "inbox.summary",
			schema: inboxSummaryResponseSchema,
			url: buildInboxSummaryPath(query.presentation)
		});
	},
	markRead: async (input) => {
		const params = requireValidInput$5(inboxItemRouteParamsSchema, { itemId: input.itemId }, "Inbox item request is invalid.");
		const body = requireValidInput$5(markInboxItemReadBodySchema, { read: input.read }, "Inbox read request is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			body: JSON.stringify(body),
			headers: {
				"content-type": "application/json",
				...inboxSourceTargetVersionHeaders()
			},
			invalidMessage: "invalid Inbox read response",
			method: "PATCH",
			operation: "inbox.item.read",
			schema: markInboxItemReadResponseSchema,
			url: buildInboxItemReadPath(params.itemId)
		});
	},
	markAllRead: async (input = {}) => {
		const query = requireValidInput$5(markAllInboxItemsReadQuerySchema, input.presentation === void 0 ? {} : { presentation: input.presentation }, "Inbox mark-all-read request is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			invalidMessage: "invalid Inbox mark-all-read response",
			method: "POST",
			operation: "inbox.mark_all_read",
			schema: markAllInboxItemsReadResponseSchema,
			url: buildInboxMarkAllReadPath(query.presentation)
		});
	},
	markCenterAgentReadThrough: async (input) => {
		const body = requireValidInput$5(markCenterAgentInboxReadThroughBodySchema, {
			spaceId: input.spaceId,
			throughOccurredAtMs: input.throughOccurredAtMs
		}, "Center Agent Inbox read request is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Center Agent Inbox read response",
			method: "POST",
			operation: "inbox.center_agent.read_through",
			schema: markCenterAgentInboxReadThroughResponseSchema,
			url: buildCenterAgentInboxReadThroughPath()
		});
	},
	spaceSummary: async (input = {}) => await client.requestJson({
		...requestOptions$7(input),
		invalidMessage: "invalid Space Inbox summary response",
		method: "GET",
		operation: "inbox.space.summary",
		headers: {
			...inboxSourceTargetVersionHeaders(),
			[OPENMELD_HEADER_INBOX_SUMMARY_VERSION]: OPENMELD_INBOX_SUMMARY_VERSION
		},
		schema: spaceInboxSummaryResponseSchema,
		url: buildSpaceInboxSummaryPath()
	}),
	spaceUnreadTargets: async (input) => {
		const params = requireValidInput$5(spaceInboxUnreadTargetsRouteParamsSchema, { spaceId: input.spaceId }, "Space Inbox unread targets request is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			headers: inboxSourceTargetVersionHeaders(),
			invalidMessage: "invalid Space Inbox unread targets response",
			method: "GET",
			operation: "inbox.space.unread_targets",
			schema: spaceInboxUnreadTargetsResponseSchema,
			url: buildSpaceInboxUnreadTargetsPath(params.spaceId)
		});
	},
	markSpaceReadThrough: async (input) => {
		const body = requireValidInput$5(markSpaceInboxReadThroughBodySchema, {
			spaceId: input.spaceId,
			...input.threadRootSignalId === void 0 ? {} : { threadRootSignalId: input.threadRootSignalId },
			throughOccurredAtMs: input.throughOccurredAtMs
		}, "Space Inbox read request is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Space Inbox read response",
			method: "POST",
			operation: "inbox.space.read_through",
			schema: markSpaceInboxReadThroughResponseSchema,
			url: buildSpaceInboxReadThroughPath()
		});
	},
	getPreferences: async (input = {}) => await client.requestJson({
		...requestOptions$7(input),
		invalidMessage: "invalid Inbox notification preferences response",
		method: "GET",
		operation: "inbox.preferences.read",
		schema: inboxNotificationPreferencesResponseSchema,
		url: buildInboxPreferencesPath()
	}),
	updatePreferences: async (input) => {
		const body = requireValidInput$5(updateInboxNotificationPreferencesBodySchema, { urgentEmailEnabled: input.urgentEmailEnabled }, "Inbox notification preferences request is invalid.");
		return await client.requestJson({
			...requestOptions$7(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Inbox notification preferences response",
			method: "PATCH",
			operation: "inbox.preferences.update",
			schema: inboxNotificationPreferencesResponseSchema,
			url: buildInboxPreferencesPath()
		});
	}
});
function inboxSourceTargetVersionHeaders() {
	return {
		[OPENMELD_HEADER_INBOX_ITEM_KIND_VERSION]: OPENMELD_INBOX_ITEM_KIND_VERSION,
		[OPENMELD_HEADER_INBOX_SOURCE_TARGET_VERSION]: OPENMELD_INBOX_SOURCE_TARGET_VERSION
	};
}
function requestOptions$7(input) {
	return {
		...input.requestContext === void 0 ? {} : { requestContext: input.requestContext },
		...input.signal === void 0 ? {} : { signal: input.signal },
		...input.timeoutMs === void 0 ? {} : { timeoutMs: input.timeoutMs }
	};
}
function requireValidInput$5(schema, value, message) {
	const parsed = schema.safeParse(value);
	if (!parsed.success) throw new Error(`${message} ${parsed.error.issues[0]?.message ?? "Invalid input."}`);
	return parsed.data;
}
//#endregion
//#region src/inbox/item-scope.ts
/** Response-scope validation only. Core still owns recipient/source access. */
function isInboxItemInOrganizationScope(item, organizationId) {
	if (item.organizationId !== null) return item.organizationId === organizationId;
	return item.sourceTarget.kind === "computer_connection" || item.sourceTarget.kind === "desktop_update";
}
//#endregion
//#region src/inbox/notification-policy.ts
/** Same rendered conversation projection in Web and native delivery. */
function isInboxItemVisibleConversation(item, conversation) {
	if (!conversation) return false;
	const target = item.sourceTarget;
	if (target.kind === "center_agent") return target.spaceId === conversation.spaceId && conversation.threadRootSignalId === null;
	if (target.kind === "space") return target.spaceId === conversation.spaceId && (target.threadRootSignalId ?? null) === conversation.threadRootSignalId;
	if (target.kind === "agent_interaction") return target.threadRootSignalId !== void 0 && target.spaceId === conversation.spaceId && target.threadRootSignalId === conversation.threadRootSignalId;
	return false;
}
/** Client delivery policy over Core facts; never an Inbox writer. */
function inboxMessageNotificationSpaceId(item) {
	if (item.attention !== "update") return;
	if (item.sourceTarget.kind !== "space" && item.sourceTarget.kind !== "center_agent") return;
	if (![
		"space_message",
		"space_mention",
		"agent_reply",
		"wake_outcome",
		"center_agent_update"
	].includes(item.kind)) return;
	return item.sourceTarget.spaceId;
}
function isDirectMessageRecipient(item) {
	return item.sourceFacts ? item.sourceFacts.recipientReasons.includes("direct_message") : item.sourceTarget.kind === "center_agent";
}
function isLegacyOwnerObservation(item) {
	return !item.sourceFacts && item.attention === "update" && item.sourceTarget.kind === "space" && item.sourceTarget.agentOwnerActivity === true && item.sourceTarget.replyToRecipient !== true && (item.kind === "space_message" || item.kind === "agent_reply");
}
function isInboxNotificationEligible(item, mode = "mentions_and_replies") {
	if (item.resolutionStatus === "resolved" || item.sourceTarget.kind === "desktop_update") return false;
	if (isLegacyOwnerObservation(item)) return false;
	const ownerOnly = item.sourceFacts?.recipientReasons.every((reason) => reason === "agent_owner") === true;
	const firstContact = (item.sourceFacts?.firstContactAgentProfileIds?.length ?? 0) > 0;
	if (ownerOnly && item.attention === "update" && !firstContact && item.importance !== "urgent") return false;
	if (inboxMessageNotificationSpaceId(item)) {
		if (mode === "muted") return false;
		if (mode === "all_messages") return true;
		if (isDirectMessageRecipient(item)) return true;
	}
	if (item.importance === "urgent") return true;
	if (firstContact) return true;
	if (item.attention === "action_required" && item.resolutionStatus === "open") return true;
	return item.kind === "space_mention" || item.kind === "agent_reply" || item.kind === "wake_outcome" || item.kind === "space_message" && item.sourceTarget.kind === "space" && (item.sourceTarget.directMessage === true || item.sourceTarget.replyToRecipient === true);
}
//#endregion
//#region src/local-folder-picker/routes.ts
const CURRENT_LOCAL_FOLDER_PICKER_PATH = "/v1/local-runtimes/current/folder-picker";
function buildLocalFolderPickerPath() {
	return CURRENT_LOCAL_FOLDER_PICKER_PATH;
}
//#endregion
//#region src/local-folder-picker/api.ts
const createLocalFolderPickerApi = (client) => ({
	selectPeopleComputerFolders: async (input) => {
		const target = peopleComputerTargetSchema.safeParse({
			deviceId: input.deviceId,
			runtimeLane: input.runtimeLane
		});
		const body = peopleComputerFolderPickerBodySchema.safeParse({
			allowMultiple: input.allowMultiple,
			purpose: input.purpose
		});
		if (!(target.success && body.success)) throw new Error("Invalid computer folder picker request.");
		return await client.requestJson({
			...requestOptions$6(input),
			method: "POST",
			headers: { "content-type": "application/json" },
			body: JSON.stringify(body.data),
			operation: "people-computer.select-folders",
			schema: localFolderPickerResultSchema,
			invalidMessage: "Invalid Local Folder Picker response.",
			url: `/v1/people-computers/${encodeURIComponent(target.data.deviceId)}/lanes/${encodeURIComponent(target.data.runtimeLane)}/folders/select`
		});
	},
	selectFolders: async (input) => {
		const parsed = localFolderPickerRequestSchema.safeParse({
			allowMultiple: input.allowMultiple,
			expectedDeviceId: input.expectedDeviceId,
			purpose: input.purpose
		});
		if (!parsed.success) throw new Error(`Local Folder Picker request is invalid. ${parsed.error.issues[0]?.message ?? "Invalid input."}`);
		return await client.requestJson({
			...requestOptions$6(input),
			body: JSON.stringify(parsed.data),
			headers: { "content-type": "application/json" },
			invalidMessage: "Invalid Local Folder Picker response.",
			method: "POST",
			operation: "local-folder-picker.select-folders",
			schema: localFolderPickerResultSchema,
			url: buildLocalFolderPickerPath()
		});
	}
});
function requestOptions$6(input) {
	return {
		...input.requestContext === void 0 ? {} : { requestContext: input.requestContext },
		...input.signal === void 0 ? {} : { signal: input.signal },
		...input.timeoutMs === void 0 ? {} : { timeoutMs: input.timeoutMs }
	};
}
//#endregion
//#region src/local-project-control/routes.ts
const CURRENT_PROJECTS_PATH = "/v1/local-runtimes/current/projects";
function buildLocalProjectControlPath(route) {
	return `${CURRENT_PROJECTS_PATH}/${route}`;
}
//#endregion
//#region src/local-project-control/api.ts
const createLocalProjectControlApi = (client) => ({
	discoverPeopleComputerProjects: async (input) => {
		const target = requireValidInput$4(peopleComputerTargetSchema, {
			deviceId: input.deviceId,
			runtimeLane: input.runtimeLane
		});
		const { deviceId: _deviceId, runtimeLane: _runtimeLane, ...request } = input;
		const body = requireValidInput$4(localProjectControlDiscoverProjectsRequestSchema, requestBody(request));
		return await client.requestJson({
			...requestOptions$5(input),
			method: "POST",
			headers: { "content-type": "application/json" },
			body: JSON.stringify(body),
			operation: "people-computer.projects.discover",
			schema: localProjectControlDiscoverProjectsResponseSchema,
			invalidMessage: "Invalid local Project discovery response.",
			url: `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/projects/discover`
		});
	},
	discoverProjects: async (input) => await client.requestJson({
		...requestOptions$5(input),
		body: JSON.stringify(requireValidInput$4(localProjectControlDiscoverProjectsRequestSchema, requestBody(input))),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid local Project discovery response",
		method: "POST",
		operation: "local-project-control.discover",
		schema: localProjectControlDiscoverProjectsResponseSchema,
		url: buildLocalProjectControlPath("discover")
	}),
	connectCandidate: async (input) => await client.requestJson({
		...requestOptions$5(input),
		body: JSON.stringify(requireValidInput$4(localProjectControlConnectCandidateRequestSchema, requestBody(input))),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid local Project candidate connection response",
		method: "POST",
		operation: "local-project-control.connect-candidate",
		schema: localProjectControlConnectOutcomeSchema,
		url: projectControlPath(input, "connect-candidate")
	}),
	connectDeclaredPath: async (input) => await client.requestJson({
		...requestOptions$5(input),
		body: JSON.stringify(requireValidInput$4(localProjectControlConnectDeclaredPathRequestSchema, requestBody(input))),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid local Project folder connection response",
		method: "POST",
		operation: "local-project-control.connect-declared-path",
		schema: localProjectControlConnectOutcomeSchema,
		url: projectControlPath(input, "connect-declared-path")
	}),
	setDefaultConnection: async (input) => await client.requestJson({
		...requestOptions$5(input),
		body: JSON.stringify(requireValidInput$4(localProjectControlSetDefaultConnectionRequestSchema, requestBody(input))),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid default local Project connection response",
		method: "POST",
		operation: "local-project-control.set-default",
		schema: localProjectControlSetDefaultConnectionResponseSchema,
		url: projectControlPath(input, "connections/set-default")
	}),
	removeConnection: async (input) => await client.requestJson({
		...requestOptions$5(input),
		body: JSON.stringify(requireValidInput$4(localProjectControlRemoveConnectionRequestSchema, requestBody(input))),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid local Project connection removal response",
		method: "POST",
		operation: "local-project-control.remove",
		schema: localProjectControlRemoveConnectionResponseSchema,
		url: buildLocalProjectControlPath("connections/remove")
	}),
	removeMissingConnections: async (input) => await client.requestJson({
		...requestOptions$5(input),
		body: JSON.stringify(requireValidInput$4(localProjectControlRemoveMissingConnectionsRequestSchema, requestBody(input))),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid missing local Project connections response",
		method: "POST",
		operation: "local-project-control.remove-missing",
		schema: localProjectControlRemoveMissingConnectionsResponseSchema,
		url: buildLocalProjectControlPath("connections/remove-missing")
	})
});
function requestOptions$5(input) {
	return {
		...input.requestContext === void 0 ? {} : { requestContext: input.requestContext },
		...input.signal === void 0 ? {} : { signal: input.signal },
		...input.timeoutMs === void 0 ? {} : { timeoutMs: input.timeoutMs }
	};
}
function requestBody(input) {
	const { target: _target, requestContext: _requestContext, signal: _signal, timeoutMs: _timeoutMs, ...body } = input;
	return body;
}
function projectControlPath(input, action) {
	if (!input.target) return buildLocalProjectControlPath(action);
	const target = requireValidInput$4(peopleComputerTargetSchema, input.target);
	return `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/projects/${action}`;
}
function requireValidInput$4(schema, value) {
	const parsed = schema.safeParse(value);
	if (!parsed.success) throw new Error(`Local Project control request is invalid. ${parsed.error.issues[0]?.message ?? "Invalid input."}`);
	return parsed.data;
}
//#endregion
//#region src/local-runtime/api.ts
const LOCAL_RUNTIME_EXPECTED_ROUTES_PATH = "/v1/local-runtime/expected-routes";
function buildExpectedRoutesUrl(input) {
	const parsed = getLocalRuntimeExpectedRoutesQuerySchema.safeParse({
		contractVersion: input.contractVersion,
		deviceId: input.deviceId,
		lane: input.lane
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid local runtime expected-routes query.");
	const searchParams = new URLSearchParams();
	if (parsed.data.contractVersion) searchParams.set("contractVersion", parsed.data.contractVersion);
	searchParams.set("deviceId", parsed.data.deviceId);
	searchParams.set("lane", parsed.data.lane);
	return `${LOCAL_RUNTIME_EXPECTED_ROUTES_PATH}?${searchParams.toString()}`;
}
function createLocalRuntimeExpectedRoutesApi(client) {
	return { getExpectedRoutes: async (input) => await client.requestJson({
		invalidMessage: "Invalid local runtime expected-routes response.",
		method: "GET",
		operation: "local_runtime.expected_routes.read",
		requestContext: input.requestContext,
		schema: getLocalRuntimeExpectedRoutesResponseSchema,
		url: buildExpectedRoutesUrl(input)
	}) };
}
//#endregion
//#region src/organization/routes.ts
function buildCurrentOrganizationDirectoryPath(input) {
	const path = "/v1/organizations/current/directory";
	const query = new URLSearchParams();
	if (input?.agentProfileWorkRecoveryVersion === 2) query.set(ORGANIZATION_DIRECTORY_AGENT_PROFILE_WORK_RECOVERY_VERSION_QUERY_PARAMETER, "2");
	if (input?.includeMemberLastActiveAt === true) query.set(ORGANIZATION_DIRECTORY_INCLUDE_MEMBER_LAST_ACTIVE_AT_QUERY_PARAMETER, "true");
	const queryString = query.toString();
	return queryString ? `${path}?${queryString}` : path;
}
function buildCurrentOrganizationComputersPath(input) {
	const path = "/v1/organizations/current/computers";
	return input?.includeUsageLimits === "true" ? `${path}?includeUsageLimits=true` : path;
}
function buildCurrentOrganizationMemberOpenMeldServiceStatusesPath() {
	return "/v1/organizations/current/member-openmeld-service-statuses";
}
function buildCurrentOrganizationSpacesPath() {
	return "/v1/organizations/current/spaces";
}
function buildCurrentOrganizationSpacesWithMemberCountsPath() {
	return "/v1/organizations/current/spaces-with-member-counts";
}
function buildCurrentOrganizationMessageChannelsPath() {
	return "/v1/organizations/current/message-channels";
}
function buildCurrentOrganizationMessageChannelSetupRequestsPath() {
	return `${buildCurrentOrganizationMessageChannelsPath()}/setup-requests`;
}
function buildCurrentOrganizationMessageChannelIdentityLinkPath(identityLinkId) {
	return `${buildCurrentOrganizationMessageChannelsPath()}/identity-links/${encodeURIComponent(identityLinkId)}`;
}
function buildCurrentOrganizationMessageChannelRegistrationsPath() {
	return `${buildCurrentOrganizationMessageChannelsPath()}/registrations`;
}
function buildMessageChannelIdentityLinkPreviewPath() {
	return "/v1/message-channels/identity-link/preview";
}
function buildMessageChannelIdentityLinkConsumePath() {
	return "/v1/message-channels/identity-link/consume";
}
function buildCurrentOrganizationMessageChannelPath(provider) {
	return `${buildCurrentOrganizationMessageChannelsPath()}/${encodeURIComponent(provider)}`;
}
function buildCurrentOrganizationMessageChannelRegistrationPath(provider) {
	return `${buildCurrentOrganizationMessageChannelPath(provider)}/registration-attempts`;
}
function buildCurrentOrganizationMessageChannelRegistrationPollPath(provider, attemptId) {
	return `${buildCurrentOrganizationMessageChannelRegistrationPath(provider)}/${encodeURIComponent(attemptId)}/poll`;
}
function buildCurrentOrganizationLogoPath() {
	return "/v1/organizations/current/logo";
}
function buildCurrentOrganizationCenterAgentMemoryWipeSelfPath() {
	return "/v1/organizations/current/center-agent-memory/wipe-self";
}
function buildCurrentOrganizationCenterAgentMemoryPolicyPath() {
	return "/v1/organizations/current/center-agent-memory/organization-policy";
}
function buildCurrentOrganizationInformationProtectionPath() {
	return "/v1/organizations/current/information-protection";
}
function buildAgentProfileCreationDefaultsPath(organizationId, agentControllerRef) {
	return `/v1/organizations/${encodeURIComponent(organizationId)}/agent-profile-creation-defaults/${encodeURIComponent(agentControllerRef)}`;
}
function buildAgentProfileCreationRequestsPath(organizationId, selector) {
	const path = `/v1/organizations/${encodeURIComponent(organizationId)}/agent-profile-creation-requests`;
	const query = new URLSearchParams();
	if (selector?.requestId) query.set("requestId", selector.requestId);
	if (selector?.idempotencyKey) query.set("idempotencyKey", selector.idempotencyKey);
	return query.size ? `${path}?${query}` : path;
}
function buildAgentProfileCreationRequestPath(organizationId, requestId) {
	return `${buildAgentProfileCreationRequestsPath(organizationId)}/${encodeURIComponent(requestId)}`;
}
function buildAgentProfileCreationRequestDecisionPath(organizationId, requestId) {
	return `${buildAgentProfileCreationRequestPath(organizationId, requestId)}/decision`;
}
function buildAgentProfileCreationRequestCancelPath(organizationId, requestId) {
	return `${buildAgentProfileCreationRequestPath(organizationId, requestId)}/cancel`;
}
function buildAgentProfileCreationRequestRetryPath(organizationId, requestId) {
	return `${buildAgentProfileCreationRequestPath(organizationId, requestId)}/retry`;
}
function buildAgentProfileCreationApprovalPreferencePath(organizationId) {
	return `/v1/organizations/${encodeURIComponent(organizationId)}/agent-profile-creation-approval-preference`;
}
//#endregion
//#region src/organization/api.ts
const createOrganizationApi = (client) => ({
	createAgentProfileCreationRequest: async (input) => {
		const body = createAgentProfileCreationRequestBodySchema.parse({
			configuration: input.configuration,
			idempotencyKey: input.idempotencyKey,
			nativeSessionId: input.nativeSessionId,
			profileName: input.profileName,
			requestedSpaceId: input.requestedSpaceId,
			sessionStrategy: input.sessionStrategy,
			source: input.source,
			targetOwnerUserId: input.targetOwnerUserId
		});
		try {
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "invalid Agent Profile creation request response",
				method: "POST",
				operation: "agent_profile.creation_request.create",
				requestContext: input.requestContext,
				schema: createAgentProfileCreationRequestResponseSchema,
				signal: input.signal,
				timeoutMs: input.timeoutMs,
				url: buildAgentProfileCreationRequestsPath(input.organizationId)
			});
		} catch (error) {
			const failure = toStructuredApiClientFailure(error);
			if (input.signal?.aborted || failure.status !== null && failure.status >= 400 && failure.status < 500 && failure.status !== 408) throw error;
			const recovered = await client.requestJson({
				method: "GET",
				operation: "agent_profile.creation_request.recover",
				requestContext: input.requestContext,
				schema: listAgentProfileCreationRequestsResponseSchema,
				signal: input.signal,
				timeoutMs: input.timeoutMs,
				invalidMessage: "invalid Agent Profile creation request recovery response",
				url: buildAgentProfileCreationRequestsPath(input.organizationId, { idempotencyKey: body.idempotencyKey })
			}).catch(() => null);
			const request = recovered?.matchedIdempotencyKey === body.idempotencyKey && recovered.requests.length === 1 ? recovered.requests[0] : void 0;
			if (request && request.organizationId === input.organizationId && JSON.stringify(agentProfileCreationIntentSchema.parse({
				...request,
				idempotencyKey: body.idempotencyKey
			})) === JSON.stringify(agentProfileCreationIntentSchema.parse(body))) return {
				replayed: true,
				request
			};
			throw Object.assign(new Error("The request may still be creating the Agent. Try again to check the same request.", { cause: error }), {
				code: "agent_profile.creation_request.outcome_unknown",
				requestId: failure.requestId,
				idempotencyKey: body.idempotencyKey
			});
		}
	},
	listAgentProfileCreationRequests: async (input) => await client.requestJson({
		invalidMessage: "invalid Agent Profile creation request list response",
		method: "GET",
		operation: "agent_profile.creation_request.list",
		requestContext: input.requestContext,
		schema: listAgentProfileCreationRequestsResponseSchema,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		url: buildAgentProfileCreationRequestsPath(input.organizationId, input)
	}),
	decideAgentProfileCreationRequest: async (input) => {
		const body = decideAgentProfileCreationRequestBodySchema.parse({ decision: input.decision });
		return await client.requestJson({
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Agent Profile creation request decision response",
			method: "POST",
			operation: "agent_profile.creation_request.decide",
			requestContext: input.requestContext,
			schema: agentProfileCreationRequestMutationResponseSchema,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			url: buildAgentProfileCreationRequestDecisionPath(input.organizationId, input.requestId)
		});
	},
	cancelAgentProfileCreationRequest: async (input) => await client.requestJson({
		invalidMessage: "invalid Agent Profile creation request cancel response",
		method: "POST",
		operation: "agent_profile.creation_request.cancel",
		requestContext: input.requestContext,
		schema: agentProfileCreationRequestMutationResponseSchema,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		url: buildAgentProfileCreationRequestCancelPath(input.organizationId, input.requestId)
	}),
	retryAgentProfileCreationRequest: async (input) => await client.requestJson({
		invalidMessage: "invalid Agent Profile creation request retry response",
		method: "POST",
		operation: "agent_profile.creation_request.retry",
		requestContext: input.requestContext,
		schema: agentProfileCreationRequestMutationResponseSchema,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		url: buildAgentProfileCreationRequestRetryPath(input.organizationId, input.requestId)
	}),
	getAgentProfileCreationApprovalPreference: async (input) => await client.requestJson({
		invalidMessage: "invalid Agent Profile creation approval preference response",
		method: "GET",
		operation: "agent_profile.creation_approval_preference.read",
		requestContext: input.requestContext,
		schema: getAgentProfileCreationApprovalPreferenceResponseSchema,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		url: buildAgentProfileCreationApprovalPreferencePath(input.organizationId)
	}),
	setAgentProfileCreationApprovalPreference: async (input) => {
		const body = setAgentProfileCreationApprovalPreferenceBodySchema.parse({
			existingSessionPolicy: input.existingSessionPolicy,
			newSessionPolicy: input.newSessionPolicy
		});
		return await client.requestJson({
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Agent Profile creation approval preference response",
			method: "PUT",
			operation: "agent_profile.creation_approval_preference.write",
			requestContext: input.requestContext,
			schema: setAgentProfileCreationApprovalPreferenceResponseSchema,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			url: buildAgentProfileCreationApprovalPreferencePath(input.organizationId)
		});
	},
	getAgentProfileCreationDefaults: async (input) => await client.requestJson({
		url: buildAgentProfileCreationDefaultsPath(input.organizationId, input.agentControllerRef),
		operation: "agent_profile.creation_defaults.read",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: getAgentProfileCreationDefaultsResponseSchema,
		invalidMessage: "invalid Agent Profile creation defaults response"
	}),
	updateCurrentLogo: async (input) => {
		const mimeType = organizationLogoMimeTypeSchema.parse(input.mimeType);
		const body = toOrganizationLogoBody(input.bytes);
		const sizeBytes = body instanceof Blob ? body.size : body.byteLength;
		if (sizeBytes < 1 || sizeBytes > ORGANIZATION_LOGO_MAX_SIZE_BYTES) throw new Error("invalid Organization logo size");
		return await client.requestJson({
			url: buildCurrentOrganizationLogoPath(),
			operation: "organization.logo.update",
			method: "PUT",
			requestContext: input.requestContext,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			headers: { "content-type": mimeType },
			body,
			schema: organizationLogoResponseSchema,
			invalidMessage: "invalid Organization logo update response"
		});
	},
	removeCurrentLogo: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationLogoPath(),
		operation: "organization.logo.remove",
		method: "DELETE",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: organizationLogoResponseSchema,
		invalidMessage: "invalid Organization logo removal response"
	}),
	getCurrentDirectory: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationDirectoryPath({
			agentProfileWorkRecoveryVersion: input.agentProfileWorkRecoveryVersion ?? 2,
			includeMemberLastActiveAt: input.includeMemberLastActiveAt
		}),
		operation: "organization.directory.read",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: organizationDirectoryResponseSchema,
		invalidMessage: "invalid Organization directory response"
	}),
	getCurrentComputers: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationComputersPath({ includeUsageLimits: input.includeUsageLimits }),
		operation: "organization.computers.read",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: organizationComputersResponseSchema,
		invalidMessage: "invalid Organization computers response"
	}),
	getCurrentMemberOpenMeldServiceStatuses: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationMemberOpenMeldServiceStatusesPath(),
		operation: "organization.member_service_statuses.read",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: organizationMemberOpenMeldServiceStatusesResponseSchema,
		invalidMessage: "invalid Organization member OpenMeld Service statuses response"
	}),
	listCurrentSpaces: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationSpacesPath(),
		operation: "organization.spaces.list",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: organizationSpaceDirectoryResponseSchema,
		invalidMessage: "invalid Organization Space directory response"
	}),
	listCurrentSpacesWithMemberCounts: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationSpacesWithMemberCountsPath(),
		operation: "organization.spaces_with_member_counts.list",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: organizationSpaceDirectoryWithMemberCountsResponseSchema,
		invalidMessage: "invalid Organization Space directory with member counts response"
	}),
	listCurrentMessageChannels: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationMessageChannelsPath(),
		operation: "organization.message_channels.list",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: messageChannelConnectionListResponseSchema,
		invalidMessage: "invalid Organization Message Channels response"
	}),
	requestMessageChannelSetup: async (input) => {
		const body = messageChannelSetupRequestBodySchema.parse({ provider: input.provider });
		return await client.requestJson({
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Message Channel setup request response",
			method: "POST",
			operation: "organization.message_channel.setup.request",
			requestContext: input.requestContext,
			schema: messageChannelSetupRequestResponseSchema,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			url: buildCurrentOrganizationMessageChannelSetupRequestsPath()
		});
	},
	disconnectMessageChannelIdentityLink: async (input) => await client.requestJson({
		url: buildCurrentOrganizationMessageChannelIdentityLinkPath(input.identityLinkId),
		operation: "organization.message_channel.identity_link.disconnect",
		method: "DELETE",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: messageChannelConnectionListResponseSchema,
		invalidMessage: "invalid Message Channel identity link disconnect response"
	}),
	listCurrentLarkPlatformRegistrations: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationMessageChannelRegistrationsPath(),
		operation: "organization.message_channel_registrations.list",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: larkPlatformActiveRegistrationListResponseSchema,
		invalidMessage: "invalid Organization Message Channel registrations response"
	}),
	previewMessageChannelIdentityLink: async (input) => {
		const body = messageChannelIdentityLinkPreviewBodySchema.parse({ token: input.token });
		return await client.requestJson({
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Message Channel identity link preview response",
			method: "POST",
			operation: "organization.message_channel.identity_link.preview",
			requestContext: input.requestContext,
			schema: messageChannelIdentityLinkPreviewResponseSchema,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			url: buildMessageChannelIdentityLinkPreviewPath()
		});
	},
	consumeMessageChannelIdentityLink: async (input) => {
		const body = messageChannelIdentityLinkConsumeBodySchema.parse({ token: input.token });
		return await client.requestJson({
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Message Channel identity link consume response",
			method: "POST",
			operation: "organization.message_channel.identity_link.consume",
			requestContext: input.requestContext,
			schema: messageChannelIdentityLinkConsumeResponseSchema,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			url: buildMessageChannelIdentityLinkConsumePath()
		});
	},
	beginLarkPlatformRegistration: async (input) => {
		const provider = larkPlatformProviderSchema.parse(input.provider);
		const mode = larkPlatformRegistrationBeginModeSchema.parse(input.mode ?? "resume");
		const path = buildCurrentOrganizationMessageChannelRegistrationPath(provider);
		return await client.requestJson({
			url: mode === "resume" ? path : `${path}?mode=${mode}`,
			operation: "organization.message_channel.registration.begin",
			method: "POST",
			requestContext: input.requestContext,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			schema: larkPlatformRegistrationResponseSchema,
			invalidMessage: "invalid Message Channel registration response"
		});
	},
	pollLarkPlatformRegistration: async (input) => {
		const provider = larkPlatformProviderSchema.parse(input.provider);
		const attemptId = larkPlatformRegistrationAttemptIdSchema.parse(input.attemptId);
		return await client.requestJson({
			url: buildCurrentOrganizationMessageChannelRegistrationPollPath(provider, attemptId),
			operation: "organization.message_channel.registration.poll",
			method: "POST",
			requestContext: input.requestContext,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			schema: larkPlatformRegistrationResponseSchema,
			invalidMessage: "invalid Message Channel registration poll response"
		});
	},
	disconnectLarkPlatform: async (input) => {
		const provider = larkPlatformProviderSchema.parse(input.provider);
		return await client.requestJson({
			url: buildCurrentOrganizationMessageChannelPath(provider),
			operation: "organization.message_channel.disconnect",
			method: "DELETE",
			requestContext: input.requestContext,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			schema: messageChannelConnectionListResponseSchema,
			invalidMessage: "invalid Message Channel disconnect response"
		});
	},
	wipeCurrentMemberCenterAgentMemory: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationCenterAgentMemoryWipeSelfPath(),
		operation: "organization.center_agent_memory.wipe_self",
		method: "POST",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: centerAgentWipeMemberMemoryResponseSchema,
		invalidMessage: "invalid Center Agent memory wipe response"
	}),
	readCurrentOrganizationCenterAgentMemoryPolicy: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationCenterAgentMemoryPolicyPath(),
		operation: "organization.center_agent_memory.organization_policy.read",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: centerAgentOrganizationMemoryPolicyResponseSchema,
		invalidMessage: "invalid Center Agent organization memory policy response"
	}),
	setCurrentOrganizationCenterAgentMemoryPolicy: async (input) => {
		const body = updateCenterAgentOrganizationMemoryPolicyBodySchema.parse({ organizationMemoryOptIn: input.organizationMemoryOptIn });
		return await client.requestJson({
			url: buildCurrentOrganizationCenterAgentMemoryPolicyPath(),
			operation: "organization.center_agent_memory.organization_policy.write",
			method: "PUT",
			requestContext: input.requestContext,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify(body),
			schema: centerAgentOrganizationMemoryPolicyResponseSchema,
			invalidMessage: "invalid Center Agent organization memory policy response"
		});
	},
	readCurrentInformationProtection: async (input = {}) => await client.requestJson({
		url: buildCurrentOrganizationInformationProtectionPath(),
		operation: "organization.information_protection.read",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: organizationInformationProtectionPolicyResponseSchema,
		invalidMessage: "invalid Organization information protection policy response"
	}),
	setCurrentInformationProtection: async (input) => {
		const body = updateOrganizationInformationProtectionPolicyBodySchema.parse({ protectedInformation: input.protectedInformation });
		return await client.requestJson({
			url: buildCurrentOrganizationInformationProtectionPath(),
			operation: "organization.information_protection.write",
			method: "PUT",
			requestContext: input.requestContext,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify(body),
			schema: organizationInformationProtectionPolicyResponseSchema,
			invalidMessage: "invalid Organization information protection policy response"
		});
	},
	setAgentProfileCreationDefaults: async (input) => {
		const body = setAgentProfileCreationDefaultsBodySchema.parse({
			agentControllerCollaborationMode: input.agentControllerCollaborationMode,
			agentControllerPermissionMode: input.agentControllerPermissionMode,
			defaultProjectId: input.defaultProjectId,
			modelId: input.modelId,
			openCodePermission: input.openCodePermission,
			reasoningLevel: input.reasoningLevel
		});
		return await client.requestJson({
			url: buildAgentProfileCreationDefaultsPath(input.organizationId, input.agentControllerRef),
			operation: "agent_profile.creation_defaults.write",
			method: "PUT",
			requestContext: input.requestContext,
			signal: input.signal,
			timeoutMs: input.timeoutMs,
			headers: { "content-type": "application/json" },
			body: JSON.stringify(body),
			schema: setAgentProfileCreationDefaultsResponseSchema,
			invalidMessage: "invalid Agent Profile creation defaults response"
		});
	}
});
function toOrganizationLogoBody(bytes) {
	if (bytes instanceof Blob || bytes instanceof ArrayBuffer) return bytes;
	const copy = new Uint8Array(bytes.byteLength);
	copy.set(bytes);
	return copy.buffer;
}
//#endregion
//#region src/organization-documents/routes.ts
const DOCUMENTS_PATH = "/v1/organizations/current/documents";
const MEMBER_RESEARCH_PATH = "/v1/organizations/current/member-research";
function buildOrganizationDocumentsPath() {
	return DOCUMENTS_PATH;
}
function buildCenterAgentMemberResearchPath() {
	return MEMBER_RESEARCH_PATH;
}
function buildOrganizationDocumentPath(documentId) {
	return `${DOCUMENTS_PATH}/${encodeURIComponent(documentId)}`;
}
function buildOrganizationDocumentFoldersPath() {
	return `${DOCUMENTS_PATH}/folders`;
}
function buildOrganizationDocumentFolderPath(folderId) {
	return `${DOCUMENTS_PATH}/folders/${encodeURIComponent(folderId)}`;
}
function buildOrganizationDocumentApproveDraftPath(documentId) {
	return `${buildOrganizationDocumentPath(documentId)}/approve-draft`;
}
function buildOrganizationDocumentDiscardDraftPath(documentId) {
	return `${buildOrganizationDocumentPath(documentId)}/discard-draft`;
}
//#endregion
//#region src/organization-documents/api.ts
const createOrganizationDocumentsApi = (client) => ({
	getMemberResearchStatus: async (input = {}) => await client.requestJson({
		...requestOptions$4(input),
		invalidMessage: "invalid Center Agent member research status response",
		method: "GET",
		operation: "center_agent_member_research.status",
		schema: getCenterAgentMemberResearchStatusResponseSchema,
		url: buildCenterAgentMemberResearchPath()
	}),
	startMemberResearch: async (input) => {
		const body = requireValidInput$3(startCenterAgentMemberResearchBodySchema, input.scope === "member" ? {
			expectedOrganizationId: input.expectedOrganizationId,
			scope: input.scope,
			subjectUserId: input.subjectUserId
		} : {
			expectedOrganizationId: input.expectedOrganizationId,
			scope: input.scope
		}, "Center Agent member research request is invalid.");
		return await client.requestJson({
			...requestOptions$4(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Center Agent member research response",
			method: "POST",
			operation: "center_agent_member_research.start",
			schema: startCenterAgentMemberResearchResponseSchema,
			url: buildCenterAgentMemberResearchPath()
		});
	},
	list: async (input = {}) => await client.requestJson({
		...requestOptions$4(input),
		invalidMessage: "invalid Organization documents response",
		method: "GET",
		operation: "organization_document.list",
		schema: listOrganizationDocumentsResponseSchema,
		url: buildOrganizationDocumentsPath()
	}),
	get: async (input) => await client.requestJson({
		...requestOptions$4(input),
		invalidMessage: "invalid Organization document response",
		method: "GET",
		operation: "organization_document.get",
		schema: getOrganizationDocumentResponseSchema,
		url: buildOrganizationDocumentPath(requireDocumentId(input.documentId))
	}),
	create: async (input) => {
		const body = requireValidInput$3(createOrganizationDocumentBodySchema, {
			content: input.content,
			expectedOrganizationId: input.expectedOrganizationId,
			kind: input.kind,
			...input.folderId === void 0 ? {} : { folderId: input.folderId },
			...input.subjectUserId === void 0 ? {} : { subjectUserId: input.subjectUserId },
			...input.title === void 0 ? {} : { title: input.title }
		}, "Organization document create request is invalid.");
		return await client.requestJson({
			...requestOptions$4(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Organization document create response",
			method: "POST",
			operation: "organization_document.create",
			schema: createOrganizationDocumentResponseSchema,
			url: buildOrganizationDocumentsPath()
		});
	},
	update: async (input) => {
		const body = requireValidInput$3(updateOrganizationDocumentBodySchema, {
			...input.content === void 0 ? {} : { content: input.content },
			...input.expectedDocumentUpdatedAt === void 0 ? {} : { expectedDocumentUpdatedAt: input.expectedDocumentUpdatedAt },
			...input.expectedDraftCreatedAt === void 0 ? {} : { expectedDraftCreatedAt: input.expectedDraftCreatedAt },
			expectedOrganizationId: input.expectedOrganizationId,
			...input.folderId === void 0 ? {} : { folderId: input.folderId },
			...input.title === void 0 ? {} : { title: input.title }
		}, "Organization document update request is invalid.");
		return await client.requestJson({
			...requestOptions$4(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Organization document update response",
			method: "PATCH",
			operation: "organization_document.update",
			schema: updateOrganizationDocumentResponseSchema,
			url: buildOrganizationDocumentPath(requireDocumentId(input.documentId))
		});
	},
	delete: async (input) => await client.requestJson({
		...requestOptions$4(input),
		body: JSON.stringify({ expectedOrganizationId: input.expectedOrganizationId }),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid Organization document delete response",
		method: "DELETE",
		operation: "organization_document.delete",
		schema: deleteOrganizationDocumentResponseSchema,
		url: buildOrganizationDocumentPath(requireDocumentId(input.documentId))
	}),
	createFolder: async (input) => {
		const body = requireValidInput$3(createOrganizationDocumentFolderBodySchema, {
			expectedOrganizationId: input.expectedOrganizationId,
			name: input.name,
			...input.parentFolderId === void 0 ? {} : { parentFolderId: input.parentFolderId }
		}, "Organization document folder create request is invalid.");
		return await client.requestJson({
			...requestOptions$4(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Organization document folder create response",
			method: "POST",
			operation: "organization_document.create_folder",
			schema: createOrganizationDocumentFolderResponseSchema,
			url: buildOrganizationDocumentFoldersPath()
		});
	},
	updateFolder: async (input) => {
		const body = requireValidInput$3(updateOrganizationDocumentFolderBodySchema, {
			expectedOrganizationId: input.expectedOrganizationId,
			...input.name === void 0 ? {} : { name: input.name },
			...input.parentFolderId === void 0 ? {} : { parentFolderId: input.parentFolderId }
		}, "Organization document folder update request is invalid.");
		return await client.requestJson({
			...requestOptions$4(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Organization document folder update response",
			method: "PATCH",
			operation: "organization_document.update_folder",
			schema: updateOrganizationDocumentFolderResponseSchema,
			url: buildOrganizationDocumentFolderPath(requireFolderId(input.folderId))
		});
	},
	deleteFolder: async (input) => await client.requestJson({
		...requestOptions$4(input),
		body: JSON.stringify({ expectedOrganizationId: input.expectedOrganizationId }),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid Organization document folder delete response",
		method: "DELETE",
		operation: "organization_document.delete_folder",
		schema: deleteOrganizationDocumentFolderResponseSchema,
		url: buildOrganizationDocumentFolderPath(requireFolderId(input.folderId))
	}),
	approveDraft: async (input) => await client.requestJson({
		...requestOptions$4(input),
		body: JSON.stringify({
			expectedDraftCreatedAt: input.expectedDraftCreatedAt,
			expectedOrganizationId: input.expectedOrganizationId
		}),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid Organization document approval response",
		method: "POST",
		operation: "organization_document.approve_draft",
		schema: approveOrganizationDocumentDraftResponseSchema,
		url: buildOrganizationDocumentApproveDraftPath(requireDocumentId(input.documentId))
	}),
	discardDraft: async (input) => await client.requestJson({
		...requestOptions$4(input),
		body: JSON.stringify({
			expectedDraftCreatedAt: input.expectedDraftCreatedAt,
			expectedOrganizationId: input.expectedOrganizationId
		}),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid Organization document discard response",
		method: "POST",
		operation: "organization_document.discard_draft",
		schema: discardOrganizationDocumentDraftResponseSchema,
		url: buildOrganizationDocumentDiscardDraftPath(requireDocumentId(input.documentId))
	})
});
function requireDocumentId(value) {
	return requireValidInput$3(organizationDocumentRouteParamsSchema, { documentId: value }, "Organization document identifier is invalid.").documentId;
}
function requireFolderId(value) {
	return requireValidInput$3(organizationDocumentFolderRouteParamsSchema, { folderId: value }, "Organization document folder identifier is invalid.").folderId;
}
function requestOptions$4(input) {
	return {
		...input.requestContext === void 0 ? {} : { requestContext: input.requestContext },
		...input.signal === void 0 ? {} : { signal: input.signal },
		...input.timeoutMs === void 0 ? {} : { timeoutMs: input.timeoutMs }
	};
}
function requireValidInput$3(schema, value, message) {
	const parsed = schema.safeParse(value);
	if (!parsed.success) throw new Error(`${message} ${parsed.error.issues[0]?.message ?? "Invalid input."}`);
	return parsed.data;
}
//#endregion
//#region src/organization-skills/routes.ts
const SKILLS_PATH = "/v1/organizations/current/skills";
function buildOrganizationSkillsPath() {
	return SKILLS_PATH;
}
function buildOrganizationSkillPath(skillId) {
	return `${SKILLS_PATH}/${encodeURIComponent(skillId)}`;
}
function buildOrganizationSkillGitHubImportPath() {
	return `${SKILLS_PATH}/import-github`;
}
function buildOrganizationSkillGitHubPreviewPath() {
	return `${SKILLS_PATH}/preview-github`;
}
function buildOrganizationSkillEnabledPath(skillId) {
	return `${buildOrganizationSkillPath(skillId)}/enabled`;
}
function buildOrganizationSkillMaintainersPath(skillId) {
	return `${buildOrganizationSkillPath(skillId)}/maintainers`;
}
//#endregion
//#region src/organization-skills/api.ts
const createOrganizationSkillsApi = (client) => ({
	list: async (input = {}) => await client.requestJson({
		...requestOptions$3(input),
		invalidMessage: "invalid Organization Skills response",
		method: "GET",
		operation: "organization_skill.list",
		schema: listOrganizationSkillsResponseSchema,
		url: buildOrganizationSkillsPath()
	}),
	get: async (input) => await client.requestJson({
		...requestOptions$3(input),
		invalidMessage: "invalid Organization Skill response",
		method: "GET",
		operation: "organization_skill.get",
		schema: getOrganizationSkillResponseSchema,
		url: `${buildOrganizationSkillPath(requireSkillId(input.skillId))}${input.releaseId === void 0 ? "" : `?releaseId=${encodeURIComponent(input.releaseId)}`}`
	}),
	create: async (input) => {
		const body = requireValidInput$2(createOrganizationSkillBodySchema, {
			description: input.description,
			expectedOrganizationId: input.expectedOrganizationId,
			instructions: input.instructions,
			name: input.name
		}, "Organization Skill create request is invalid.");
		return await client.requestJson({
			...requestOptions$3(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Organization Skill create response",
			method: "POST",
			operation: "organization_skill.create",
			schema: createOrganizationSkillResponseSchema,
			url: buildOrganizationSkillsPath()
		});
	},
	importFromGitHub: async (input) => {
		const body = requireValidInput$2(importOrganizationSkillFromGitHubBodySchema, {
			...input.expectedCommitSha === void 0 ? {} : { expectedCommitSha: input.expectedCommitSha },
			expectedOrganizationId: input.expectedOrganizationId,
			url: input.url
		}, "Organization Skill GitHub import request is invalid.");
		return await client.requestJson({
			...requestOptions$3(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Organization Skill GitHub import response",
			method: "POST",
			operation: "organization_skill.import_github",
			schema: importOrganizationSkillFromGitHubResponseSchema,
			url: buildOrganizationSkillGitHubImportPath()
		});
	},
	previewFromGitHub: async (input) => {
		const body = requireValidInput$2(previewOrganizationSkillFromGitHubBodySchema, {
			expectedOrganizationId: input.expectedOrganizationId,
			url: input.url
		}, "Organization Skill GitHub preview request is invalid.");
		return await client.requestJson({
			...requestOptions$3(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Organization Skill GitHub preview response",
			method: "POST",
			operation: "organization_skill.preview_github",
			schema: previewOrganizationSkillFromGitHubResponseSchema,
			url: buildOrganizationSkillGitHubPreviewPath()
		});
	},
	update: async (input) => {
		const body = requireValidInput$2(updateOrganizationSkillBodySchema, {
			bundle: input.bundle,
			expectedActiveReleaseId: input.expectedActiveReleaseId,
			expectedOrganizationId: input.expectedOrganizationId,
			expectedVersion: input.expectedVersion
		}, "Organization Skill update request is invalid.");
		return await client.requestJson({
			...requestOptions$3(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Organization Skill update response",
			method: "PATCH",
			operation: "organization_skill.update",
			schema: updateOrganizationSkillResponseSchema,
			url: buildOrganizationSkillPath(requireSkillId(input.skillId))
		});
	},
	setEnabled: async (input) => {
		const skillId = requireSkillId(input.skillId);
		const body = requireValidInput$2(setOrganizationSkillEnabledBodySchema, {
			enabled: input.enabled,
			expectedOrganizationId: input.expectedOrganizationId,
			expectedVersion: input.expectedVersion
		}, "Organization Skill enabled request is invalid.");
		return await client.requestJson({
			...requestOptions$3(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Organization Skill enabled response",
			method: "PATCH",
			operation: "organization_skill.set_enabled",
			schema: setOrganizationSkillEnabledResponseSchema,
			url: buildOrganizationSkillEnabledPath(skillId)
		});
	},
	setMaintainers: async (input) => {
		const skillId = requireSkillId(input.skillId);
		const body = requireValidInput$2(setOrganizationSkillMaintainersBodySchema, {
			expectedOrganizationId: input.expectedOrganizationId,
			expectedVersion: input.expectedVersion,
			maintainerUserIds: input.maintainerUserIds
		}, "Organization Skill maintainers request is invalid.");
		return await client.requestJson({
			...requestOptions$3(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Organization Skill maintainers response",
			method: "PUT",
			operation: "organization_skill.set_maintainers",
			schema: setOrganizationSkillMaintainersResponseSchema,
			url: buildOrganizationSkillMaintainersPath(skillId)
		});
	},
	delete: async (input) => {
		const body = requireValidInput$2(deleteOrganizationSkillBodySchema, {
			expectedOrganizationId: input.expectedOrganizationId,
			expectedVersion: input.expectedVersion
		}, "Organization Skill delete request is invalid.");
		return await client.requestJson({
			...requestOptions$3(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Organization Skill delete response",
			method: "DELETE",
			operation: "organization_skill.delete",
			schema: deleteOrganizationSkillResponseSchema,
			url: buildOrganizationSkillPath(requireSkillId(input.skillId))
		});
	}
});
function requireSkillId(value) {
	return requireValidInput$2(organizationSkillRouteParamsSchema, { skillId: value }, "Organization Skill identifier is invalid.").skillId;
}
function requestOptions$3(input) {
	return {
		...input.requestContext === void 0 ? {} : { requestContext: input.requestContext },
		...input.signal === void 0 ? {} : { signal: input.signal },
		...input.timeoutMs === void 0 ? {} : { timeoutMs: input.timeoutMs }
	};
}
function requireValidInput$2(schema, value, message) {
	const parsed = schema.safeParse(value);
	if (!parsed.success) throw new Error(`${message} ${parsed.error.issues[0]?.message ?? "Invalid input."}`);
	return parsed.data;
}
//#endregion
//#region src/organization-usage/routes.ts
const ORGANIZATION_USAGE_OVERVIEW_PATH = "/v1/organizations/current/usage/overview";
function buildOrganizationUsageOverviewPath() {
	return ORGANIZATION_USAGE_OVERVIEW_PATH;
}
//#endregion
//#region src/organization-usage/api.ts
const createOrganizationUsageApi = (client) => ({ readOverview: async (input = {}) => await client.requestJson({
	...requestOptions$2(input),
	invalidMessage: "invalid Organization Usage overview response",
	method: "GET",
	operation: "organization_usage.overview.read",
	schema: organizationUsageOverviewResponseSchema,
	url: buildOrganizationUsageOverviewPath()
}) });
function requestOptions$2(input) {
	return {
		...input.requestContext === void 0 ? {} : { requestContext: input.requestContext },
		...input.signal === void 0 ? {} : { signal: input.signal },
		...input.timeoutMs === void 0 ? {} : { timeoutMs: input.timeoutMs }
	};
}
//#endregion
//#region src/plugins/api.ts
function createPluginsApi(client) {
	return { action: async (input) => {
		const request = pluginActionRequestSchema.parse(input.request);
		return await client.requestJson({
			method: "POST",
			operation: "plugins.action",
			timeoutMs: input.request.action.operation === "execute" ? 12e4 : 3e4,
			requestContext: input.requestContext,
			url: `/v1/organizations/current/plugins/actions?expectedOrganizationId=${encodeURIComponent(input.organizationId)}`,
			body: JSON.stringify(request),
			headers: { "content-type": "application/json" },
			schema: pluginActionResponseSchema,
			invalidMessage: "Invalid plugin action response."
		});
	} };
}
//#endregion
//#region src/prepare-readiness/routes.ts
function buildPrepareReadinessRoute(deviceId) {
	return `/v1/devices/${encodeURIComponent(deviceId)}/prepare-readiness`;
}
//#endregion
//#region src/prepare-readiness/api.ts
function requireValidPrepareReadinessQuery(input) {
	const parsed = getPrepareReadinessQuerySchema.safeParse({
		agentControllerRefs: input.agentControllerRefs,
		lane: input.lane,
		openMeldServiceRuntimeId: input.openMeldServiceRuntimeId
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Prepare readiness read query.");
	return parsed.data;
}
function buildPrepareReadinessUrl(input) {
	const query = requireValidPrepareReadinessQuery(input);
	const searchParams = new URLSearchParams();
	searchParams.set("lane", query.lane);
	if (query.openMeldServiceRuntimeId) searchParams.set("openMeldServiceRuntimeId", query.openMeldServiceRuntimeId);
	for (const agentControllerRef of query.agentControllerRefs ?? []) searchParams.append("agentControllerRef", agentControllerRef);
	return `${buildPrepareReadinessRoute(input.deviceId)}?${searchParams.toString()}`;
}
const createPrepareReadinessApi = (client) => {
	return { getReadiness: async (input) => await client.requestJson({
		url: buildPrepareReadinessUrl(input),
		operation: "prepare_readiness.read",
		method: "GET",
		requestContext: input.requestContext,
		schema: getPrepareReadinessResponseSchema,
		invalidMessage: "Invalid Prepare readiness response."
	}) };
};
//#endregion
//#region src/profile-space-history/api.ts
const createProfileSpaceHistoryApi = (client) => {
	return {
		listProfileSpaceHistory: async (input) => {
			return (await client.requestJson({
				url: buildProfileSpaceHistoryListPath(input),
				operation: "profile_space_history.list",
				method: "GET",
				requestContext: input.requestContext,
				timeoutMs: input.timeoutMs,
				schema: listProfileSpaceHistoryResponseSchema,
				invalidMessage: "invalid profile-space-history list response"
			})).items;
		},
		upsertProfileSpaceHistory: async (input) => await client.requestJson({
			url: buildProfileSpaceHistoryUpsertPath(input),
			operation: "profile_space_history.upsert",
			method: "PATCH",
			headers: { "content-type": "application/json" },
			body: JSON.stringify(input.body),
			requestContext: input.requestContext,
			timeoutMs: input.timeoutMs,
			schema: upsertProfileSpaceHistoryResponseSchema,
			invalidMessage: "invalid profile-space-history upsert response"
		}),
		updateProfileSpaceHistoryStatus: async (input) => await client.requestJson({
			url: buildProfileSpaceHistoryStatusPath(input),
			operation: "profile_space_history.status.update",
			method: "PATCH",
			headers: { "content-type": "application/json" },
			body: JSON.stringify(input.body),
			requestContext: input.requestContext,
			timeoutMs: input.timeoutMs,
			schema: patchProfileSpaceHistoryStatusResponseSchema,
			invalidMessage: "invalid profile-space-history status response"
		})
	};
};
//#endregion
//#region src/profiles/routes.ts
function buildProfileRoute(profileId) {
	return `/v1/profiles/${encodeURIComponent(profileId)}`;
}
function buildAgentProfileDefaultProjectRoute(profileId) {
	return `/v1/agent-profiles/${encodeURIComponent(profileId)}/default-project`;
}
//#endregion
//#region src/profiles/api.ts
const createProfilesApi = (client) => ({
	rename: async (input) => {
		const request = requireValidRenameProfileInput(input);
		return await client.requestJson({
			body: JSON.stringify({ profileName: request.profileName }),
			headers: { "content-type": "application/json" },
			invalidMessage: "Invalid Profile rename response.",
			method: "PATCH",
			operation: "profile.rename",
			requestContext: request.requestContext,
			schema: updateProfileResponseSchema,
			url: buildProfileRoute(request.profileId)
		});
	},
	updateDefaultProject: async (input) => {
		const request = requireValidUpdateDefaultProjectInput(input);
		const parsedBody = updateAgentProfileDefaultProjectBodySchema.safeParse({
			defaultProjectId: request.defaultProjectId,
			expectedOrganizationId: request.expectedOrganizationId
		});
		if (!parsedBody.success) throw new Error(`Invalid Agent Profile Default Project request: ${parsedBody.error.message}`);
		return await client.requestJson({
			body: JSON.stringify(parsedBody.data),
			headers: { "content-type": "application/json" },
			invalidMessage: "Invalid Agent Profile default Project response.",
			method: "PATCH",
			operation: "profile.updateDefaultProject",
			requestContext: request.requestContext,
			schema: updateAgentProfileDefaultProjectResponseSchema,
			url: buildAgentProfileDefaultProjectRoute(request.profileId)
		});
	}
});
function requireValidRenameProfileInput(input) {
	return {
		profileId: normalizeRequiredText(input.profileId, "profileId"),
		profileName: normalizeRequiredText(input.profileName, "profileName"),
		...input.requestContext ? { requestContext: input.requestContext } : {}
	};
}
function requireValidUpdateDefaultProjectInput(input) {
	const profileId = normalizeRequiredText(input.profileId, "profileId");
	const expectedOrganizationId = normalizeRequiredText(input.expectedOrganizationId, "expectedOrganizationId");
	return {
		defaultProjectId: input.defaultProjectId === null ? null : normalizeRequiredText(input.defaultProjectId, "defaultProjectId"),
		expectedOrganizationId,
		profileId,
		...input.requestContext ? { requestContext: input.requestContext } : {}
	};
}
function normalizeRequiredText(value, fieldName) {
	const normalized = String(value ?? "").trim();
	if (normalized.length === 0) throw new Error(`${fieldName} is required`);
	return normalized;
}
//#endregion
//#region src/projects/routes.ts
const PROJECTS_PATH = "/v1/organizations/current/projects";
function buildProjectsPath() {
	return PROJECTS_PATH;
}
function buildProjectPath(projectId) {
	return `${PROJECTS_PATH}/${encodeURIComponent(projectId)}`;
}
//#endregion
//#region src/projects/api.ts
const createProjectsApi = (client) => ({
	list: async (input = {}) => await client.requestJson({
		...requestOptions$1(input),
		invalidMessage: "invalid Project list response",
		method: "GET",
		operation: "project.list",
		schema: listProjectsResponseSchema,
		url: buildProjectsPath()
	}),
	create: async (input) => {
		const body = requireValidInput$1(createProjectBodySchema, {
			expectedOrganizationId: input.expectedOrganizationId,
			name: input.name,
			...input.operationId === void 0 ? {} : { operationId: input.operationId },
			...input.repositoryFingerprint === void 0 ? {} : { repositoryFingerprint: input.repositoryFingerprint },
			...input.repositoryUrl === void 0 ? {} : { repositoryUrl: input.repositoryUrl },
			...input.slug === void 0 ? {} : { slug: input.slug }
		}, "Project create request is invalid.");
		return await client.requestJson({
			...requestOptions$1(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Project create response",
			method: "POST",
			operation: "project.create",
			schema: createProjectResponseSchema,
			url: buildProjectsPath()
		});
	},
	update: async (input) => {
		const projectId = requireProjectId(input.projectId);
		const body = requireValidInput$1(updateProjectBodySchema, {
			expectedOrganizationId: input.expectedOrganizationId,
			...input.name === void 0 ? {} : { name: input.name },
			...input.repositoryFingerprint === void 0 ? {} : { repositoryFingerprint: input.repositoryFingerprint },
			...input.repositoryUrl === void 0 ? {} : { repositoryUrl: input.repositoryUrl },
			...input.slug === void 0 ? {} : { slug: input.slug }
		}, "Project update request is invalid.");
		return await client.requestJson({
			...requestOptions$1(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Project update response",
			method: "PATCH",
			operation: "project.update",
			schema: updateProjectResponseSchema,
			url: buildProjectPath(projectId)
		});
	},
	archive: async (input) => {
		const projectId = requireProjectId(input.projectId);
		const body = requireValidInput$1(archiveProjectBodySchema, { expectedOrganizationId: input.expectedOrganizationId }, "Project archive request is invalid.");
		return await client.requestJson({
			...requestOptions$1(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Project archive response",
			method: "DELETE",
			operation: "project.archive",
			schema: archiveProjectResponseSchema,
			url: buildProjectPath(projectId)
		});
	}
});
function requireProjectId(value) {
	return requireValidInput$1(projectRouteParamsSchema, { projectId: value }, "Project identifier is invalid.").projectId;
}
function requestOptions$1(input) {
	return {
		...input.requestContext === void 0 ? {} : { requestContext: input.requestContext },
		...input.signal === void 0 ? {} : { signal: input.signal },
		...input.timeoutMs === void 0 ? {} : { timeoutMs: input.timeoutMs }
	};
}
function requireValidInput$1(schema, value, message) {
	const parsed = schema.safeParse(value);
	if (!parsed.success) throw new Error(`${message} ${parsed.error.issues[0]?.message ?? "Invalid input."}`);
	return parsed.data;
}
//#endregion
//#region src/public-space-urls.ts
function publicSpaceUrls(baseUrl) {
	const normalizedBaseUrl = normalizeApiBaseUrl(baseUrl);
	return {
		status: (spaceId) => buildPublicSpaceUrl(normalizedBaseUrl, spaceId, "status"),
		members: (spaceId) => buildPublicSpaceUrl(normalizedBaseUrl, spaceId, "members"),
		signals: (spaceId) => buildPublicSpaceUrl(normalizedBaseUrl, spaceId, "signals")
	};
}
function buildPublicSpaceUrl(baseUrl, spaceId, segment) {
	const url = new URL(baseUrl);
	url.pathname = `/v1/spaces/${encodeURIComponent(spaceId)}/${segment}`;
	return url.toString();
}
//#endregion
//#region src/reasoning-stream.ts
function createReasoningStreamApi(client) {
	return {
		get: () => client.requestJson({
			method: "GET",
			url: "/v1/account/reasoning-stream",
			operation: "reasoning_stream.preferences.get",
			schema: localAgentReasoningPreferencesSchema,
			invalidMessage: "Invalid reasoning streaming preference."
		}),
		update: (enabled) => client.requestJson({
			method: "PATCH",
			url: "/v1/account/reasoning-stream",
			operation: "reasoning_stream.preferences.update",
			schema: localAgentReasoningPreferencesSchema,
			body: JSON.stringify({ enabled }),
			headers: { "content-type": "application/json" },
			invalidMessage: "Invalid reasoning streaming preference."
		})
	};
}
//#endregion
//#region src/routines/routes.ts
const ROUTINES_PATH = "/v1/organizations/current/routines";
const ROUTINE_TARGET_SPACES_PATH = "/v1/organizations/current/routine-target-spaces";
function buildRoutinesPath(query = {}) {
	return appendRoutineContract(ROUTINES_PATH, query);
}
function buildRoutineTargetSpacesPath() {
	return ROUTINE_TARGET_SPACES_PATH;
}
function buildRoutinePath(routineId, query = {}) {
	return appendRoutineContract(`${ROUTINES_PATH}/${encodeURIComponent(routineId)}`, query);
}
function buildRoutinePausePath(routineId, query = {}) {
	return appendRoutineContract(`${ROUTINES_PATH}/${encodeURIComponent(routineId)}/pause`, query);
}
function buildRoutineResumePath(routineId, query = {}) {
	return appendRoutineContract(`${ROUTINES_PATH}/${encodeURIComponent(routineId)}/resume`, query);
}
function buildRoutineRunsPath(routineId, query = {}) {
	const search = new URLSearchParams();
	if (query.beforeScheduledFor !== void 0) search.set("beforeScheduledFor", String(query.beforeScheduledFor));
	if (query.limit !== void 0) search.set("limit", String(query.limit));
	if (query.contract !== void 0) search.set("contract", query.contract);
	const encodedQuery = search.toString();
	const path = `${buildRoutinePath(routineId)}/runs`;
	return encodedQuery.length > 0 ? `${path}?${encodedQuery}` : path;
}
function appendRoutineContract(path, query) {
	return query.contract ? `${path}?contract=${query.contract}` : path;
}
//#endregion
//#region src/routines/api.ts
const PRACTICAL_ROUTINE_CONTRACT_QUERY = { contract: CENTER_AGENT_ROUTINE_PRACTICAL_CONTRACT };
const MANAGEMENT_ROUTINE_CONTRACT_QUERY = { contract: CENTER_AGENT_ROUTINE_MANAGEMENT_CONTRACT };
const createRoutinesApi = (client) => ({
	listRoutines: async (input = {}) => await client.requestJson({
		...requestOptions(input),
		invalidMessage: "invalid Routine list response",
		method: "GET",
		operation: "routine.list",
		schema: listCenterAgentRoutinesResponseSchema,
		url: buildRoutinesPath(PRACTICAL_ROUTINE_CONTRACT_QUERY)
	}),
	listRoutineManagement: async (input = {}) => await client.requestJson({
		...requestOptions(input),
		invalidMessage: "invalid Routine management response",
		method: "GET",
		operation: "routine.management.list",
		schema: listCenterAgentRoutinesManagementResponseSchema,
		url: buildRoutinesPath(MANAGEMENT_ROUTINE_CONTRACT_QUERY)
	}),
	listRoutineTargetSpaces: async (input = {}) => await client.requestJson({
		...requestOptions(input),
		invalidMessage: "invalid Routine target Space list response",
		method: "GET",
		operation: "routine.target_spaces.list",
		schema: listCenterAgentRoutineTargetSpacesResponseSchema,
		url: buildRoutineTargetSpacesPath()
	}),
	createRoutine: async (input) => {
		const body = requireValidInput(createCenterAgentRoutineBodySchema, {
			authorizedActions: input.authorizedActions,
			cronExpression: input.cronExpression,
			destinationKind: input.destinationKind,
			externalActionPolicy: input.externalActionPolicy,
			instructions: input.instructions,
			name: input.name,
			runAtMs: input.runAtMs,
			scheduleKind: input.scheduleKind,
			slackChannelId: input.slackChannelId,
			slackConversationId: input.slackConversationId,
			slackTeamId: input.slackTeamId,
			slackThreadLabel: input.slackThreadLabel,
			slackThreadTs: input.slackThreadTs,
			targetSpaceId: input.targetSpaceId,
			timezone: input.timezone
		}, "Routine create request is invalid.");
		return await client.requestJson({
			...requestOptions(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Routine create response",
			method: "POST",
			operation: "routine.create",
			schema: createCenterAgentRoutineResponseSchema,
			url: buildRoutinesPath(PRACTICAL_ROUTINE_CONTRACT_QUERY)
		});
	},
	updateRoutine: async (input) => {
		const routineId = requireRoutineId(input.routineId);
		const body = requireValidInput(updateCenterAgentRoutineBodySchema, omitUndefinedValues({
			authorizedActions: input.authorizedActions,
			cronExpression: input.cronExpression,
			destinationKind: input.destinationKind,
			externalActionPolicy: input.externalActionPolicy,
			instructions: input.instructions,
			name: input.name,
			runAtMs: input.runAtMs,
			scheduleKind: input.scheduleKind,
			slackChannelId: input.slackChannelId,
			slackConversationId: input.slackConversationId,
			slackTeamId: input.slackTeamId,
			slackThreadLabel: input.slackThreadLabel,
			slackThreadTs: input.slackThreadTs,
			targetSpaceId: input.targetSpaceId,
			timezone: input.timezone
		}), "Routine update request is invalid.");
		return await client.requestJson({
			...requestOptions(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Routine update response",
			method: "PATCH",
			operation: "routine.update",
			schema: updateCenterAgentRoutineResponseSchema,
			url: buildRoutinePath(routineId, PRACTICAL_ROUTINE_CONTRACT_QUERY)
		});
	},
	pauseRoutine: async (input) => {
		const routineId = requireRoutineId(input.routineId);
		const body = requireValidInput(pauseCenterAgentRoutineBodySchema, {}, "Routine pause request is invalid.");
		return await client.requestJson({
			...requestOptions(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Routine pause response",
			method: "POST",
			operation: "routine.pause",
			schema: pauseCenterAgentRoutineResponseSchema,
			url: buildRoutinePausePath(routineId, PRACTICAL_ROUTINE_CONTRACT_QUERY)
		});
	},
	resumeRoutine: async (input) => {
		const routineId = requireRoutineId(input.routineId);
		const body = requireValidInput(resumeCenterAgentRoutineBodySchema, {}, "Routine resume request is invalid.");
		return await client.requestJson({
			...requestOptions(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Routine resume response",
			method: "POST",
			operation: "routine.resume",
			schema: resumeCenterAgentRoutineResponseSchema,
			url: buildRoutineResumePath(routineId, PRACTICAL_ROUTINE_CONTRACT_QUERY)
		});
	},
	deleteRoutine: async (input) => {
		const routineId = requireRoutineId(input.routineId);
		const body = requireValidInput(deleteCenterAgentRoutineBodySchema, {}, "Routine delete request is invalid.");
		return await client.requestJson({
			...requestOptions(input),
			body: JSON.stringify(body),
			headers: { "content-type": "application/json" },
			invalidMessage: "invalid Routine delete response",
			method: "DELETE",
			operation: "routine.delete",
			schema: deleteCenterAgentRoutineResponseSchema,
			url: buildRoutinePath(routineId, PRACTICAL_ROUTINE_CONTRACT_QUERY)
		});
	},
	listRoutineRuns: async (input) => {
		const routineId = requireRoutineId(input.routineId);
		const query = requireValidInput(listCenterAgentRoutineRunsQuerySchema, {
			...input.beforeScheduledFor === void 0 ? {} : { beforeScheduledFor: String(input.beforeScheduledFor) },
			...input.limit === void 0 ? {} : { limit: String(input.limit) },
			contract: CENTER_AGENT_ROUTINE_PRACTICAL_CONTRACT
		}, "Routine run query is invalid.");
		return await client.requestJson({
			...requestOptions(input),
			invalidMessage: "invalid Routine run list response",
			method: "GET",
			operation: "routine.runs.list",
			schema: listCenterAgentRoutineRunsResponseSchema,
			url: buildRoutineRunsPath(routineId, query)
		});
	}
});
function omitUndefinedValues(input) {
	return Object.fromEntries(Object.entries(input).filter((entry) => entry[1] !== void 0));
}
function requireRoutineId(value) {
	return requireValidInput(centerAgentRoutineRouteParamsSchema, { routineId: value }, "Routine identifier is invalid.").routineId;
}
function requestOptions(input) {
	return {
		...input.requestContext === void 0 ? {} : { requestContext: input.requestContext },
		...input.signal === void 0 ? {} : { signal: input.signal },
		...input.timeoutMs === void 0 ? {} : { timeoutMs: input.timeoutMs }
	};
}
function requireValidInput(schema, value, message) {
	const parsed = schema.safeParse(value);
	if (!parsed.success) throw new TypeError(`${message} ${parsed.error.issues[0]?.message ?? "Invalid value."}`);
	return parsed.data;
}
//#endregion
//#region src/runtime-reporting/routes.ts
const buildRuntimeRegistrationRoute = (deviceId) => `/v1/devices/${encodeURIComponent(deviceId)}/runtime-registration`;
const buildAgentActivityEventsRoute = (deviceId) => `/v1/devices/${encodeURIComponent(deviceId)}/agent-activity-events`;
const buildAgentActivitySessionReconciliationRoute = (deviceId) => `/v1/devices/${encodeURIComponent(deviceId)}/agent-activity-session-reconciliation`;
const buildAgentControllerTaskLifecycleEventsRoute = (deviceId) => `/v1/devices/${encodeURIComponent(deviceId)}/agent-controller-task-lifecycle-events`;
const buildRuntimeAgentControllerReportsRoute = (deviceId) => `/v1/devices/${encodeURIComponent(deviceId)}/runtime-agent-controller-reports/current`;
const buildRuntimeProviderConversationProofsRoute = (deviceId) => `/v1/devices/${encodeURIComponent(deviceId)}/runtime-provider-conversation-proofs/current`;
//#endregion
//#region src/runtime-reporting/api.ts
function requireValidAgentActivityEventsBody(input) {
	const events = input.events.map((event) => {
		const parsed = agentActivityEventSchema.safeParse(event);
		if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Activity event.");
		return parsed.data;
	});
	const parsed = submitAgentActivityEventsBodySchema.safeParse({
		events,
		lane: input.lane,
		openMeldServiceRuntimeId: input.openMeldServiceRuntimeId
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Activity event submission.");
	return parsed.data;
}
function requireValidAgentActivitySessionReconciliationBody(input) {
	const { deviceId: _deviceId, ...body } = input;
	const parsed = submitAgentActivitySessionReconciliationBodySchema.safeParse(body);
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Activity Session reconciliation.");
	return parsed.data;
}
function requireValidRuntimeRegistrationBody(input) {
	const parsed = submitRuntimeRegistrationBodySchema.safeParse({ lane: input.lane });
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Runtime registration payload.");
	return parsed.data;
}
function requireValidAgentControllerTaskLifecycleEventsBody(input) {
	const parsed = submitAgentControllerTaskLifecycleEventsBodySchema.safeParse({
		events: input.events,
		lane: input.lane,
		openMeldServiceRuntimeId: input.openMeldServiceRuntimeId
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Agent Controller task lifecycle event payload.");
	return parsed.data;
}
function requireValidRuntimeAgentControllerReportsBody(input) {
	const parsed = submitRuntimeAgentControllerReportsBodySchema.safeParse({
		lane: input.lane,
		reports: input.reports,
		openMeldServiceRuntimeId: input.openMeldServiceRuntimeId
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Runtime Agent Controller Report payload.");
	return parsed.data;
}
function requireValidRuntimeProviderConversationProofsBody(input) {
	const parsed = submitRuntimeProviderConversationProofsBodySchema.safeParse({
		lane: input.lane,
		proofs: input.proofs,
		openMeldServiceRuntimeId: input.openMeldServiceRuntimeId
	});
	if (!parsed.success) throw new Error(parsed.error.issues[0]?.message ?? "Invalid Provider Conversation Proof payload.");
	return parsed.data;
}
const createRuntimeReportingApi = (client) => {
	return {
		submitAgentActivityEvents: async (input) => {
			const body = requireValidAgentActivityEventsBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Agent Activity event response.",
				method: "PUT",
				operation: "agent_activity.events.submit",
				schema: submitAgentActivityEventsResponseSchema,
				url: buildAgentActivityEventsRoute(input.deviceId)
			});
		},
		submitAgentActivitySessionReconciliation: async (input) => {
			const body = requireValidAgentActivitySessionReconciliationBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Agent Activity Session reconciliation response.",
				method: "PUT",
				operation: "agent_activity.sessions.reconcile",
				schema: submitAgentActivitySessionReconciliationResponseSchema,
				url: buildAgentActivitySessionReconciliationRoute(input.deviceId)
			});
		},
		submitAgentControllerTaskLifecycleEvents: async (input) => {
			const body = requireValidAgentControllerTaskLifecycleEventsBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Agent Controller task lifecycle event response.",
				method: "PUT",
				operation: "agent_controller_task.lifecycle_events.submit",
				schema: submitAgentControllerTaskLifecycleEventsResponseSchema,
				url: buildAgentControllerTaskLifecycleEventsRoute(input.deviceId)
			});
		},
		submitRegistration: async (input) => {
			const body = requireValidRuntimeRegistrationBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Runtime registration response.",
				method: "PUT",
				operation: "runtime.registration.submit",
				schema: submitRuntimeRegistrationResponseSchema,
				url: buildRuntimeRegistrationRoute(input.deviceId)
			});
		},
		submitAgentControllerReports: async (input) => {
			const body = requireValidRuntimeAgentControllerReportsBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Runtime Agent Controller Report response.",
				method: "PUT",
				operation: "runtime.agent_controller_reports.submit",
				schema: submitRuntimeAgentControllerReportsResponseSchema,
				url: buildRuntimeAgentControllerReportsRoute(input.deviceId)
			});
		},
		submitProviderConversationProofs: async (input) => {
			const body = requireValidRuntimeProviderConversationProofsBody(input);
			return await client.requestJson({
				body: JSON.stringify(body),
				headers: { "content-type": "application/json" },
				invalidMessage: "Invalid Provider Conversation Proof response.",
				method: "PUT",
				operation: "runtime.provider_conversation_proofs.submit",
				schema: submitRuntimeProviderConversationProofsResponseSchema,
				url: buildRuntimeProviderConversationProofsRoute(input.deviceId)
			});
		}
	};
};
//#endregion
//#region src/service-connection-evidence/api.ts
function createServiceConnectionEvidenceApi(client) {
	const route = (input) => {
		const target = peopleComputerTargetSchema.parse(input);
		return `/v1/people-computers/${encodeURIComponent(target.deviceId)}/lanes/${encodeURIComponent(target.runtimeLane)}/connection-incidents`;
	};
	return {
		read: async (target) => await client.requestJson({
			method: "GET",
			operation: "computer.connection-incidents.read",
			url: route(target),
			schema: serviceConnectionIncidentsResponseSchema,
			invalidMessage: "Invalid connection history response."
		}),
		report: async (input) => await client.requestJson({
			method: "POST",
			operation: "computer.connection-incidents.report",
			url: route({
				deviceId: input.incident.deviceId,
				runtimeLane: input.incident.runtimeLane
			}),
			body: JSON.stringify(serviceConnectionIncidentReportSchema.parse(input)),
			headers: { "content-type": "application/json" },
			schema: serviceConnectionIncidentReceiptSchema,
			timeoutMs: 1e4,
			invalidMessage: "Invalid connection history receipt."
		})
	};
}
//#endregion
//#region src/space/routes.ts
function buildCreateSpacePath() {
	return "/v1/spaces";
}
function buildSpaceDeletePath(spaceId) {
	return `/v1/spaces/${encodeURIComponent(spaceId)}`;
}
function buildSpaceStatusPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "status");
}
function buildSpaceEntryResolutionPath(input) {
	const path = buildSpaceRoutePath(input.spaceId, "entry-resolution");
	const searchParams = new URLSearchParams();
	if (input.signalId !== void 0) searchParams.set("signalId", input.signalId);
	if (input.threadRootSignalId !== void 0) searchParams.set("threadRootSignalId", input.threadRootSignalId);
	const queryString = searchParams.toString();
	return queryString ? `${path}?${queryString}` : path;
}
function buildSpaceMetaPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "meta");
}
function buildSpaceAccessModePath(spaceId) {
	return buildSpaceRoutePath(spaceId, "access-mode");
}
function buildSpaceBootstrapPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "bootstrap");
}
function buildSpaceMembersPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "members");
}
function buildSpaceRemoveMembersPath(spaceId) {
	return `${buildSpaceMembersPath(spaceId)}/remove`;
}
function buildSpaceMemberDirectoryPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "member-directory");
}
function buildSpaceIdentityDirectoryPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "identity-directory");
}
function buildSpaceViewerMembershipPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "viewer-membership");
}
function buildSpaceJoinPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "join");
}
function buildSpaceCenterAgentMemberPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "center-agent");
}
function buildSpaceOrganizationDirectoryProfilesPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "organization-directory-profiles");
}
function buildSpaceLeavePath(spaceId) {
	return buildSpaceRoutePath(spaceId, "leave");
}
function buildSpaceSignalsPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "signals");
}
function buildSpaceAttachmentsPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "attachments");
}
function buildSpaceFilesPath(spaceId, query) {
	const path = buildSpaceRoutePath(spaceId, "files");
	const searchParams = new URLSearchParams();
	if (query?.parentId) searchParams.set("parentId", query.parentId);
	if (query?.view && query.view !== "active") searchParams.set("view", query.view);
	if (query?.origin && query.origin !== "artifact") searchParams.set("origin", query.origin);
	const queryString = searchParams.toString();
	return queryString ? `${path}?${queryString}` : path;
}
function buildSpaceFileFoldersPath(spaceId) {
	return `${buildSpaceFilesPath(spaceId)}/folders`;
}
function buildSpaceFileEntryPath(spaceId, entryId) {
	return `${buildSpaceFilesPath(spaceId)}/${encodeURIComponent(entryId)}`;
}
function buildSpaceFileRevisionsPath(spaceId, fileId) {
	return `${buildSpaceFileEntryPath(spaceId, fileId)}/revisions`;
}
function buildSpaceFileRestorePath(spaceId, entryId) {
	return `${buildSpaceFileEntryPath(spaceId, entryId)}/restore`;
}
function buildSpaceFileRevisionRestorePath(spaceId, fileId, revision) {
	return `${buildSpaceFileRevisionsPath(spaceId, fileId)}/${revision}/restore`;
}
function buildSpaceFileContentPath(spaceId, fileId, query) {
	const path = `${buildSpaceFileEntryPath(spaceId, fileId)}/content`;
	const searchParams = new URLSearchParams();
	if (query?.revision !== void 0) searchParams.set("revision", String(query.revision));
	if (query?.baseRevision !== void 0) searchParams.set("baseRevision", String(query.baseRevision));
	if (query?.clientMutationId !== void 0) searchParams.set("clientMutationId", query.clientMutationId);
	const queryString = searchParams.toString();
	return queryString ? `${path}?${queryString}` : path;
}
function buildSpaceFileUploadPath(input) {
	const searchParams = new URLSearchParams({
		clientMutationId: input.clientMutationId,
		name: input.name
	});
	if (input.parentId) searchParams.set("parentId", input.parentId);
	if (input.origin) searchParams.set("origin", input.origin);
	return `${buildSpaceFilesPath(input.spaceId)}?${searchParams.toString()}`;
}
function buildSpaceComposerUploadPath(input) {
	const path = `${buildSpaceRoutePath(input.spaceId, "composer-uploads")}/${encodeURIComponent(input.uploadId)}`;
	if (input.name === void 0) return path;
	return `${path}?${new URLSearchParams({ name: input.name }).toString()}`;
}
function buildSpaceComposerUploadPublishPath(input) {
	return `${buildSpaceComposerUploadPath(input)}/publish`;
}
function buildSpaceAttachmentUploadPath(spaceId, query) {
	const path = buildSpaceAttachmentsPath(spaceId);
	const searchParams = new URLSearchParams();
	if (query?.fileName !== void 0) searchParams.set("fileName", query.fileName);
	if (query?.width !== void 0) searchParams.set("width", String(query.width));
	if (query?.height !== void 0) searchParams.set("height", String(query.height));
	const queryString = searchParams.toString();
	return queryString.length > 0 ? `${path}?${queryString}` : path;
}
function buildSpaceUpdatesPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "updates");
}
function buildSpaceWakeProgressPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "wake-progress");
}
function buildActiveSpaceWakeProgressPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "active-wake-progress");
}
function buildSpaceWakeStopPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "wake-stop");
}
function buildSpaceExecutionRecoveryPath(spaceId, dispatchId) {
	return `${buildSpaceRoutePath(spaceId, "dispatches")}/${encodeURIComponent(dispatchId)}/recovery`;
}
function buildSpaceAgentInteractionResponsePath(spaceId) {
	return buildSpaceRoutePath(spaceId, "agent-interactions/respond");
}
function buildSpaceWakeTraceWaterfallPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "wake-trace-waterfall");
}
function buildSpaceMessageDetailsPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "message-details");
}
function buildSpaceDiagnosticReportsPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "diagnostic-reports");
}
function buildSpaceThreadsPath(spaceId) {
	return buildSpaceRoutePath(spaceId, "threads");
}
function buildSpaceThreadPath(spaceId, threadId) {
	return `${buildSpaceThreadsPath(spaceId)}/${encodeURIComponent(threadId)}`;
}
function buildSpaceThreadEventsPath(spaceId, threadId) {
	return `${buildSpaceThreadPath(spaceId, threadId)}/events`;
}
function buildSpaceThreadSignalsPath(spaceId, threadId, query) {
	const path = `${buildSpaceThreadPath(spaceId, threadId)}/signals`;
	if (!query) return path;
	const searchParams = new URLSearchParams();
	if (query.afterSignalId && query.limit !== void 0) {
		searchParams.set("afterSignalId", query.afterSignalId);
		searchParams.set("limit", String(query.limit));
	}
	if (query.includeWakeContinuation) searchParams.set("includeWakeContinuation", String(query.includeWakeContinuation));
	return `${path}?${searchParams.toString()}`;
}
function buildSpaceRoutePath(spaceId, segment) {
	return `/v1/spaces/${encodeURIComponent(spaceId)}/${segment}`;
}
//#endregion
//#region src/space/access-mode.ts
async function setSpaceAccessMode(client, input) {
	const parsedBody = setSpaceAccessModeBodySchema.safeParse({
		accessMode: input.accessMode,
		...input.allowGuests === void 0 ? {} : { allowGuests: input.allowGuests },
		...input.linkJoinPolicy === void 0 ? {} : { linkJoinPolicy: input.linkJoinPolicy },
		...input.password === void 0 ? {} : { password: input.password },
		...input.visibility === void 0 ? {} : { visibility: input.visibility }
	});
	if (!parsedBody.success) throw new Error(parsedBody.error.issues[0]?.message ?? "invalid space access mode request body");
	return await client.requestJson({
		url: buildSpaceAccessModePath(input.spaceId),
		operation: "space.access_mode.set",
		method: "PUT",
		headers: { "content-type": "application/json" },
		body: JSON.stringify(parsedBody.data),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		schema: spaceAccessModeStateSchema,
		invalidMessage: "invalid space access mode response"
	});
}
//#endregion
//#region src/space/agent-interaction.ts
async function respondToSpaceAgentInteraction(client, input) {
	const parsedBody = respondToSpaceAgentInteractionBodySchema.safeParse(input.body);
	if (!parsedBody.success) throw new Error(parsedBody.error.issues[0]?.message ?? "invalid agent interaction response");
	return await client.requestJson({
		body: JSON.stringify(parsedBody.data),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid agent interaction result",
		method: "POST",
		operation: "space.agent_interaction.respond",
		requestContext: input.requestContext,
		schema: respondToSpaceAgentInteractionResponseSchema,
		signal: input.signal,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		timeoutMs: input.timeoutMs,
		url: buildSpaceAgentInteractionResponsePath(input.spaceId)
	});
}
//#endregion
//#region src/space/add-members.ts
async function addSpaceMembers(client, input) {
	const parsedBody = postSpaceMembersBodySchema.safeParse({ memberProfileIds: input.memberProfileIds });
	if (!parsedBody.success) throw new Error(parsedBody.error.issues[0]?.message ?? "invalid add space members request body");
	return await client.requestJson({
		url: buildSpaceMembersPath(input.spaceId),
		operation: "space.members.add",
		method: "POST",
		headers: { "content-type": "application/json" },
		body: JSON.stringify(parsedBody.data),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: postSpaceMembersResponseSchema,
		invalidMessage: "invalid add space members response"
	});
}
//#endregion
//#region src/space/attachments.ts
async function uploadSpaceAttachment(client, input) {
	const mimeType = parseMimeType$1(input.mimeType);
	const body = toRequestBody$1(input.bytes);
	validateAttachmentSize(readRequestBodySize(body));
	const query = parseUploadQuery(input);
	return (await client.requestJson({
		url: buildSpaceAttachmentUploadPath(input.spaceId, query),
		operation: "space.attachment.upload",
		method: "POST",
		headers: { "content-type": mimeType },
		body,
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: uploadSpaceAttachmentResponseSchema,
		invalidMessage: "invalid Space attachment upload response"
	})).attachment;
}
function buildSpaceAttachmentDownloadPath(spaceId, attachmentId) {
	return `${buildSpaceAttachmentsPath(spaceId)}/${encodeURIComponent(attachmentId)}`;
}
function parseMimeType$1(value) {
	const parsed = spaceAttachmentMimeTypeSchema.safeParse(value);
	if (!parsed.success) throw new Error("invalid Space attachment MIME type");
	return parsed.data;
}
function validateAttachmentSize(sizeBytes) {
	if (!spaceAttachmentSizeBytesSchema.safeParse(sizeBytes).success) throw new Error("invalid Space attachment size");
}
function parseUploadQuery(input) {
	const parsed = spaceAttachmentUploadQuerySchema.safeParse({
		...input.fileName === void 0 ? {} : { fileName: input.fileName },
		...input.width === void 0 ? {} : { width: String(input.width) },
		...input.height === void 0 ? {} : { height: String(input.height) }
	});
	if (!parsed.success) throw new Error("invalid Space attachment upload metadata");
	return parsed.data;
}
function toRequestBody$1(bytes) {
	if (bytes instanceof Blob || bytes instanceof ArrayBuffer) return bytes;
	const copy = new Uint8Array(bytes.byteLength);
	copy.set(bytes);
	return copy.buffer;
}
function readRequestBodySize(body) {
	return body instanceof Blob ? body.size : body.byteLength;
}
//#endregion
//#region src/space/access-version.ts
function currentSpaceAccessHeaders() {
	return { [SPACE_ACCESS_VERSION_HEADER]: SPACE_ACCESS_VERSION };
}
//#endregion
//#region src/space/addressing-contract.ts
function currentSpaceAddressingHeaders(contentType) {
	return {
		[AGENT_REPLY_PLACEMENT_HEADER]: "1",
		...contentType ? { "content-type": contentType } : {},
		[OPENMELD_HEADER_SPACE_ADDRESSING_VERSION]: OPENMELD_SPACE_ADDRESSING_VERSION,
		...currentSpaceImageGeometryHeaders()
	};
}
function currentSpaceImageGeometryHeaders() {
	return { [OPENMELD_HEADER_SPACE_IMAGE_GEOMETRY_VERSION]: OPENMELD_SPACE_IMAGE_GEOMETRY_VERSION };
}
function currentSpaceFileHeaders() {
	return {
		[OPENMELD_HEADER_SPACE_FILES_ORIGIN_VERSION]: OPENMELD_SPACE_FILES_ORIGIN_VERSION,
		...currentSpaceImageGeometryHeaders()
	};
}
//#endregion
//#region src/space/signals.ts
const SPACE_HISTORY_SIGNAL_KIND_TO_TYPE = {
	text: "signal.text",
	status: "signal.status",
	system_notice: "signal.system_notice"
};
async function listSpaceSignals(client, input) {
	return await client.requestJson({
		url: buildSpaceSignalsReadPath(input.spaceId, input.query),
		operation: "space.signals.read",
		headers: currentSpaceAddressingHeaders(),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: catchupResponseSchema,
		invalidMessage: "Unexpected response: expected { signals, nextCursor }"
	});
}
async function listSpaceSignalEnvelopes(client, input) {
	const result = await listSpaceSignals(client, input);
	return {
		envelopes: result.signals.flatMap((item) => {
			const envelope = parseEnvelope(item);
			return envelope ? [envelope] : [];
		}),
		nextCursor: result.nextCursor
	};
}
function buildSpaceSignalsReadPath(spaceId, query) {
	const url = new URL(buildSpaceSignalsPath(spaceId), "https://openmeld.local");
	for (const [key, value] of buildSpaceSignalsReadSearchParams(query)) url.searchParams.append(key, value);
	return `${url.pathname}${url.search}`;
}
function buildSpaceSignalsReadSearchParams(query) {
	const searchParams = new URLSearchParams();
	const normalizedQuery = normalizeSpaceSignalsReadQuery(query);
	if (normalizedQuery.afterTs !== null) searchParams.set("afterTs", String(normalizedQuery.afterTs));
	if (normalizedQuery.cursor) searchParams.set("cursor", normalizedQuery.cursor);
	if (normalizedQuery.recent) searchParams.set("recent", "1");
	if (normalizedQuery.includeLimit) searchParams.set("limit", String(normalizedQuery.limit));
	if (normalizedQuery.afterSignalId) searchParams.set("afterSignalId", normalizedQuery.afterSignalId);
	if (normalizedQuery.aroundSignalId) searchParams.set("aroundSignalId", normalizedQuery.aroundSignalId);
	if (normalizedQuery.beforeCount !== null) searchParams.set("beforeCount", String(normalizedQuery.beforeCount));
	if (normalizedQuery.afterCount !== null) searchParams.set("afterCount", String(normalizedQuery.afterCount));
	for (const profileId of normalizedQuery.fromProfileIds) searchParams.append("fromProfileId", profileId);
	for (const kind of normalizedQuery.kinds) searchParams.append("signalType", SPACE_HISTORY_SIGNAL_KIND_TO_TYPE[kind]);
	return searchParams;
}
function normalizeSpaceSignalsReadQuery(query) {
	const afterTs = normalizeOptionalNonNegativeInteger(query?.afterTs);
	const cursor = normalizeOptionalString(query?.cursor);
	const afterSignalId = normalizeOptionalString(query?.afterSignalId);
	const aroundSignalId = normalizeOptionalString(query?.aroundSignalId);
	const beforeCount = normalizeOptionalNonNegativeInteger(query?.beforeCount);
	const afterCount = normalizeOptionalNonNegativeInteger(query?.afterCount);
	const limit = normalizeOptionalNonNegativeInteger(query?.limit);
	const recent = query?.recent === true;
	const fromProfileIds = normalizeUniqueStrings(query?.fromProfileIds ?? []);
	const kinds = normalizeKinds(query?.kinds ?? []);
	const semantics = normalizeListSignalsReadQuerySemantics({
		recentOnly: recent,
		hasExplicitLimit: query?.limit !== void 0,
		limit,
		afterSignalId,
		aroundSignalId,
		beforeCount,
		afterCount
	});
	if ((semantics.afterSignalId || semantics.aroundSignalId) && (afterTs !== null || cursor !== null)) throw new Error("Signal anchors cannot be combined with afterTs or cursor.");
	return {
		afterTs,
		cursor,
		recent: semantics.recentOnly,
		includeLimit: semantics.includeLimit,
		limit: semantics.limit,
		afterSignalId: semantics.afterSignalId,
		aroundSignalId: semantics.aroundSignalId,
		beforeCount: semantics.beforeCount,
		afterCount: semantics.afterCount,
		fromProfileIds,
		kinds
	};
}
function normalizeOptionalString(value) {
	if (typeof value !== "string") return null;
	const normalized = value.trim();
	return normalized.length > 0 ? normalized : null;
}
function normalizeOptionalNonNegativeInteger(value) {
	if (value === void 0) return null;
	if (!Number.isSafeInteger(value) || value < 0) throw new Error("history query counts must be non-negative integers");
	return value;
}
function normalizeUniqueStrings(values) {
	const deduped = /* @__PURE__ */ new Set();
	for (const value of values) {
		const normalized = normalizeOptionalString(value);
		if (normalized) deduped.add(normalized);
	}
	return [...deduped];
}
function normalizeKinds(values) {
	const deduped = /* @__PURE__ */ new Set();
	for (const value of values) deduped.add(value);
	return [...deduped];
}
//#endregion
//#region src/space/bootstrap.ts
async function getSpaceBootstrap(client, input) {
	return await client.requestJson({
		url: buildSpaceBootstrapReadPath(input.spaceId, input.historyQuery, input.includeAgentStreamPresence, input.includeAgentReadiness),
		operation: "space.bootstrap.read",
		headers: {
			...currentSpaceAddressingHeaders(),
			...currentSpaceAccessHeaders()
		},
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: spaceBootstrapResponseSchema,
		invalidMessage: "invalid space bootstrap response"
	});
}
function buildSpaceBootstrapReadPath(spaceId, historyQuery, includeAgentStreamPresence, includeAgentReadiness) {
	const url = new URL(buildSpaceBootstrapPath(spaceId), "https://openmeld.local");
	for (const [key, value] of buildSpaceSignalsReadSearchParams(historyQuery)) url.searchParams.append(key, value);
	if (includeAgentStreamPresence === true) url.searchParams.set("includeAgentStreamPresence", "true");
	if (includeAgentReadiness === false) url.searchParams.set("includeAgentReadiness", "false");
	return `${url.pathname}${url.search}`;
}
//#endregion
//#region src/space/create.ts
async function createSpace(client, input) {
	const body = buildCreateSpaceBody(input);
	const parsedBody = createSpaceBodySchema.safeParse(body);
	if (!parsedBody.success) throw new Error(parsedBody.error.issues[0]?.message ?? "invalid create space request body");
	return await client.requestJson({
		url: buildCreateSpacePath(),
		operation: "space.create",
		method: "POST",
		headers: {
			...currentSpaceAccessHeaders(),
			"content-type": "application/json"
		},
		body: JSON.stringify(parsedBody.data),
		requestContext: input.requestContext,
		schema: createSpaceResponseSchema,
		invalidMessage: "invalid create space response"
	});
}
function buildCreateSpaceBody(input) {
	return {
		...input.name === void 0 ? {} : { name: input.name },
		...input.purpose === void 0 ? {} : { purpose: input.purpose },
		...input.guide === void 0 ? {} : { guide: input.guide },
		...input.visibility === void 0 ? {} : { visibility: input.visibility },
		...input.accessMode === void 0 ? {} : { accessMode: input.accessMode },
		...input.password === void 0 ? {} : { password: input.password }
	};
}
//#endregion
//#region src/space/delete.ts
async function deleteSpace(client, input) {
	return await client.requestJson({
		url: buildSpaceDeletePath(input.spaceId),
		operation: "space.delete",
		method: "DELETE",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: deleteSpaceResponseSchema,
		invalidMessage: "invalid delete space response"
	});
}
//#endregion
//#region src/space/diagnostic-report.ts
async function createSpaceDiagnosticReport(client, input) {
	const parsedBody = createSpaceDiagnosticReportBodySchema.safeParse(input.body);
	if (!parsedBody.success) {
		const firstIssue = parsedBody.error.issues[0];
		throw new Error(firstIssue?.message ?? "invalid diagnostic report request body");
	}
	return await client.requestJson({
		url: buildSpaceDiagnosticReportsPath(input.spaceId),
		operation: "space.diagnostic_report.create",
		method: "POST",
		headers: { "content-type": "application/json" },
		body: JSON.stringify(parsedBody.data),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: createSpaceDiagnosticReportResponseSchema,
		invalidMessage: "invalid diagnostic report response"
	});
}
//#endregion
//#region src/space/entry-resolution.ts
async function resolveSpaceEntry(client, input) {
	return await client.requestJson({
		url: buildSpaceEntryResolutionPath(input),
		operation: "space.entry.resolve",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: getSpaceEntryResolutionResponseSchema,
		invalidMessage: "invalid Space entry resolution response"
	});
}
//#endregion
//#region src/space/execution-recovery.ts
async function inspectSpaceExecutionRecovery(client, input) {
	return await client.requestJson({
		invalidMessage: "invalid execution recovery response",
		method: "GET",
		operation: "space.execution_recovery.inspect",
		requestContext: input.requestContext,
		schema: inspectExecutionRecoveryResponseSchema,
		signal: input.signal,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		timeoutMs: input.timeoutMs,
		url: buildSpaceExecutionRecoveryPath(input.spaceId, input.dispatchId)
	});
}
async function executeSpaceExecutionRecovery(client, input) {
	const parsed = executeExecutionRecoveryBodySchema.safeParse(input.body);
	if (!parsed.success || parsed.data.expectedIdentity.dispatchId !== input.dispatchId) throw new Error(parsed.success ? "dispatchId does not match expected execution identity" : parsed.error.issues[0]?.message ?? "invalid execution recovery request");
	return await client.requestJson({
		body: JSON.stringify(parsed.data),
		headers: { "content-type": "application/json" },
		invalidMessage: "invalid execution recovery command response",
		method: "POST",
		operation: "space.execution_recovery.execute",
		requestContext: input.requestContext,
		schema: executeExecutionRecoveryResponseSchema,
		signal: input.signal,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		timeoutMs: input.timeoutMs,
		url: buildSpaceExecutionRecoveryPath(input.spaceId, input.dispatchId)
	});
}
//#endregion
//#region src/space/file-update-settings.ts
async function spaceFileUpdateSettings(client, input) {
	const read = input.command.action === "read";
	return await client.requestJson({
		url: `/v1/spaces/${encodeURIComponent(input.spaceId)}/files/${encodeURIComponent(input.fileId)}/update-settings`,
		method: read ? "GET" : "PATCH",
		operation: "space.files.update-settings",
		headers: { "content-type": "application/json" },
		...read ? {} : { body: JSON.stringify(input.command) },
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: spaceFileUpdateSettingsSchema,
		invalidMessage: "Invalid file update settings response"
	});
}
//#endregion
//#region src/space/files.ts
function bodySize(body) {
	return body instanceof Blob ? body.size : body.byteLength;
}
async function mutationUploadId(mutation) {
	const hash = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(mutation));
	const hex = Array.from(new Uint8Array(hash), (b) => b.toString(16).padStart(2, "0")).join("");
	return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-4${hex.slice(13, 16)}-a${hex.slice(17, 20)}-${hex.slice(20, 32)}`;
}
async function uploadMultipart(client, input, target, uploadId) {
	const body = toRequestBody(input.bytes);
	const blob = body instanceof Blob ? body : new Blob([body]);
	const url = `/v1/spaces/${encodeURIComponent(input.spaceId)}/file-uploads/${uploadId}`;
	const request = async (command, part) => {
		return await retryUploadRequest(input.signal, () => client.requestJson({
			...requestFields$1(input),
			url: command.action === "part" ? `${url}?part=${command.partNumber}` : url,
			method: "POST",
			operation: "space.files.upload",
			headers: {
				...currentSpaceFileHeaders(),
				"content-type": part ? "application/octet-stream" : "application/json"
			},
			body: part ?? JSON.stringify(command),
			schema: spaceFileUploadResponseSchema,
			invalidMessage: "Invalid file upload response."
		}));
	};
	const partDigests = [];
	for (let offset = 0; offset < blob.size; offset += SPACE_FILE_UPLOAD_PART_BYTES) {
		input.signal?.throwIfAborted();
		const hash = await crypto.subtle.digest("SHA-256", await blob.slice(offset, offset + SPACE_FILE_UPLOAD_PART_BYTES).arrayBuffer());
		partDigests.push(Array.from(new Uint8Array(hash), (b) => b.toString(16).padStart(2, "0")).join(""));
	}
	let session = await request({
		action: "start",
		metadata: {
			target,
			mimeType: input.mimeType,
			sizeBytes: blob.size,
			partDigests
		}
	});
	if (session.file || session.upload) return session;
	input.onProgress?.(session.parts.reduce((n, p) => n + p.sizeBytes, 0), blob.size);
	for (let start = 0, number = 1; start < blob.size; start += session.partSizeBytes, number++) {
		if (session.parts.some((p) => p.partNumber === number)) continue;
		session = await request({
			action: "part",
			partNumber: number
		}, blob.slice(start, start + session.partSizeBytes));
		input.onProgress?.(session.parts.reduce((n, p) => n + p.sizeBytes, 0), blob.size);
	}
	return await request({ action: "complete" });
}
async function retryUploadRequest(signal, request) {
	for (let attempt = 0;; attempt++) try {
		signal?.throwIfAborted();
		return await request();
	} catch (error) {
		const status = error && typeof error === "object" && "status" in error ? error.status : void 0;
		if (signal?.aborted || attempt >= 2 || typeof status === "number" && status < 500 && status !== 429) throw error;
		await new Promise((resolve) => setTimeout(resolve, 250 * 2 ** attempt));
	}
}
async function listSpaceFiles(client, input) {
	const response = await client.requestJson({
		...requestFields$1(input),
		url: buildSpaceFilesPath(input.spaceId, input.query),
		operation: "space.files.list",
		schema: listSpaceFilesResponseSchema,
		invalidMessage: "invalid Space Files list response"
	});
	const requestedView = input.query?.view ?? "active";
	if (response.view !== requestedView) throw new OpenMeldApiClientInvalidResponseError({
		message: `Space Files returned the ${response.view} view while the ${requestedView} view was requested.`,
		operation: "space.files.list",
		status: 200,
		rawBody: JSON.stringify(response),
		schemaIssue: {
			message: "The response view did not match the requested view.",
			path: ["view"]
		}
	});
	const requestedOrigin = input.query?.origin ?? "artifact";
	if (response.origin !== requestedOrigin) throw new OpenMeldApiClientInvalidResponseError({
		message: `Space Files returned the ${response.origin} filter while ${requestedOrigin} was requested.`,
		operation: "space.files.list",
		status: 200,
		rawBody: JSON.stringify(response),
		schemaIssue: {
			message: "The response origin filter did not match the request.",
			path: ["origin"]
		}
	});
	return response;
}
async function getSpaceFile(client, input) {
	return await client.requestJson({
		...requestFields$1(input),
		url: buildSpaceFileEntryPath(input.spaceId, input.fileId),
		operation: "space.files.get",
		schema: getSpaceFileResponseSchema,
		invalidMessage: "invalid Space file response"
	});
}
async function listSpaceFileRevisions(client, input) {
	return await client.requestJson({
		...requestFields$1(input),
		url: buildSpaceFileRevisionsPath(input.spaceId, input.fileId),
		operation: "space.files.revisions.list",
		schema: listSpaceFileRevisionsResponseSchema,
		invalidMessage: "invalid Space file revisions response"
	});
}
async function createSpaceFolder(client, input) {
	return await client.requestJson({
		...requestFields$1(input),
		url: buildSpaceFileFoldersPath(input.spaceId),
		operation: "space.files.folder.create",
		method: "POST",
		headers: {
			...currentSpaceFileHeaders(),
			"content-type": "application/json"
		},
		body: JSON.stringify(input.body),
		schema: createSpaceFolderResponseSchema,
		invalidMessage: "invalid Space folder create response"
	});
}
async function updateSpaceFileEntry(client, input) {
	return (await client.requestJson({
		...requestFields$1(input),
		url: buildSpaceFileEntryPath(input.spaceId, input.entryId),
		operation: "space.files.entry.update",
		method: "PATCH",
		headers: {
			...currentSpaceFileHeaders(),
			"content-type": "application/json"
		},
		body: JSON.stringify(input.body),
		schema: updateSpaceFileEntryResponseSchema,
		invalidMessage: "invalid Space file update response"
	})).entry;
}
async function trashSpaceFileEntry(client, input) {
	return await client.requestJson({
		...requestFields$1(input),
		url: buildSpaceFileEntryPath(input.spaceId, input.entryId),
		operation: "space.files.entry.trash",
		method: "DELETE",
		headers: {
			...currentSpaceFileHeaders(),
			"content-type": "application/json"
		},
		body: JSON.stringify({ clientMutationId: input.clientMutationId }),
		schema: trashSpaceFileEntryResponseSchema,
		invalidMessage: "invalid Space file trash response"
	});
}
async function restoreSpaceFileEntry(client, input) {
	return (await client.requestJson({
		...requestFields$1(input),
		url: buildSpaceFileRestorePath(input.spaceId, input.entryId),
		operation: "space.files.entry.restore",
		method: "POST",
		headers: {
			...currentSpaceFileHeaders(),
			"content-type": "application/json"
		},
		body: JSON.stringify({ clientMutationId: input.clientMutationId }),
		schema: restoreSpaceFileEntryResponseSchema,
		invalidMessage: "invalid Space file restore response"
	})).entry;
}
async function restoreSpaceFileRevision(client, input) {
	return (await client.requestJson({
		...requestFields$1(input),
		url: buildSpaceFileRevisionRestorePath(input.spaceId, input.fileId, input.revision),
		operation: "space.files.revision.restore",
		method: "POST",
		headers: {
			...currentSpaceFileHeaders(),
			"content-type": "application/json"
		},
		body: JSON.stringify({
			baseRevision: input.baseRevision,
			clientMutationId: input.clientMutationId
		}),
		schema: restoreSpaceFileRevisionResponseSchema,
		invalidMessage: "invalid Space file revision restore response"
	})).file;
}
async function uploadSpaceFile(client, input) {
	const body = toRequestBody(input.bytes);
	validateSize(body);
	const mimeType = parseMimeType(input.mimeType);
	if (bodySize(body) > SPACE_FILE_RAW_UPLOAD_MAX_BYTES) {
		const response = await uploadMultipart(client, input, {
			kind: "file",
			clientMutationId: input.clientMutationId,
			name: input.name,
			origin: input.origin,
			parentId: input.parentId ?? null
		}, await mutationUploadId(input.clientMutationId));
		if (!response.file) throw new Error("The upload did not return a file.");
		return response.file;
	}
	return (await client.requestJson({
		...requestFields$1(input),
		url: buildSpaceFileUploadPath(input),
		operation: "space.files.upload",
		method: "POST",
		headers: {
			...currentSpaceFileHeaders(),
			"content-type": mimeType
		},
		body,
		schema: uploadSpaceFileResponseSchema,
		invalidMessage: "invalid Space file upload response"
	})).file;
}
async function stageSpaceComposerUpload(client, input) {
	const body = toRequestBody(input.bytes);
	validateSize(body);
	const mimeType = parseMimeType(input.mimeType);
	if (bodySize(body) > SPACE_FILE_RAW_UPLOAD_MAX_BYTES) {
		const response = await uploadMultipart(client, input, {
			kind: "composer",
			name: input.name
		}, input.uploadId);
		if (!response.upload) throw new Error("The upload did not return a staged file.");
		return response.upload;
	}
	return (await client.requestJson({
		...requestFields$1(input),
		body,
		headers: {
			...currentSpaceFileHeaders(),
			"content-type": mimeType
		},
		invalidMessage: "invalid Space Composer upload response",
		method: "PUT",
		operation: "space.composer_uploads.stage",
		schema: stageSpaceComposerUploadResponseSchema,
		url: buildSpaceComposerUploadPath(input)
	})).upload;
}
async function publishSpaceComposerUpload(client, input) {
	return (await client.requestJson({
		...requestFields$1(input),
		body: JSON.stringify({ clientMutationId: input.clientMutationId }),
		headers: {
			...currentSpaceFileHeaders(),
			"content-type": "application/json"
		},
		invalidMessage: "invalid Space Composer upload publication response",
		method: "POST",
		operation: "space.composer_uploads.publish",
		schema: publishSpaceComposerUploadResponseSchema,
		url: buildSpaceComposerUploadPublishPath(input)
	})).file;
}
async function discardSpaceComposerUpload(client, input) {
	await client.requestJson({
		...requestFields$1(input),
		invalidMessage: "invalid Space Composer upload discard response",
		method: "DELETE",
		operation: "space.composer_uploads.discard",
		schema: discardSpaceComposerUploadResponseSchema,
		url: buildSpaceComposerUploadPath(input)
	});
}
async function updateSpaceFileContent(client, input) {
	const body = toRequestBody(input.bytes);
	validateSize(body);
	const mimeType = parseMimeType(input.mimeType);
	if (bodySize(body) > SPACE_FILE_RAW_UPLOAD_MAX_BYTES) {
		const response = await uploadMultipart(client, input, {
			kind: "revision",
			clientMutationId: input.clientMutationId,
			fileId: input.fileId,
			baseRevision: input.baseRevision
		}, await mutationUploadId(input.clientMutationId));
		if (!response.file) throw new Error("The upload did not return a file.");
		return response.file;
	}
	return (await client.requestJson({
		...requestFields$1(input),
		url: buildSpaceFileContentPath(input.spaceId, input.fileId, {
			baseRevision: input.baseRevision,
			clientMutationId: input.clientMutationId
		}),
		operation: "space.files.content.update",
		method: "PUT",
		headers: {
			...currentSpaceFileHeaders(),
			"content-type": mimeType
		},
		body,
		schema: uploadSpaceFileResponseSchema,
		invalidMessage: "invalid Space file content update response"
	})).file;
}
async function downloadSpaceFileContent(client, input) {
	const content = await streamSpaceFileContent(client, input);
	return {
		...content,
		bytes: await new Response(content.bytes).arrayBuffer()
	};
}
async function streamSpaceFileContent(client, input) {
	const response = await client.requestResponse({
		...requestFields$1(input),
		url: buildSpaceFileContentPath(input.spaceId, input.fileId, { revision: input.revision }),
		operation: "space.files.content.download"
	});
	if (!response.ok) {
		await readApiClientTextResponse({ response });
		throw new Error("Space file download failed.");
	}
	const mimeType = parseMimeType(response.headers.get("content-type") ?? "application/octet-stream");
	const revision = Number(response.headers.get("x-openmeld-file-revision"));
	if (!(Number.isInteger(revision) && revision > 0)) throw new Error("invalid Space file revision response header");
	if (!response.body) throw new Error("Space file download has no body.");
	return {
		bytes: response.body,
		mimeType,
		revision
	};
}
function requestFields$1(input) {
	return {
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		headers: currentSpaceFileHeaders(),
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword }
	};
}
function parseMimeType(value) {
	const parsed = spaceFileMimeTypeSchema.safeParse(value);
	if (!parsed.success) throw new Error("invalid Space file MIME type");
	return parsed.data;
}
function toRequestBody(bytes) {
	if (bytes instanceof Blob || bytes instanceof ArrayBuffer) return bytes;
	const copy = new Uint8Array(bytes.byteLength);
	copy.set(bytes);
	return copy.buffer;
}
function validateSize(body) {
	if ((body instanceof Blob ? body.size : body.byteLength) > SPACE_FILE_MAX_SIZE_BYTES) throw new Error("Space files must be 250 MiB or smaller");
}
//#endregion
//#region src/space/history-navigation.ts
function getSpaceHistoryNavigation(client, input) {
	const query = new URLSearchParams();
	if (input.startSignalId) query.set("startSignalId", input.startSignalId);
	if (input.endSignalId) query.set("endSignalId", input.endSignalId);
	return client.requestJson({
		url: `/v1/spaces/${encodeURIComponent(input.spaceId)}/history-navigation?${query}`,
		operation: "space.history_navigation.read",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: spaceHistoryNavigationSchema,
		invalidMessage: "Invalid history navigation response"
	});
}
//#endregion
//#region src/space/leave.ts
async function leaveSpace(client, input) {
	return await client.requestJson({
		url: buildSpaceLeavePath(input.spaceId),
		operation: "space.leave",
		method: "POST",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: leaveSpaceResponseSchema,
		invalidMessage: "invalid leave space response"
	});
}
//#endregion
//#region src/space/link-previews.ts
function getSpaceLinkPreviews(client, input) {
	const query = new URLSearchParams({ signalId: input.signalId });
	return client.requestJson({
		url: `/v1/spaces/${encodeURIComponent(input.spaceId)}/link-previews?${query}`,
		operation: "space.link_previews",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs ?? 3e4,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: getSpaceLinkPreviewsResponseSchema,
		invalidMessage: "Invalid link preview response."
	});
}
//#endregion
//#region src/space/members.ts
async function getSpaceMembersSnapshot(client, input) {
	return await client.requestJson({
		url: buildSpaceMembersPath(input.spaceId),
		operation: "space.members.list",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: spaceMembersSnapshotSchema,
		invalidMessage: "invalid space members response"
	});
}
async function getSpaceMemberDirectory(client, input) {
	return await client.requestJson({
		url: buildSpaceMemberDirectoryPath(input.spaceId),
		operation: "space.member_directory.read",
		headers: currentSpaceAddressingHeaders(),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: spaceMemberDirectorySchema,
		invalidMessage: "invalid space member directory response"
	});
}
async function getSpaceIdentityDirectory(client, input) {
	return await client.requestJson({
		url: buildSpaceIdentityDirectoryPath(input.spaceId),
		operation: "space.identity_directory.read",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: spaceIdentityDirectorySchema,
		invalidMessage: "invalid space identity directory response"
	});
}
async function getSpaceViewerMembership(client, input) {
	return await client.requestJson({
		url: buildSpaceViewerMembershipPath(input.spaceId),
		operation: "space.viewer_membership.read",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: spaceViewerMembershipResponseSchema,
		invalidMessage: "invalid space viewer membership response"
	});
}
async function joinSpace(client, input) {
	return await client.requestJson({
		url: buildSpaceJoinPath(input.spaceId),
		operation: "space.join",
		method: "POST",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: postSpaceMembersResponseSchema,
		invalidMessage: "invalid space join response"
	});
}
/** @deprecated Use addOrganizationDirectoryProfilesToSpace instead. */
async function addCenterAgentToSpace(client, input) {
	const parsedBody = addCenterAgentToSpaceBodySchema.safeParse({ expectedCenterAgentProfileId: input.expectedCenterAgentProfileId });
	if (!parsedBody.success) throw new Error(parsedBody.error.issues[0]?.message ?? "invalid add Center Agent Space member request body");
	return await client.requestJson({
		url: buildSpaceCenterAgentMemberPath(input.spaceId),
		operation: "space.center_agent_member.add",
		method: "POST",
		headers: { "content-type": "application/json" },
		body: JSON.stringify(parsedBody.data),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: postSpaceMembersResponseSchema,
		invalidMessage: "invalid add Center Agent Space member response"
	});
}
async function addOrganizationDirectoryProfilesToSpace(client, input) {
	const parsedBody = addOrganizationDirectoryProfilesToSpaceBodySchema.safeParse({
		directoryProfileIds: input.directoryProfileIds,
		...input.expectedCenterAgentProfileId === void 0 ? {} : { expectedCenterAgentProfileId: input.expectedCenterAgentProfileId }
	});
	if (!parsedBody.success) throw new Error(parsedBody.error.issues[0]?.message ?? "invalid Organization Directory Space member request body");
	return await client.requestJson({
		url: buildSpaceOrganizationDirectoryProfilesPath(input.spaceId),
		operation: "space.organization_directory_profiles.add",
		method: "POST",
		headers: { "content-type": "application/json" },
		body: JSON.stringify(parsedBody.data),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: postSpaceMembersResponseSchema,
		invalidMessage: "invalid Organization Directory Space member response"
	});
}
//#endregion
//#region src/space/message-details.ts
async function getSpaceMessageDetails(client, input) {
	const searchParams = new URLSearchParams();
	searchParams.set("signalId", input.signalId);
	return await client.requestJson({
		url: `${buildSpaceMessageDetailsPath(input.spaceId)}?${searchParams.toString()}`,
		operation: "space.message_details",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: getSpaceMessageDetailsResponseSchema,
		invalidMessage: "invalid message details response"
	});
}
//#endregion
//#region src/space/message-reactions.ts
function getSpaceMessageReactions(client, input) {
	const query = new URLSearchParams({ signalId: input.signalId });
	if (input.emoji) query.set("emoji", input.emoji);
	if (input.afterProfileId) query.set("afterProfileId", input.afterProfileId);
	return client.requestJson({
		...requestFields(input),
		url: `${path(input.spaceId)}?${query}`,
		method: "GET",
		operation: "space.reactions.read"
	});
}
function setSpaceMessageReaction(client, input) {
	return client.requestJson({
		...requestFields(input),
		url: path(input.spaceId),
		method: "PUT",
		operation: "space.reactions.set",
		headers: { "content-type": "application/json" },
		body: JSON.stringify({
			signalId: input.signalId,
			emoji: input.emoji,
			active: input.active
		})
	});
}
function path(spaceId) {
	return `/v1/spaces/${encodeURIComponent(spaceId)}/message-reactions`;
}
function requestFields(input) {
	return {
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: getSpaceMessageReactionsResponseSchema,
		invalidMessage: "Invalid message reactions response"
	};
}
//#endregion
//#region src/space/meta.ts
async function updateSpaceMeta(client, input) {
	const parsedBody = patchSpaceMetaBodySchema.safeParse({
		...input.ownership === void 0 ? {} : { ownership: input.ownership },
		...input.allowGuests === void 0 ? {} : { allowGuests: input.allowGuests },
		...input.visibility === void 0 ? {} : { visibility: input.visibility },
		...input.name === void 0 ? {} : { name: input.name },
		...input.purpose === void 0 ? {} : { purpose: input.purpose },
		...input.guide === void 0 ? {} : { guide: input.guide }
	});
	if (!parsedBody.success) throw new Error(parsedBody.error.issues[0]?.message ?? "invalid Space metadata request body");
	return await client.requestJson({
		url: buildSpaceMetaPath(input.spaceId),
		operation: "space.meta.update",
		method: "PATCH",
		headers: {
			...currentSpaceAccessHeaders(),
			"content-type": "application/json"
		},
		body: JSON.stringify(parsedBody.data),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: patchSpaceMetaResponseSchema,
		invalidMessage: "invalid Space metadata response"
	});
}
//#endregion
//#region src/space/mutate-message.ts
function mutateSpaceMessage(client, input) {
	return client.requestJson({
		url: `/v1/spaces/${encodeURIComponent(input.spaceId)}/messages/${encodeURIComponent(input.signalId)}`,
		operation: "space.message.change",
		method: "POST",
		headers: {
			"content-type": "application/json",
			...currentSpaceImageGeometryHeaders()
		},
		body: JSON.stringify(spaceMessageMutationBodySchema.parse(input.body)),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: spaceMessageMutationResponseSchema,
		invalidMessage: "Invalid message change response"
	});
}
//#endregion
//#region src/space/post-normal-message.ts
async function postSpaceNormalMessage(client, input) {
	const body = buildPostNormalMessageBody(input);
	const parsedBody = postNormalMessageBodySchema.safeParse(body);
	if (!parsedBody.success) {
		const firstIssue = parsedBody.error.issues[0];
		throw new Error(firstIssue?.message ?? "invalid normal message request body");
	}
	return await client.requestJson({
		url: buildSpaceSignalsPath(input.spaceId),
		operation: "space.send",
		method: "POST",
		headers: currentSpaceAddressingHeaders("application/json"),
		body: JSON.stringify(toLegacySpaceImageGeometryWireValue(toCompatibleSpaceAddressingRequestWireValue(parsedBody.data))),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: postNormalMessageResponseSchema,
		invalidMessage: "invalid send response"
	});
}
function buildPostNormalMessageBody(input) {
	return {
		text: input.text,
		...input.meta?.workHandoff ? { workHandoffVersion: 1 } : {},
		...input.deviceWait ? { deviceWait: input.deviceWait } : {},
		...input.contextSelection ? { contextSelection: input.contextSelection } : {},
		...input.attachments ? { attachments: input.attachments } : {},
		...input.files ? { files: input.files } : {},
		...input.messageEnvelope ? { messageEnvelope: input.messageEnvelope } : {},
		...input.replyTo ? { replyTo: input.replyTo } : {},
		...input.meta ? { meta: input.meta } : {}
	};
}
//#endregion
//#region src/space/remove-members.ts
async function removeSpaceMembers(client, input) {
	const parsedBody = removeSpaceMembersBodySchema.safeParse({ memberProfileIds: input.memberProfileIds });
	if (!parsedBody.success) throw new Error(parsedBody.error.issues[0]?.message ?? "invalid remove space members request body");
	return await client.requestJson({
		url: buildSpaceRemoveMembersPath(input.spaceId),
		operation: "space.members.remove",
		method: "POST",
		headers: { "content-type": "application/json" },
		body: JSON.stringify(parsedBody.data),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: removeSpaceMembersResponseSchema,
		invalidMessage: "invalid remove space members response"
	});
}
//#endregion
//#region src/space/status.ts
async function getSpaceStatus(client, input) {
	return await client.requestJson({
		url: buildSpaceStatusPath(input.spaceId),
		operation: "space.status.read",
		headers: currentSpaceAccessHeaders(),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: getSpaceStatusResponseSchema,
		invalidMessage: "invalid space status response"
	});
}
//#endregion
//#region src/space/tasks.ts
async function listSpaceTasks(client, input) {
	const query = input.phase ? `?phase=${encodeURIComponent(input.phase)}` : "";
	return await client.requestJson({
		url: `/v1/spaces/${encodeURIComponent(input.spaceId)}/tasks${query}`,
		operation: "space.tasks.list",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		spacePassword: input.spacePassword,
		schema: listSpaceTasksResponseSchema,
		invalidMessage: "Invalid Space Tasks response."
	});
}
async function getSpaceTask(client, input) {
	return await client.requestJson({
		url: `/v1/spaces/${encodeURIComponent(input.spaceId)}/tasks/${encodeURIComponent(input.taskId)}`,
		operation: "space.tasks.get",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		spacePassword: input.spacePassword,
		schema: spaceTaskResponseSchema,
		invalidMessage: "Invalid Space Task response."
	});
}
async function createSpaceTask(client, input) {
	return await client.requestJson({
		url: `/v1/spaces/${encodeURIComponent(input.spaceId)}/tasks`,
		operation: "space.tasks.create",
		method: "POST",
		headers: { "content-type": "application/json" },
		body: JSON.stringify(createSpaceTaskBodySchema.parse(input.body)),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		spacePassword: input.spacePassword,
		schema: spaceTaskMutationReceiptSchema,
		invalidMessage: "Invalid Space Task creation response."
	});
}
async function mutateSpaceTask(client, input) {
	return await client.requestJson({
		url: `/v1/spaces/${encodeURIComponent(input.spaceId)}/tasks/${encodeURIComponent(input.taskId)}`,
		operation: "space.tasks.mutate",
		method: "PATCH",
		headers: { "content-type": "application/json" },
		body: JSON.stringify(mutateSpaceTaskBodySchema.parse(input.body)),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		spacePassword: input.spacePassword,
		schema: spaceTaskMutationReceiptSchema,
		invalidMessage: "Invalid Space Task change response."
	});
}
//#endregion
//#region src/space/threads.ts
async function createSpaceThread(client, input) {
	const body = {
		rootSignalId: input.rootSignalId,
		clientMutationId: input.clientMutationId
	};
	const parsedBody = createSpaceThreadBodySchema.safeParse(body);
	if (!parsedBody.success) throw new Error(parsedBody.error.issues[0]?.message ?? "Invalid thread request");
	return await client.requestJson({
		url: buildSpaceThreadsPath(input.spaceId),
		operation: "space.thread.create",
		method: "POST",
		headers: currentSpaceAddressingHeaders("application/json"),
		body: JSON.stringify(parsedBody.data),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: createSpaceThreadResponseSchema,
		invalidMessage: "invalid thread create response"
	});
}
async function listSpaceThreads(client, input) {
	return await client.requestJson({
		url: buildSpaceThreadsPath(input.spaceId),
		operation: "space.thread.list",
		method: "GET",
		headers: currentSpaceAddressingHeaders(),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: listSpaceThreadsResponseSchema,
		invalidMessage: "invalid thread list response"
	});
}
async function getSpaceThread(client, input) {
	return await client.requestJson({
		url: buildSpaceThreadPath(input.spaceId, input.threadId),
		operation: "space.thread.get",
		method: "GET",
		headers: currentSpaceAddressingHeaders(),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: getSpaceThreadResponseSchema,
		invalidMessage: "invalid thread detail response"
	});
}
async function listSpaceThreadEvents(client, input) {
	return await client.requestJson({
		url: buildSpaceThreadEventsPath(input.spaceId, input.threadId),
		operation: "space.thread.events",
		method: "GET",
		headers: currentSpaceAddressingHeaders(),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: listSpaceThreadEventsResponseSchema,
		invalidMessage: "invalid thread events response"
	});
}
async function listSpaceThreadSignals(client, input) {
	const parsedQuery = listSpaceThreadSignalsQuerySchema.safeParse({
		includeWakeContinuation: input.includeWakeContinuation,
		afterSignalId: input.afterSignalId,
		limit: input.limit
	});
	if (!parsedQuery.success) throw new Error(parsedQuery.error.issues[0]?.message ?? "Invalid bounded thread signals query");
	return await client.requestJson({
		url: buildSpaceThreadSignalsPath(input.spaceId, input.threadId, parsedQuery.data.afterSignalId || parsedQuery.data.includeWakeContinuation ? parsedQuery.data : void 0),
		operation: "space.thread.signals",
		method: "GET",
		headers: currentSpaceAddressingHeaders(),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: listSpaceThreadSignalsResponseSchema,
		invalidMessage: "invalid thread signals response"
	});
}
async function postSpaceThreadSignal(client, input) {
	const parsedBody = postSpaceThreadSignalBodySchema.safeParse(input.body);
	if (!parsedBody.success) throw new Error(parsedBody.error.issues[0]?.message ?? "Invalid thread message");
	return await client.requestJson({
		url: buildSpaceThreadSignalsPath(input.spaceId, input.threadId),
		operation: "space.thread.send",
		method: "POST",
		headers: currentSpaceAddressingHeaders("application/json"),
		body: JSON.stringify(toLegacySpaceImageGeometryWireValue(toCompatibleSpaceAddressingRequestWireValue(parsedBody.data))),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: postSpaceThreadSignalResponseSchema,
		invalidMessage: "invalid thread message response"
	});
}
//#endregion
//#region src/space/updates.ts
async function getSpaceUpdates(client, input) {
	return await client.requestJson({
		url: buildSpaceUpdatesReadPath({
			afterSignalId: input.afterSignalId,
			limit: input.limit,
			spaceId: input.spaceId
		}),
		operation: "space.updates.read",
		headers: currentSpaceAddressingHeaders(),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: getSpaceUpdatesResponseSchema,
		invalidMessage: "Unexpected response: expected { signals }"
	});
}
function buildSpaceUpdatesReadPath(input) {
	const afterSignalId = input.afterSignalId.trim();
	if (afterSignalId.length === 0) throw new Error("afterSignalId is required");
	if (!Number.isSafeInteger(input.limit) || input.limit <= 0) throw new Error("limit must be a positive integer");
	const url = new URL(buildSpaceUpdatesPath(input.spaceId), "https://openmeld.local");
	url.searchParams.set("afterSignalId", afterSignalId);
	url.searchParams.set("limit", String(input.limit));
	return `${url.pathname}${url.search}`;
}
//#endregion
//#region src/space/wake-progress.ts
async function getSpaceWakeProgress(client, input) {
	const searchParams = new URLSearchParams();
	searchParams.set("clientMessageId", input.clientMessageId);
	if (input.includePreviewText === true) searchParams.set("includePreviewText", "true");
	if (input.includeSourceContext === true) searchParams.set("includeSourceContext", "true");
	if (input.includeTiming === true) searchParams.set("includeTiming", "true");
	if (input.includeWaitReason === true) searchParams.set("includeWaitReason", "true");
	if (input.includeDeviceWait === true) searchParams.set("includeDeviceWait", "true");
	if (input.includeWakeStopEligibility === true) searchParams.set("includeWakeStopEligibility", "true");
	if (input.targetProfileId) searchParams.set("targetProfileId", input.targetProfileId);
	const query = searchParams.toString();
	return await client.requestJson({
		url: `${buildSpaceWakeProgressPath(input.spaceId)}?${query}`,
		operation: "space.wake_progress",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: getSpaceWakeProgressResponseSchema,
		invalidMessage: "invalid wake progress response"
	});
}
async function getActiveSpaceWakeProgress(client, input) {
	const searchParams = new URLSearchParams();
	if (input.includePageInfo === true) searchParams.set("includePageInfo", "true");
	if (input.includePreviewText === true) searchParams.set("includePreviewText", "true");
	if (input.includeSourceContext === true) searchParams.set("includeSourceContext", "true");
	if (input.includeTiming === true) searchParams.set("includeTiming", "true");
	if (input.includeWaitReason === true) searchParams.set("includeWaitReason", "true");
	if (input.includeDeviceWait === true) searchParams.set("includeDeviceWait", "true");
	if (input.includeWakeStopEligibility === true) searchParams.set("includeWakeStopEligibility", "true");
	if (input.targetProfileId) searchParams.set("targetProfileId", input.targetProfileId);
	if (input.sourceProfileId) searchParams.set("sourceProfileId", input.sourceProfileId);
	const query = searchParams.toString();
	const response = await client.requestJson({
		url: query ? `${buildActiveSpaceWakeProgressPath(input.spaceId)}?${query}` : buildActiveSpaceWakeProgressPath(input.spaceId),
		operation: "space.active_wake_progress",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: getActiveSpaceWakeProgressResponseSchema,
		invalidMessage: "invalid active wake progress response"
	});
	if (input.sourceProfileId && response.query.sourceProfileId !== input.sourceProfileId) throw new OpenMeldApiClientInvalidResponseError({
		message: "Active Wake progress did not confirm the requested source profile filter.",
		operation: "space.active_wake_progress",
		status: 200,
		rawBody: JSON.stringify(response),
		schemaIssue: {
			message: "The response source profile did not match the requested source profile.",
			path: ["query", "sourceProfileId"]
		}
	});
	if (input.includePageInfo === true && response.pageInfo === void 0) throw new OpenMeldApiClientInvalidResponseError({
		message: "Active Wake progress did not confirm the requested page information.",
		operation: "space.active_wake_progress",
		status: 200,
		rawBody: JSON.stringify(response),
		schemaIssue: {
			message: "The response did not include the requested page information.",
			path: ["pageInfo"]
		}
	});
	return response;
}
//#endregion
//#region src/space/wake-stop.ts
async function postSpaceWakeStop(client, input) {
	const parsedBody = postSpaceWakeStopBodySchema.safeParse(input.body);
	if (!parsedBody.success) {
		const firstIssue = parsedBody.error.issues[0];
		throw new Error(firstIssue?.message ?? "invalid Wake Stop request body");
	}
	return await client.requestJson({
		url: buildSpaceWakeStopPath(input.spaceId),
		operation: "space.wake_stop",
		method: "POST",
		headers: { "content-type": "application/json" },
		body: JSON.stringify(parsedBody.data),
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: postSpaceWakeStopResponseSchema,
		invalidMessage: "invalid Wake Stop response"
	});
}
//#endregion
//#region src/space/wake-trace-waterfall.ts
async function getSpaceWakeTraceWaterfall(client, input) {
	const searchParams = new URLSearchParams();
	if (input.clientMessageId) searchParams.set("clientMessageId", input.clientMessageId);
	if (input.sourceSignalId) searchParams.set("sourceSignalId", input.sourceSignalId);
	if (input.targetProfileId) searchParams.set("targetProfileId", input.targetProfileId);
	const query = searchParams.toString();
	return await client.requestJson({
		url: `${buildSpaceWakeTraceWaterfallPath(input.spaceId)}?${query}`,
		operation: "space.wake_trace_waterfall",
		method: "GET",
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		...input.spacePassword === void 0 ? {} : { spacePassword: input.spacePassword },
		schema: getSpaceWakeTraceWaterfallResponseSchema,
		invalidMessage: "invalid wake trace waterfall response"
	});
}
//#endregion
//#region src/space/api.ts
const createSpaceApi = (client) => {
	return {
		createSpace: async (input) => await createSpace(client, input),
		deleteSpace: async (input) => await deleteSpace(client, input),
		joinSpace: async (input) => await joinSpace(client, input),
		addMembers: async (input) => await addSpaceMembers(client, input),
		addCenterAgentToSpace: async (input) => await addCenterAgentToSpace(client, input),
		addOrganizationDirectoryProfilesToSpace: async (input) => await addOrganizationDirectoryProfilesToSpace(client, input),
		uploadAttachment: async (input) => await uploadSpaceAttachment(client, input),
		listFiles: async (input) => await listSpaceFiles(client, input),
		getFile: async (input) => await getSpaceFile(client, input),
		fileUpdateSettings: async (input) => await spaceFileUpdateSettings(client, input),
		listFileRevisions: async (input) => await listSpaceFileRevisions(client, input),
		createFolder: async (input) => await createSpaceFolder(client, input),
		updateFileEntry: async (input) => await updateSpaceFileEntry(client, input),
		trashFileEntry: async (input) => await trashSpaceFileEntry(client, input),
		restoreFileEntry: async (input) => await restoreSpaceFileEntry(client, input),
		restoreFileRevision: async (input) => await restoreSpaceFileRevision(client, input),
		uploadFile: async (input) => await uploadSpaceFile(client, input),
		stageComposerUpload: async (input) => await stageSpaceComposerUpload(client, input),
		publishComposerUpload: async (input) => await publishSpaceComposerUpload(client, input),
		discardComposerUpload: async (input) => await discardSpaceComposerUpload(client, input),
		updateFileContent: async (input) => await updateSpaceFileContent(client, input),
		downloadFileContent: async (input) => await downloadSpaceFileContent(client, input),
		streamFileContent: async (input) => await streamSpaceFileContent(client, input),
		removeMembers: async (input) => await removeSpaceMembers(client, input),
		setAccessMode: async (input) => await setSpaceAccessMode(client, input),
		updateMeta: async (input) => await updateSpaceMeta(client, input),
		leaveSpace: async (input) => await leaveSpace(client, input),
		getBootstrap: async (input) => await getSpaceBootstrap(client, input),
		getStatus: async (input) => await getSpaceStatus(client, input),
		resolveEntry: async (input) => await resolveSpaceEntry(client, input),
		getMembersSnapshot: async (input) => await getSpaceMembersSnapshot(client, input),
		getMemberDirectory: async (input) => await getSpaceMemberDirectory(client, input),
		getHistoryNavigation: async (input) => await getSpaceHistoryNavigation(client, input),
		getIdentityDirectory: async (input) => await getSpaceIdentityDirectory(client, input),
		getViewerMembership: async (input) => await getSpaceViewerMembership(client, input),
		listSignals: async (input) => await listSpaceSignals(client, input),
		listSignalEnvelopes: async (input) => await listSpaceSignalEnvelopes(client, input),
		getUpdates: async (input) => await getSpaceUpdates(client, input),
		getActiveWakeProgress: async (input) => await getActiveSpaceWakeProgress(client, input),
		postWakeStop: async (input) => await postSpaceWakeStop(client, input),
		inspectExecutionRecovery: async (input) => await inspectSpaceExecutionRecovery(client, input),
		executeExecutionRecovery: async (input) => await executeSpaceExecutionRecovery(client, input),
		respondToAgentInteraction: async (input) => await respondToSpaceAgentInteraction(client, input),
		getWakeProgress: async (input) => await getSpaceWakeProgress(client, input),
		getWakeTraceWaterfall: async (input) => await getSpaceWakeTraceWaterfall(client, input),
		getMessageReactions: (input) => getSpaceMessageReactions(client, input),
		setMessageReaction: (input) => setSpaceMessageReaction(client, input),
		getMessageDetails: async (input) => await getSpaceMessageDetails(client, input),
		getLinkPreviews: (input) => getSpaceLinkPreviews(client, input),
		createDiagnosticReport: async (input) => await createSpaceDiagnosticReport(client, input),
		mutateMessage: (input) => mutateSpaceMessage(client, input),
		postNormalMessage: async (input) => await postSpaceNormalMessage(client, input),
		createThread: async (input) => await createSpaceThread(client, input),
		listThreads: async (input) => await listSpaceThreads(client, input),
		getThread: async (input) => await getSpaceThread(client, input),
		listThreadEvents: async (input) => await listSpaceThreadEvents(client, input),
		listThreadSignals: async (input) => await listSpaceThreadSignals(client, input),
		postThreadSignal: async (input) => await postSpaceThreadSignal(client, input),
		listTasks: async (input) => await listSpaceTasks(client, input),
		getTask: async (input) => await getSpaceTask(client, input),
		createTask: async (input) => await createSpaceTask(client, input),
		mutateTask: async (input) => await mutateSpaceTask(client, input)
	};
};
//#endregion
//#region src/space/work-handoff.ts
/** One existing Message/Thread publication owns both the handoff and its Wake. */
async function postSpaceWorkHandoff(api, input) {
	const handoff = spaceWorkHandoffSchema.parse(input.handoff);
	const text = `${handoff.work.goal}\n\n${handoff.work.nextSteps}`;
	const files = handoff.files.map((file) => ({
		fileId: file.fileId,
		revision: file.revision,
		name: file.relativePath.split("/").at(-1) ?? file.relativePath,
		mimeType: "application/octet-stream",
		sizeBytes: 0
	}));
	const messageEnvelope = {
		text,
		activationTargets: [input.targetProfileId],
		mentionTargets: [],
		referenceTargets: []
	};
	const contextSelection = {
		mode: "new",
		access: "space_context",
		workspace: "isolated"
	};
	const common = {
		spaceId: input.spaceId,
		requestContext: input.requestContext,
		spacePassword: input.spacePassword,
		signal: input.signal,
		timeoutMs: input.timeoutMs
	};
	if (input.threadId) return await api.postThreadSignal({
		...common,
		threadId: input.threadId,
		body: {
			text,
			files,
			messageEnvelope,
			contextSelection,
			clientMessageId: input.clientMessageId,
			workHandoff: handoff
		}
	});
	return await api.postNormalMessage({
		...common,
		text,
		files,
		messageEnvelope,
		contextSelection,
		meta: {
			clientMessageId: input.clientMessageId,
			workHandoff: handoff
		}
	});
}
//#endregion
//#region src/space/message-pins.ts
async function readOrUpdateSpaceFilePins(client, input) {
	return await client.requestJson({
		url: `/v1/spaces/${encodeURIComponent(input.spaceId)}/file-pins`,
		operation: "space.file-pins",
		method: input.mutation ? "PATCH" : "GET",
		headers: currentSpaceFileHeaders(),
		...input.mutation ? {
			headers: {
				"content-type": "application/json",
				...currentSpaceFileHeaders()
			},
			body: JSON.stringify(spaceFilePinMutationSchema.parse(input.mutation))
		} : {},
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		spacePassword: input.spacePassword,
		schema: spaceFilePinsResponseSchema,
		invalidMessage: "Invalid pinned files response."
	});
}
async function readOrUpdateSpaceMessagePins(client, input) {
	return await client.requestJson({
		url: `/v1/spaces/${encodeURIComponent(input.spaceId)}/message-pins`,
		operation: "space.message-pins",
		method: input.mutation ? "PATCH" : "GET",
		...input.mutation ? {
			headers: { "content-type": "application/json" },
			body: JSON.stringify(spaceMessagePinMutationSchema.parse(input.mutation))
		} : {},
		requestContext: input.requestContext,
		signal: input.signal,
		timeoutMs: input.timeoutMs,
		spacePassword: input.spacePassword,
		schema: spaceMessagePinsResponseSchema,
		invalidMessage: "Invalid pinned messages response."
	});
}
//#endregion
//#region src/transport.ts
function createFetchTransport(input) {
	const defaultTimeoutMs = normalizeOptionalTimeoutMs(input.defaultTimeoutMs);
	const fetchImpl = input.fetch;
	return async function fetchTransport(request) {
		const timeoutMs = normalizeOptionalTimeoutMs(request.timeoutMs) ?? defaultTimeoutMs;
		const timeoutSignal = timeoutMs === void 0 ? null : AbortSignal.timeout(timeoutMs);
		const signals = [request.init?.signal, timeoutSignal].filter((signal) => signal != null);
		const signal = signals.length > 1 ? AbortSignal.any(signals) : signals[0];
		try {
			return await fetchImpl(request.url, {
				...request.init,
				signal
			});
		} catch (error) {
			if (timeoutSignal?.aborted && timeoutMs !== void 0) throw createTimeoutError({
				operation: request.operation,
				timeoutMs,
				cause: error
			});
			if (shouldWrapNetworkRequestError(error)) throw createNetworkRequestError({
				operation: request.operation,
				url: request.url,
				cause: error
			});
			throw error;
		}
	};
}
function createTimeoutError(input) {
	const error = new Error(`${input.operation} request timed out after ${input.timeoutMs}ms`, { cause: input.cause });
	error.code = "network.timeout";
	return error;
}
function createNetworkRequestError(input) {
	const error = new Error(`${input.operation} request could not reach ${describeRequestTarget(input.url)} (${toErrorMessage(input.cause)})`, { cause: input.cause });
	error.code = "network.request_failed";
	return error;
}
function normalizeOptionalTimeoutMs(value) {
	if (value === void 0) return;
	if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) throw new Error("timeoutMs must be a finite positive number");
	return Math.trunc(value);
}
function describeRequestTarget(url) {
	try {
		return new URL(url).origin;
	} catch {
		return url;
	}
}
function toErrorMessage(error) {
	if (error instanceof Error) {
		const message = error.message.trim();
		return message.length > 0 ? message : "request failed";
	}
	const message = String(error ?? "").trim();
	return message.length > 0 ? message : "request failed";
}
function shouldWrapNetworkRequestError(error) {
	if (error instanceof TypeError) return true;
	const message = toErrorMessage(error).toLowerCase();
	return message.includes("fetch failed") || message.includes("failed to fetch") || message.includes("network request failed");
}
//#endregion
export { OpenMeldApiClientHttpError, OpenMeldApiClientInvalidResponseError, buildAccountSpaceActiveWakeSummaryPath, buildAccountSpaceIndexPath, buildAgentActivitySessionsPath, buildAgentActivitySnapshotPath, buildAgentActivityStatsPath, buildAgentProfileCreationApprovalPreferencePath, buildAgentProfileCreationDefaultsPath, buildAgentProfileCreationRequestCancelPath, buildAgentProfileCreationRequestDecisionPath, buildAgentProfileCreationRequestRetryPath, buildAgentProfileCreationRequestsPath, buildAgentProfileWorkRecoveryRoute, buildCenterAgentAuditJournalPath, buildCenterAgentDesignationPath, buildCenterAgentDirectMessageSpacePath, buildCenterAgentInboxReadThroughPath, buildCenterAgentInboxSummaryPath, buildCenterAgentMemberResearchPath, buildCenterAgentOperatingStatePath, buildCenterAgentProfilePath, buildCenterAgentSessionPath, buildCenterAgentSessionsPath, buildComputerFileAccessReadPath, buildComputerFileAccessUpdatePath, buildCurrentAgentProfileSessionRoute, buildCurrentOrganizationCenterAgentMemoryWipeSelfPath, buildCurrentOrganizationComputersPath, buildCurrentOrganizationDirectoryPath, buildCurrentOrganizationFeedbackReportingPolicyPath, buildCurrentOrganizationInformationProtectionPath, buildCurrentOrganizationLogoPath, buildCurrentOrganizationMemberOpenMeldServiceStatusesPath, buildCurrentOrganizationMessageChannelPath, buildCurrentOrganizationMessageChannelRegistrationPath, buildCurrentOrganizationMessageChannelRegistrationPollPath, buildCurrentOrganizationMessageChannelRegistrationsPath, buildCurrentOrganizationMessageChannelSetupRequestsPath, buildCurrentOrganizationMessageChannelsPath, buildCurrentOrganizationSpacesPath, buildCurrentOrganizationSpacesWithMemberCountsPath, buildDirectMessageConversionPath, buildDirectMessageSpacePath, buildFeedbackIssueSubmissionPath, buildInboxItemDismissPath, buildInboxItemPath, buildInboxItemReadPath, buildInboxMarkAllReadPath, buildInboxPath, buildInboxPreferencesPath, buildInboxSummaryPath, buildLocalFolderPickerPath, buildLocalProjectControlPath, buildModelCatalogPath, buildOrganizationDocumentApproveDraftPath, buildOrganizationDocumentDiscardDraftPath, buildOrganizationDocumentPath, buildOrganizationDocumentsPath, buildOrganizationSkillEnabledPath, buildOrganizationSkillGitHubImportPath, buildOrganizationSkillGitHubPreviewPath, buildOrganizationSkillMaintainersPath, buildOrganizationSkillPath, buildOrganizationSkillsPath, buildOrganizationUsageOverviewPath, buildProfileRoute, buildProfileSpaceHistoryListPath, buildProfileSpaceHistoryStatusPath, buildProfileSpaceHistoryUpsertPath, buildProjectPath, buildProjectsPath, buildRoutinePath, buildRoutinePausePath, buildRoutineResumePath, buildRoutineRunsPath, buildRoutineTargetSpacesPath, buildRoutinesPath, buildSpaceAttachmentDownloadPath, buildSpaceBootstrapReadPath, buildSpaceInboxReadThroughPath, buildSpaceInboxSummaryPath, buildSpaceInboxUnreadTargetsPath, createAccountSpaceIndexApi, createAgentActivityApi, createAgentProfileBindingApi, createAgentProfileExecutionModeApi, createAgentProfileWorkRecoveryApi, createCenterAgentApi, createComputerAuthorizationGrant, createComputerFileAccessApi, createConfigApi, createCurrentDeviceApi, createDirectMessageApi, createFeedbackApi, createFetchTransport, createInboxApi, createLocalFolderPickerApi, createLocalProjectControlApi, createLocalRuntimeExpectedRoutesApi, createOpenMeldApiClient, createOrganizationApi, createOrganizationDocumentsApi, createOrganizationSkillsApi, createOrganizationUsageApi, createPluginsApi, createPrepareReadinessApi, createProfileSpaceHistoryApi, createProfilesApi, createProjectsApi, createReasoningStreamApi, createRoutinesApi, createRuntimeReportingApi, createServiceConnectionEvidenceApi, createSpaceApi, createSpaceFolder, createSpaceTask, downloadSpaceFileContent, getModelCatalog, getSpaceFile, getSpaceTask, inboxMessageNotificationSpaceId, isInboxItemInOrganizationScope, isInboxItemVisibleConversation, isInboxNotificationEligible, listSpaceFileRevisions, listSpaceFiles, listSpaceTasks, mutateSpaceTask, normalizeApiBaseUrl, postSpaceWorkHandoff, publicSpaceUrls, readAccountOrganizationContext, readAccountSession, readCliRelease, readOrUpdateSpaceFilePins, readOrUpdateSpaceMessagePins, resolveAccountSpaceIndexGatewayHost, resolveProfileSpaceHistoryGatewayHost, setSpaceAccessMode, toStructuredApiClientFailure, trashSpaceFileEntry, updateSpaceFileContent, updateSpaceFileEntry, updateSpaceMeta, uploadSpaceAttachment, uploadSpaceFile };

//# sourceMappingURL=index.js.map